import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";

function Home() {
  const [toggle, setTg] = useState();
  const [activeSection, setActiveSection] = useState("");
  const sectionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const topOffset = sectionRef.current.getBoundingClientRect().top;
      setIsSticky(window.pageYOffset > topOffset);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const sections = document.querySelectorAll("section");

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 350; // adjust 50 to the height of your fixed header
        const sectionBottom = sectionTop + section.offsetHeight;

        if (
          currentScrollPos >= sectionTop &&
          currentScrollPos < sectionBottom
        ) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Load YouTube Iframe Player API
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var videoWrap = document.querySelector(".video-wrap");
    var video = document.querySelector(".video");
    var videoHeight = video.offsetHeight;
    var state;

    function getVideoID() {
      var videoIframe = document.querySelector("iframe");
      var videoURL = videoIframe.getAttribute("src");
      var id = videoURL.split("/")[4].split("?")[0];
      var playerDiv = document.createElement("div");
      playerDiv.setAttribute("id", "player");
      videoIframe.parentNode.insertBefore(playerDiv, videoIframe.nextSibling);
      videoIframe.parentNode.removeChild(videoIframe);
      return id;
    }
    window.onYouTubeIframeAPIReady = () => {
      var videoID = getVideoID();
      const player = new window.YT.Player("player", {
        width: "100%",
        height: "450",
        videoId: videoID,
        events: {
          // onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });

      // function onPlayerReady(event) {
      //   event.target.playVideo();
      // }

      function onPlayerStateChange(event) {
        state = event.target.getPlayerState();
        if (state == 2) {
          video.classList.remove("stuck");
          video.classList.remove("stuck");
        }

        window.addEventListener("scroll", function () {
          var windowScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          var videoBottom = videoHeight + videoWrap.offsetTop;
          if (state == 1) {
            if (windowScrollTop > videoBottom) {
              videoWrap.style.height = videoHeight + "px";
              video.classList.add("stuck");
            } else {
              videoWrap.style.height = "auto";
              video.classList.remove("stuck");
            }
          }
        });
      }
    };
  }, []);

  return (
    <div>
      <title>Data Analytics Course Online (2023)</title>
      <meta
        name="description"
        content="Data analysis includes the accurate jobs of cleaning, transforming, and managing raw data, with the ultimate purpose of revealing important insights that enable businesses to make informed decisions. This critical activity helps businesses obtain deeper insights into their client base, improve product development, evaluate the efficiency of advertising initiatives, and a lot more."
      />
      <link
        rel="canonical"
        href="https://logicmojo.com/dataanalytics-course/"
      />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Data Analytics Course Online (2023)" />
      <meta
        property="og:description"
        content="Data analysis includes the accurate jobs of cleaning, transforming, and managing raw data, with the ultimate purpose of revealing important insights that enable businesses to make informed decisions. This critical activity helps businesses obtain deeper insights into their client base, improve product development, evaluate the efficiency of advertising initiatives, and a lot more."
      />
      <meta
        property="og:url"
        content="https://logicmojo.com/dataanalytics-course"
      />
      <meta property="og:site_name" content="Logicmojo" />
      <meta
        property="article:modified_time"
        content="2023-03-17T11:45:44+00:00"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://logicmojo.com/assets/dist/new_pages/images/datas.png"
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="1 minute" />

      <div className="banner-ai">
        <div className="container position-relative">
          <div className="banner-ai-inner">
            <div className="banner-ai-links">
              <ul>
                <li>
                  <Link to="https://logicmojo.com">Home</Link>
                </li>
                <li>
                  <a href="">Data Analytics Course</a>
                </li>
              </ul>
            </div>
            <div className="bestsaller">
              <span>
                <i className="fa fa-star" aria-hidden="true"></i> Bestseller
              </span>
            </div>
            <div className="bestsaller">
              <div className="ratinglink">
                Review 4.5
                <div className="ratingstarfa">
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                </div>
                <a href="#ratingreviews">(6991 Ratings)</a>
              </div>
            </div>
            <div className="banner-ai-text">
              <h1>Become A Certified Data Analyst</h1>
              <p>
                Data analysts are the heroes who gather and dissect data to
                solve real-world problems. To launch your exciting career as a
                data analyst, start with entry-level positions and keep climbing
                the ladder. Success in this field hinges on acquiring key skills
                like data analysis, statistical know-how, and data
                visualization. At Logicmojo's Data Analyst Course, we're here to
                kickstart your journey, equipping you with the skills you need
                to reach your goals. Join us and unlock your data-driven
                potential!
              </p>
            </div>
            <div className="banner-ai-btngrp">
              <a
                target="_default"
                href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
                className="counsbtn btnstyle002"
              >
                Enroll Now!
              </a>
            </div>
            <div className="banner-ai-experts">
              <p>Become a Certified Data Analyst with OUr Online Course</p>
              <a href="">
                <img alt="" src="assets/images/gramener.png" />
              </a>
              <a href="">
                <img alt="" src="assets/images/actify.png" />
              </a>
              <a href="">
                <img src="assets/images/flipcart.png" alt="" />
              </a>
              <a href="">
                <img src="assets/images/walmart.png" alt="" />
              </a>
              <a href="">
                <img alt="" src="assets/images/zee.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-aistrip">
        <div className="container">
          <ul>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon1.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>60% Average Hike</h5>
                <p>in Job Switch</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon2.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>6 Months</h5>
                <p>Live Classes on Weekend</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon3.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>Real Time Projects</h5>
                <p>Industry Demanded Projects in Portfolio</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon4.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>Placement assistance /Interview Preparation</h5>
                <p>100% Placements</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon5.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>6.5 LPA</h5>
                <p>Average package</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="itfeaturevideorow">
        <div className="container">
          <h2>
            Data Analytics Course to Become Expert <b>Data Analyst</b>
          </h2>
          <br />
          <br />
          {/* <div className="itfeaturevideo">
            <iframe
              loading="lazy"
              src="https://www.youtube.com/embed/MZ6eHbNnngk"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen=""
              width="100%"
              height="450"
              frameBorder="0"
            ></iframe>
          </div> */}

          <div className="video-wrap">
            <div className="video">
              <iframe
                loading="lazy"
                src="https://www.youtube.com/embed/aiqdypMW64I"
                // src="https://www.youtube.com/embed/MZ6eHbNnngk"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                width="40%"
                height="450"
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll!</b>
            </a>
          </div>
        </center>
      </section>

      <section
        className={isSticky ? "fixed-nav sec-navbar" : "sec-navbar"}
        ref={sectionRef}
      >
        <nav className="container d-flex justify-content-between align-items-center">
          <ul>
            <li className={activeSection === "projects" ? "active" : ""}>
              <a href="#projects">Projects</a>
            </li>
            <li className={activeSection === "careeropp" ? "active" : ""}>
              <a
                target="_default"
                href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
              >
                Course Brochure
              </a>
            </li>
            <li className={activeSection === "syllabus" ? "active" : ""}>
              <a href="#syllabus">Syllabus</a>
            </li>
            <li className={activeSection === "syllabus" ? "active" : ""}>
              <a href="#Fee">Fee</a>
            </li>
            <li className={activeSection === "careeropp" ? "active" : ""}>
              <a href="#careeropp">Career Opportunities</a>
            </li>
            <li className={activeSection === "getcertfied" ? "active" : ""}>
              <a href="#getcertfied">Certification</a>
            </li>
            <li className={activeSection === "faqs" ? "active" : ""}>
              <a href="#faqs">FAQs</a>
            </li>
            <li className={activeSection === "ratingreviews" ? "active" : ""}>
              <a href="#ratingreviews">Reviews</a>
            </li>
            <li className={activeSection === "specialisation" ? "active" : ""}>
              <a href="#specialisation">Specialisation</a>
            </li>
          </ul>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="enroll-btn btn btn-danger"
            >
              <b>Enroll Now!</b>
            </a>
          </div>
        </nav>
      </section>

      <section id="careeropp" className="careeroppbg">
        <div className="container">
          <div className="careeroppbg-inner">
            <h2>Jobs related to Data Analytics</h2>
            <br />
            <br />

            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab01">
                  <span>
                    <img src="assets/images/opportunities-icon1.png" alt="" />
                  </span>
                  Business Analyst
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab02">
                  <span>
                    <img src="assets/images/opportunities-icon2.png" alt="" />
                  </span>
                  Financial Analyst
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab03">
                  <span>
                    <img src="assets/images/opportunities-icon3.png" alt="" />
                  </span>
                  Marketing Analyst
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab04">
                  <span>
                    <img src="assets/images/opportunities-icon4.png" alt="" />
                  </span>
                  Data Scientist
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab01" className="tab-pane">
                <div className="careeroppbg-inner-text">
                  <p>
                    A financial analyst assesses financial data to help
                    organizations make informed decisions about investments,
                    budgets, and financial planning. They provide insights into
                    a company's financial health and future prospects.
                  </p>

                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab02" className="tab-pane fade active show">
                <div className="careeroppbg-inner-text">
                  <p>
                    Business analysts bridge the gap between business needs and
                    technology solutions. They analyze processes, gather
                    requirements, and recommend improvements to enhance
                    efficiency and effectiveness within an organization.
                  </p>

                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab03" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p>
                    Marketing analysts focus on evaluating marketing strategies
                    and campaigns. They analyze data related to customer
                    behavior, market trends, and advertising performance to
                    optimize marketing efforts and drive business growth.
                  </p>
                </div>
              </div>
              <div id="tab04" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p>
                    Data scientists leverage data to extract valuable insights
                    and predictions. They use advanced statistical and machine
                    learning techniques to solve complex problems, make
                    data-driven decisions, and develop models for various
                    applications, such as recommendation systems or predictive
                    analytics.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <section id="getcertfied" className="getcertfiedbgnew">
        <div className="container">
          <div className="getcertfiedbgnew-inner">
            <center>
              <h2>Key Features of Data Analytics Cousre</h2>
            </center>
            <br />
            <br />
            <h6>
              The demand for data analysts is surging globally due to a
              significant skills gap. To address this, many are switching to
              data analysis careers. A comprehensive data analytics course
              equips individuals with essential skills. The U.S. BLS predicts a
              remarkable 23% job growth in this field by 2031, well above the
              average. This trend highlights the enduring need for skilled data
              professionals, making a data analytics course a strategic career
              move for those seeking promising opportunities.
            </h6>
            <div className="row">
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-laptop" aria-hidden="true"></i>
                  <h2>Dynamic learning platform</h2>
                  <p>
                    Offers a unique opportunity to assess your tech skills by
                    actively coding in a hands-on environment on CloudLabs,
                    Receive detailed reports on your strengths and weaknesses,
                    empowering you to enhance your expertise.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h2>Detailed curriculum</h2>
                  <p>
                    Comprehensive plan outlining the specific topics, tools, and
                    techniques covered in the course, provides a structured
                    learning path, ensuring students gain in-depth knowledge of
                    data analysis, statistical methods, data visualization, and
                    other critical skills required to excel in the field.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h2>Gateway to a Rewarding Career</h2>
                  <p>
                    Possess the technical skills but also the industry knowledge
                    required to launch your career as a Data analyst,
                    resume-building techniques, interview preparation
                    strategies, and job placement assistance.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-briefcase" aria-hidden="true"></i>
                  <h2>Teamwork Makes the Dream Work</h2>
                  <p>
                    collaboration is key, collaborate with fellow learners on
                    various analytics projects, learn to work in agile teams,
                    handle data versioning with data warehouses, and communicate
                    effectively with your peers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="ourclientbg-new">
        <div className="container">
          <h3>Our Alumni Works at</h3>
          <div className="owl-carousel owl-theme">
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <div className="whymakesnew">
        <div className="container">
          <h2>
            Data Analytics Course <b>Features</b>
          </h2>
          <br></br>
          <div className="row">
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon1.png" alt="" />
                <h4>1-on-1 Dedication</h4>
                <p>
                  Experience personalized learning and growth with live
                  interactive sessions led by industry experts
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon2.png" alt="" />
                <h4> Practical Experience through Real-Time Projects</h4>
                <p>
                  Gain invaluable real-world experience by working on live
                  projects. Switch your domain to Data Analyst with real time
                  projects.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Life Time Access </h4>
                <p>
                  Life Time accessibility of the Content. Get Access of all
                  Recording of All Classes for Download in Slack Channel.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/studyassigment.png" alt="" />
                <h4>30+ Case Studies &amp; Assignments</h4>
                <p>
                  Work on 30+ Case studies ad assignments with 24/7 Assignments
                  support.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/industries.png" alt="" />
                <h4>10+ Industry Relevant Projects</h4>
                <p>
                  Projects enabling them to apply their skills in real-world
                  scenarios.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Tied-up with 50+ Companies</h4>
                <p>
                  Partnerships creating avenues for internships, networking, and
                  potential job opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <div className="specialisation-bg">
        <div className="container">
          <h2>
            Data Analytics  <b>Specialisation Program</b>
          </h2>
          <br></br>
          <h5>
            Below topics and skills can you expect to acquire during an 8-month
            Data Analytics course
          </h5>

          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#tab06">
                Python & Applied Statistics
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab07">
                Machine Learning
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab08">
                Deep Learning TensorFlow
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab09">
                Tableau & Power BI
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab010">
                NLP
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div id="tab06" className="tab-pane active">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Object-oriented programming <br />
                          &amp; in Python
                        </h3>
                        <ul>
                          <li>
                            OOP Terminology (classes, objects, inheritance,
                            polymorphism, encapsulation)
                          </li>
                          <li>
                            constructors and destructors, static methods,
                            overriding
                          </li>
                          <li>super() to call parent methods</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Functional programming in Python</h3>
                        <li>
                          Built-in functions for iterables(map, filter, reduce,
                          etc.)
                        </li>
                        <li>Lambda functions,Closures, Function decorators</li>
                        <li>itertools, functools, operator module etc</li>
                        <li>Exceptional Handling and Regular Expression</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Python Data Structures <br />
                          &amp; Sets, Dictionaries, Namedtuples etc
                        </h3>
                        <li>
                          Basic Operations Indexing, Slicing, and Matrixes
                        </li>
                        <li>
                          List, Tuples, Dictionaries Python Lists, Tuples,
                          Dictionaries
                        </li>
                        <li>Exercises on List, Tuples And Dictionary</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          NumPy, Pandas <br />
                          &amp; Matplotlib, Scikit-learn
                        </h3>
                        <li>
                          Introduction Numpy, Pandas, Matplotlib, Seaborn, Scipy
                        </li>
                        <li>Setting up the development environment</li>
                        <li>NumPy arrays and Data Types</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          TensorFlow, Data Preprocessing <br />
                          &amp; Data visualization
                        </h3>
                        <li>
                          Installing TensorFlow and setting up the development
                          env
                        </li>
                        <li>Data cleaning and transformation</li>
                        <li>Creating subplots and multiple plots</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3> Data Visualization using Matplotlib</h3>
                        <li>Matplotlib and setting up the development env</li>
                        <li>Advanced Plots with Matplotlib</li>
                        <li>
                          Advanced Visualizations: histograms, heatmaps and box
                        </li>
                        <li>Advanced customization with OOI</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Data Analysis Using Pandas</h3>
                        <li>
                          Data structures in Pandas: Series and DataFrames
                        </li>
                        <li>Basic data exploration with Pandas</li>
                        <li>
                          Statistical Analysis &amp; Data visualization with
                          Pandas
                        </li>
                        <li>
                          Reshaping Data &amp; Hierarchical indexing in Pandas
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Fundamentals of Math and Probability</h3>
                        <li>
                          Population, Sample, Mean, Population Distribution
                        </li>
                        <li>Sample Distribution,Mean, Median, Mode</li>
                        <li>Range, Measure of Dispersion, Variance</li>
                        <li>Probability Density function</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Standard, Normal Distribution, Gaussian Distribution
                        </h3>
                        <li>Standard Normal Distribution, Z Score</li>
                        <li>Cumulative Distribution function</li>
                        <li>Pearson Correlation Coefficient</li>
                        <li>Spearman Rank Coefficient, Hypothesis Testing</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                      <div className="coveredrow-left">
                        <span>10</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Q-Q plot, Bernoulli &amp; Binomial Distribution</h3>
                        <li>Q-Q plot, Skewness of Data</li>
                        <li>Discrete, Bernoulli & Continuous Distribution</li>
                        <li>Log normal, Poisson & Pox cox transformation</li>
                        <li>Application of Non Gaussian distribution</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox11">
                      <div className="coveredrow-left">
                        <span>11</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Poisson Distribution &amp; Advanced Statistics</h3>
                        <li>
                          Probability Mass Function and Cumulative Distribution
                        </li>
                        <li>
                          Poisson Approximation to the Binomial Distribution
                        </li>
                        <li>Hypothesis Testing and Statistical Inference</li>
                        <li>Case Study Based on Poisson Distribution</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox12">
                      <div className="coveredrow-left">
                        <span>12</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Pearson Correlation Coefficient &amp; Covariance
                        </h3>
                        <li>
                          Linear regression,Hypothesis testing,Multiple
                          regression
                        </li>
                        <li>
                          Nonlinear regression,Time series analysis,Multivariate
                          analysis
                        </li>
                        <li>
                          Case study of Pearson Correlation Coefficient with
                          examples
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab07" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Machine Learning Introduction</h3>
                        <li>
                          Overview of Machine Learning and its applications
                        </li>
                        <li>
                          Algorithm, Model, Predictor Variable,Response Variable
                        </li>
                        <li>Evaluation Metrics and Techniques</li>
                        <li>
                          Training - Test Split, Steps in Machine Learning
                        </li>
                        <li>
                          Types of Machine Learning (Supervised, Unsupervised,
                          Reinforcement)
                        </li>
                        <li>Data Preprocessing and Feature Engineering</li>
                        <li>
                          Performance Measures (Accuracy, Precision, Recall, F1
                          Score)
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Regression Analysis and Supervised Learning</h3>
                        <li>
                          Overview Regression Analysis & Supervised Learning
                        </li>
                        <li>
                          Regression models: linear, polynomial, logistic, etc
                        </li>
                        <li>Training, Validation, & Test Sets</li>
                        <li>
                          Evaluation metrics: mean squared error (MSE),
                          R-squared etc
                        </li>
                        <li>
                          Linear Regression & Logistic: A Model-Based Approach
                        </li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>Stock Price Prediction using Linear regression</li>
                        <li>Spam mail detector for mailbox</li>
                        <li>
                          Predict car price using py-torch & SVC egression
                        </li>
                        <li>
                          Use logistics regression models to predict wine
                          quality
                        </li>
                        <li>
                          Use logistics regression to predict if loan approved
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Supervised Learning - Classification </h3>
                        <li>Understanding Decision Trees and Naive Bayes</li>
                        <li>Linear classifiers</li>
                        <li>Decision Boundaries</li>
                        <li>K-Nearest Neighbours</li>
                        <li>Random Forest</li>
                        <li>Feature selection in Model building</li>
                        <li>Evaluating over fitting via training/test split</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Credit Card Fraud Detection using Classification
                          algorithms
                        </li>
                        <li>
                          Build model and evaluate water quality using random
                          forest
                        </li>
                        <li>
                          Purchase Prediction of Customer using Random Forest
                        </li>
                        <li>Confusion Matrix of Multi Class Classification</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Unsupervised Learning - Clustering</h3>
                        <li>K-Means Clustering</li>
                        <li>Hierarchical Clustering</li>
                        <li>Mean-Shift Algorithm</li>
                        <li>Principal Component Analysis</li>
                        <li>Independent Component Analysis</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Music recommendation in Spotify using k-means
                          clustering
                        </li>
                        <li>
                          Topic Modelling for Twitter Customer Reviews
                          clustering
                        </li>
                        <li>
                          K-Means Clustering model to determine banknote is
                          authentic
                        </li>
                        <li>
                          Dimension reduction using PCA with clustering Model
                        </li>
                        <li>e-Commerce Products Dataset For Record Linkage</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Unsupervised Learning - Association</h3>
                        <li>Association Rule Learning</li>
                        <li>FP-Growth Algorithm</li>
                        <li>
                          Anomaly Detection(Fraud Detection) with Clustering
                        </li>
                        <li>
                          Likeness of Item B Being Purchased after Item A
                          Prediction
                        </li>
                        <li>Frequent Itemsets Evaluation metrics</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Frequent itemset mining using Apriori or FP-growth
                          algorithm
                        </li>
                        <li>
                          Evaluate the performance of the recommendation System
                        </li>
                        <li>
                          K-Means Clustering model to determine banknote is
                          authentic
                        </li>
                        <li>
                          Dimension reduction using PCA with clustering Model
                        </li>
                        <li>e-Commerce Products Dataset For Record Linkage</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Recommendation System </h3>
                        <li>Recommender Systems Overview</li>
                        <li>Collaborative Filtering</li>
                        <li>
                          Understanding Collaborative Filtering and Support
                          Vector
                        </li>
                        <li>
                          Normalizing Co-Occurrence Matrices and Leveraging
                        </li>
                        <li>The Matrix Completion Task</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Build Job recommendation using collaborative filtering
                        </li>
                        <li>
                          Build a travel recommendation system using datasets
                        </li>
                        <li>Build a Dashion Recommendation System</li>
                        <li>
                          Build a news article recommendation system using
                          datasets
                        </li>
                        <li>
                          Build music playlist recommendation using Support
                          Vector
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Reinforced Learning</h3>
                        <li>Introduction To RL</li>
                        <li>Model-Based Reinforcement Learning</li>
                        <li>Open Al</li>
                        <li>Model Predictive Control (MPC)</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Autonomous Driving System can be trained using
                          reinforced
                        </li>
                        <li>Finance industry to develop trading algorithms</li>
                        <li>Build a Dashion Recommendation System</li>
                        <li>
                          Build a news article recommendation system using
                          datasets
                        </li>
                        <li>
                          Build music playlist recommendation using Support
                          Vector
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3> Neural Networks</h3>
                        <li>Introduction to Neural Networks</li>
                        <li>Feedforward Neural Networks</li>
                        <li>Convolutional Neural Networks(CNNs)</li>
                        <li>Recurrent Neural Networks(RNNs)</li>
                        <li>Advanced Topics of Neural Networks</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Image Classification using Convolutional Neural
                          Networks
                        </li>
                        <li>
                          Sentiment Analysis using Recurrent Neural Networks
                        </li>
                        <li>Object Detection using Faster R-CNN</li>
                        <li>
                          Music Generation using Generative Adversarial Networks
                        </li>
                        <li>Game Playing using Deep Reinforcement Learning</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab08" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Deep Learning Overview </h3>
                        <li>What is Deep Learning</li>
                        <li>Machine Learning Vs Deep Learning</li>
                        <li>Tensorflow I Keras I Pytorch In details</li>
                        <li>Overview Caffe and Theano</li>
                        <li>Types of file formats in TensorFlow</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>TensorFlow Classification Examples</h3>
                        <li>Introduction to TensorFlow</li>
                        <li>Installing TensorFlow</li>
                        <li>Simple Computation, Contents and Variables</li>
                        <li>TensorFlow Classification Examples</li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          TensorFlow library to create a text-to-speech-to-text
                        </li>
                        <li>
                          TensorFlow Object Counting API function for tracking
                          vehicle
                        </li>
                        <li>
                          Identifies Different Musical Genres through Sounds
                        </li>
                        <li>
                          Identify customers purchase
                          history,gender,age,interest
                        </li>
                        <li>TensorFlow's Face Recognition Function</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Deep Learning Algorithms </h3>
                        <li>Artificial Neural Networks(ANN)</li>
                        <li>Recurrent Neural Networks(RNN)</li>
                        <li>Convolutional Neural Networks(CNN)</li>
                        <li>Autoencoders and Boltzmann Machine</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>Speech Recognition with Deep Learning</li>
                        <li>
                          Build models with high accuracy Identify Human Face
                        </li>
                        <li>Music Genre Classification using DL</li>
                        <li>Image Classification with CIFAR Dataset</li>
                        <li>ChatBot Learning Human-to-Human Dialogue</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Convolutional Neural Networks (CNN)</h3>
                        <li>Introduction to CNN</li>
                        <li>Convolutional layers</li>
                        <li>Pooling layers</li>
                        <li>Fully Connected Layers</li>
                        <li>Training CNNs</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Recurrent Neural Networks (RNN)</h3>
                        <li>Introduction to RNN</li>
                        <li>Vanishing Gradient Problem</li>
                        <li>Long Short-Term Memory (LSTM) Networks</li>
                        <li>Gated Recurrent Units (GRU)</li>
                        <li>Applications of RNN</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Neural Networks and Deep Learning</h3>
                        <li>
                          Introduction to artificial neural networks (ANN)
                        </li>
                        <li>Backpropagation algorithm</li>
                        <li>Activation functions</li>
                        <li>Loss functions</li>
                        <li>Optimization algorithms</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Generative Adversarial Networks (GANs)</h3>
                        <li>Introduction to GANs</li>
                        <li>Generator and Discriminator Networks</li>
                        <li>Loss functions for GANs</li>
                        <li>Training GANs</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Transfer Learning</h3>
                        <li>Introduction to Transfer Learning</li>
                        <li>Pre-trained models</li>
                        <li>Fine-tuning</li>
                        <li>Applications of Transfer Learning</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced Deep Learning Concepts</h3>
                        <li>Reinforcement Learning</li>
                        <li>Capsule Networks</li>
                        <li>Attention Mechanisms</li>
                        <li>Self-Organizing Maps (SOM)</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab09" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Introduction to Tableau</h3>
                        <li>
                          Installing Tableau and connecting to data sources
                        </li>
                        <li>Creating dashboard pages</li>
                        <li>How to create calculated columns</li>
                        <li>Data cleaning and reshaping</li>
                        <li>Creating a basic visualization</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Visual Analytics</h3>
                        <li>Getting Started With Visual Analytics</li>
                        <li>Sorting and Grouping</li>
                        <li>Working with sets, set action</li>
                        <li>Filters: Ways to filter, Interactive Filters</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Charts and Graphs</h3>
                        <li>Basic charts and Graph Types</li>
                        <li>Customizing Charts and Formatting</li>
                        <li>Interactive Features and actions</li>
                        <li>
                          Advanced chart types (e.g., maps, treemaps, scatter
                          plots)
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Tableau (Advance)</h3>
                        <li>Mapping</li>
                        <li>Coordinate points</li>
                        <li>Plotting Latitude and Longitude</li>
                        <li>Custom Geocoding</li>
                        <li>Polygon Maps</li>
                        <li>WMS and Background Image</li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Case Study</h3>
                        <li>Connecting data source and data cleansing </li>
                        <li>Working with various Charts </li>
                        <li>Deployment of Predictive model in visualization</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Dashboard and Stories</h3>
                        <li>Working in Views with Dashboards and Stories</li>
                        <li>Working with Sheets Fitting Sheets</li>
                        <li>Legends and Quick Filters</li>
                        <li>Tiled and Floating Layouts</li>
                        <li>Floating Objects</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced Chart Types and Analytics</h3>
                        <li>
                          Creating Advanced Chart types (treemaps, heatmaps,
                          etc.)
                        </li>
                        <li>
                          Using statistical functions and analytics (trend
                          lines, forecasting)
                        </li>
                        <li>
                          Creating sets, groups, and bins for data analysis
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Getting Started With Power BI</h3>
                        <li>Installing Power BI Desktop</li>
                        <li>Overview of the Workflow in Power BI Desktop</li>
                        <li>
                          Introducing the Different Views of the Data Mode
                        </li>
                        <li>Query Editor Interface</li>
                        <li>Working on Data Model</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Programming with Power BI</h3>
                        <li>Working with Time Series</li>
                        <li>Understanding aggregation and granularity</li>
                        <li>Filters and Slicers in Power BI Maps</li>
                        <li>Scatterplots and BI Reports</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Connecting Dataset with Power BI</h3>
                        <li>Creating a Customer</li>
                        <li>Segmentation Dashboard</li>
                        <li>Analyzing the Customer</li>
                        <li>Segmentation Dashboard</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                      <div className="coveredrow-left">
                        <span>10</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced features</h3>
                        <li>
                          Creating calculated columns and measures with DAX
                        </li>
                        <li>Using custom visuals</li>
                        <li>
                          Building hierarchical visualizations with drill-downs
                        </li>
                        <li>Creating and using templates</li>
                        <li>
                          Publishing reports and dashboards to the Power BI
                          Service
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="tab010" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Introduction to NLP</h3>
                        <li>Stop Words, Tokenization</li>
                        <li>Text Analytics Vs NLP</li>
                        <li>Bag of Words Model,Word Vectorizer</li>
                        <li>Introduction to Sequential data</li>
                        <li>Text Preprocessing using NLP</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Language Modeling</h3>
                        <li>N-gram models</li>
                        <li>Smoothing techniques</li>
                        <li>Language Model Evaluation</li>
                        <li>Working with maps and geographic data</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Named Entity Recognition and Relation Extraction
                        </h3>
                        <li>Named entity Recognition</li>
                        <li>Relation Extraction</li>
                        <li>
                          Evaluation Metrics for NER and Relation Extraction
                        </li>
                        <li>Context-free Grammars using NLP</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>

                      <div className="coveredrow-right">
                        <h3>NLP Advanced</h3>
                        <li>RNNs and its Mechanisms</li>
                        <li>Vanishing & Exploding gradients in RNNs</li>
                        <li>NLP libraries: NLTK Text blog</li>
                        <li>LSTMs - Long Short-Term Memory</li>
                        <li>Neural Machine Translation</li>
                        <li>
                          Advanced Language Models: Transformers, BERT, XLNet
                        </li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Text summarization using Natural language processing
                        </li>
                        <li>
                          Deeper dive project of Automatic Speech Recognition
                        </li>
                        <li>
                          Newspaper Data Cleaning & Pre-processing using NLP
                        </li>
                        <li>Text Classification using scikit-learn and NLP</li>
                        <li>Hate Speech Detection Model</li>
                        <li>Next Word Prediction Model</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>
      <section id="projects" className="projectsnewbg">
        <div className="container">
          <center>
            <h2>Data Analytics Projects in the Course</h2>
          </center>
          <br></br>
          <h5>
            Projects will be a part of your Certification in Data Analytics
            Training to consolidate your learning. <br />
            It will ensure that you have real-world experience in Data Analytics
            Field.
          </h5>
          <div className="projectsnewbg-practice">
            <ul>
              <li>
                <img src="assets/images/practice-icon.png" alt="" />
                <h3>Practice 20+</h3>
                <p>Essential Tools</p>
              </li>
              <li>
                <img src="assets/images/designed-icon.png" alt="" />
                <h3 style={{ color: "#2aacf6" }}>Designed by</h3>
                <p>Industry Experts</p>
              </li>
              <li>
                <img src="assets/images/get-icon.png" alt="" />
                <h3 style={{ color: "#1fcd71" }}>Get Real-world</h3>
                <p>Experience</p>
              </li>
            </ul>
          </div>

          <div className="projectsnewbg-bottom">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab012">
                  Beginner
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab013">
                  Intermediate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab014">
                  Advance
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab012" className="tab-pane active">
                <div id="products" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        Face Detection is an initiative to create a computer
                        vision model that can automatically detect and locate
                        human faces within images or video frames.The goal of
                        this project is to enable machines to recognize and
                        analyze human faces in various contexts, such as
                        security, entertainment, or social media.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Artificial intelligence-powered chatbot that can
                        communicate with humans in a natural language.project
                        involves designing, developing, and deploying a chatbot
                        that can perform specific tasks or answer questions for
                        users. The chatbot can be used for various purposes,
                        such as customer support, sales, marketing, or personal
                        assistance
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Restaurant revenue prediction project is an initiative
                        to create a machine learning model that can forecast the
                        revenue of a restaurant based on various factors such as
                        customer footfall, menu items, prices, and marketing
                        promotions. The goal of this project is to help
                        restaurant owners make data-driven decisions to increase
                        their revenue and profitability.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        climate change impacts project on the global food supply
                        is an initiative to investigate how climate change will
                        affect food production, distribution, and consumption
                        worldwide. The project aims to provide insights into how
                        these impacts may vary by region, crop type, and
                        socio-economic factors, and to identify potential
                        strategies for adaptation and mitigation.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Credit card fraud detection using classification
                        algorithms is an initiative to create a machine learning
                        model that can automatically detect fraudulent
                        transactions in credit card transactions. The goal of
                        this project is to enable financial institutions to
                        detect and prevent fraud and protect their customers'
                        financial security.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Water quality project using the random forest algorithm
                        in Data Analytics is an initiative to create a machine
                        learning model that can predict water quality parameters
                        such as pH, dissolved oxygen, biochemical oxygen demand
                        (BOD), and total suspended solids (TSS). Predict water
                        quality using datasets.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tab013" className="tab-pane fade">
                <div id="products1" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        Purchase prediction of customer using random forest is a
                        Data Analytics project that aims to predict whether a
                        customer is likely to make a purchase based on their
                        historical purchase behavior and demographic data. The
                        goal of this project is to help businesses understand
                        their customers' purchasing patterns
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Predicting house prices using regression is a data
                        science project that aims to create a machine learning
                        model that can predict the sale price of a house based
                        on various features such as the number of bedrooms,
                        bathrooms, square footage, location, and age of the
                        property
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Topic Modelling for Twitter Customer Reviews
                          clustering
                        </span>
                      </h3>
                      <p>
                        Topic modeling is a powerful technique in natural
                        language processing that can be used to extract and
                        identify themes or topics in a large corpus of text
                        data. In the context of Twitter customer reviews
                        clustering, topic modeling can be used to identify the
                        main themes or topics that customers are discussing in
                        their reviews
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Authentic vs. Fake Banknote Classification</span>
                      </h3>
                      <p>
                        Using supervised learning algorithms such as logistic
                        regression, decision trees, random forests, or support
                        vector machines (SVMs) used to authentic vs. fake
                        banknote classification.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Principal Component Analysis (PCA) can help improve the
                        clustering performance by reducing the dimensionality of
                        the data. Dimension reduction using PCA with clustering
                        models is a powerful technique to reduce the
                        dimensionality of the data while improving the
                        clustering performance.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>E-Commerce Products Dataset</span>
                      </h3>
                      <p>
                        Record linkage is the process of linking records that
                        refer to the same entity or object across different data
                        sources. In the context of e-commerce products, record
                        linkage can be used to link product records from
                        different e-commerce platforms or retailers that refer
                        to the same product.
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>
                          Anomaly Detection with clustering Data Analytics
                        </span>
                      </h3>
                      <p>
                        Anomaly detection, particularly for fraud detection, can
                        be achieved using clustering techniques in Data Analytics.
                        The idea is to use clustering to group data points
                        together and identify any outliers or anomalies that do
                        not belong to any cluster.
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Likeness of Item B being purchased after item A
                          prediction
                        </span>
                      </h3>
                      <p>
                        Association rules mining is a technique used to find
                        patterns or relationships between items in a dataset. In
                        the context of e-commerce, association rules mining can
                        be used to find items that are frequently purchased
                        together, which can be used to make recommendations to
                        customers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tab014" className="tab-pane fade">
                <div id="products2" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>
                          Online Movie recommendation system to predict
                          preference
                        </span>
                      </h3>
                      <p>
                        Movie Recommendation system is a Data Analytics solution
                        that predicts the preferences of users for movies and
                        recommends relevant movies to them. The system uses
                        machine learning algorithms to analyze user data and
                        movie metadata to make predictions and recommendations.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Online Books recommendation System</span>
                      </h3>
                      <p>
                        Collaborative filtering popular approach to
                        recommendation systems.It involves analyzing the
                        behavior of similar users to predict what a user might
                        like. For example, if User A and User B both read and
                        liked similar books, the system might recommend a new
                        book to User A based on the assumption that they will
                        also like it
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        One popular architecture for speech recognition is the
                        recurrent neural network (RNN), which can model the
                        temporal dependencies in speech.Use the preprocessed
                        data to train your neural network.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Design chatGPT</span>
                      </h3>
                      <p>
                        Use ChatGPT deep learning techniques to generate
                        human-like responses to user inputs.ChatGPT uses a
                        variant of the transformer architecture called the
                        Generative Pre-trained Transformer (GPT). This
                        architecture allows the model to process sequences of
                        text and generate new text that is coherent and
                        grammatically correct
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <section id="syllabus" className="syllabusnewbg">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="syllabusheadings">
                <h1>
                  <span>Data Anlytics Course Syllabus</span>
                  <a
                    target="_default"
                    href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
                  >
                    <i className="fa fa-download mr-2" aria-hidden="true"></i>{" "}
                    Download brochure
                  </a>
                </h1>
                <p>
                  Logicmojo provides Live, Interactive Online Sessions guided by
                  Professionals working in top MNCs. All sessions are covered
                  practically with real-time industrial projects and case
                  studies.
                </p>
              </div>

              <div className="faqnew">
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="heading00">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse00"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 1 -
                          Starting with Excel
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse00"
                      className="collapse"
                      aria-labelledby="heading00"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4 className="mt-3">
                            Chapter 1: Learning the Basics
                          </h4>
                          <ul>
                            <li>Introduction to Microsoft Excel</li>
                            <li>Navigating the Excel interface</li>
                            <li>Working with rows, columns, and cells</li>
                            <li>Data entry and editing</li>
                            <li>Formatting data and cells</li>
                            <li>Creating and saving Excel workbooks</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Excel Functions and Formulas
                          </h4>
                          <ul>
                            <li>Understanding Excel functions and formulas</li>
                            <li>
                              Using basic functions (SUM, AVERAGE, MIN, MAX,
                              etc.)
                            </li>
                            <li>Logical functions (IF, AND, OR)</li>
                            <li>
                              Lookup functions (VLOOKUP, HLOOKUP, INDEX, MATCH)
                            </li>
                            <li>
                              Statistical functions (COUNT, COUNTA, COUNTIF,
                              SUMIF, AVERAGEIF, etc.)
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Data Analysis and Visualization
                          </h4>
                          <ul>
                            <li>Introduction to data analysis in Excel</li>
                            <li>Sorting and filtering data</li>
                            <li>Creating tables and data validation</li>
                            <li>Introduction to PivotTables</li>
                            <li>Analyzing data using PivotTables</li>
                            <li>
                              Data visualization using charts (bar charts, pie
                              charts, line charts, etc.)
                            </li>
                            <li>Creating dynamic and interactive charts</li>
                            <li>
                              Using conditional formatting for data
                              visualization
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Advanced Reporting and Dashboards
                          </h4>
                          <ul>
                            <li>Building dynamic reports and dashboards</li>
                            <li>Combining data from multiple sheets</li>
                            <li>
                              Creating interactive dashboards using slicers
                            </li>
                            <li>
                              Data consolidation and linking between sheets
                            </li>
                            <li>Advanced charting techniques</li>
                            <li>Preparing data for analysis and reporting</li>
                            <li>Tips and tricks for efficient data handling</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading001">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse001"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 2 - SQL
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse001"
                      className="collapse"
                      aria-labelledby="heading001"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4 className="mt-3">
                            Chapter 1: Introduction to SQL and Database Basics
                          </h4>
                          <ul>
                            <li>Introduction to databases and SQL</li>
                            <li>
                              Data Definition Language (DDL) and Data
                              Manipulation Language (DML)
                            </li>
                            <li>
                              SQL Constraints, Relationships, and Cardinality
                            </li>
                            <li>Hands-on experience in DDL and DML</li>
                            <li>
                              Hands-on experience in indexes and variables
                            </li>
                            <li>Accessing data and using operators</li>
                            <li>Filtering data</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: SQL Functions and Joins
                          </h4>
                          <ul>
                            <li>
                              Aggregating Functions (theory with examples)
                            </li>
                            <li>Sorting functions (theory with examples)</li>
                            <li>
                              Retrieving specific columns, rows, and values
                              (theory with examples)
                            </li>
                            <li>Hands-on experience with the above topics</li>
                            <li>
                              Understanding SQL Joins (theory with examples)
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Subqueries and Advanced SQL
                          </h4>
                          <ul>
                            <li>Working with subqueries</li>
                            <li>
                              Working with strings (emphasis on selecting the
                              right string functions)
                            </li>
                            <li>Math functions in SQL</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Advanced SQL Functions
                          </h4>
                          <ul>
                            <li>Date Manipulation in SQL</li>
                            <li>Math functions in SQL</li>
                            <li>Window functions in SQL</li>
                            <li>
                              Aggregator Windows Functions (explained with use
                              case examples)
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: More Window Functions and SQL Views
                          </h4>
                          <ul>
                            <li>
                              Ranking Window Functions (explained with use case
                              examples)
                            </li>
                            <li>
                              Value Window Functions (explained with use case
                              examples)
                            </li>
                            <li>Hands-on experience with SQL functions</li>
                            <li>Understanding SQL Views</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading002">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse002"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 3 - Python
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse002"
                      className="collapse"
                      aria-labelledby="heading002"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4 className="mt-3">
                            Chapter 1: Python deep-dive ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Working With Numbers, Booleans and Strings</li>
                            <li>
                              String types and formatting, String operations
                            </li>
                            <li>
                              List, Tuples, Dictionaries Python Lists, Tuples,
                              Dictionaries
                            </li>
                            <li>
                              Basic Operations Indexing, Slicing, and Matrixes
                            </li>
                            <li>Built-in Functions & Methods</li>
                            <li>Exercises on List,Tuples And Dictionary</li>
                            <li>Functions & Modules</li>
                            <li>Exceptional Handling and Regular Expression</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Library of Python used for ML/AI
                          </h4>
                          <ul>
                            <li>Numpy, Pandas, Matplotlib, Seaborn, Scipy</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Data Analysis Using Numpy
                          </h4>
                          <ul>
                            <li>Introduction to Numpy</li>
                            <li>
                              Array Creation, Printing Arrays. Basic Operation
                            </li>
                            <li>
                              Indexing, Slicing and Iterating, Shape
                              Manipulation
                            </li>
                            <li>Vector stacking, Broadcasting with Numpy</li>
                            <li>Numpy for Statistical Operation</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 4: Data Analysis Using Pandas
                          </h4>
                          <ul>
                            <li>Introduction to Pandas</li>
                            <li>Pandas Data Frames, Indexing Data Frames</li>
                            <li>Basic Operations With Data frame</li>
                            <li>Sub setting and filtering a data frame</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 5: Data Visualization using Matplotlib
                          </h4>
                          <ul>
                            <li>How to use & configure Matplotlib</li>
                            <li>plot(), Controlling Line Properties</li>
                            <li>
                              Subplot with Functional Method, Multiple Plot
                            </li>
                            <li>Working with Multiple Figures</li>
                            <li>Histograms</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 6: Data Visualization using Seaborn
                          </h4>
                          <ul>
                            <li>
                              Intro to Seaborn, Visualizing statistical
                              relationships
                            </li>
                            <li>Plotting with categorical data</li>
                            <li>Visualizing linear relationships</li>
                            <li>Seaborn Exercise</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>1. Resume Screening project with Python Library</p>
                          <p>
                            2. Climate Change impacts on the Global Food Supply
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading003">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse003"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 4 - Basics
                          Of Statistics
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse003"
                      className="collapse"
                      aria-labelledby="heading003"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Fundamentals of Math and Probability ( 3
                            hrs )
                          </h4>
                          <ul>
                            <li>Variables, Random Variables</li>
                            <li>
                              Population, Sample, Mean, Population Distribution
                            </li>
                            <li>Sample Distribution, Mean, Median, Mode</li>
                            <li>Range, Measure of Dispersion, Variance</li>
                            <li>Probability Density function</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Statistics, Statistical Thinking
                          </h4>
                          <ul>
                            <li>Standard Normal Distribution, Z Score </li>
                            <li>Standard Deviation, Gaussian Distribution</li>
                            <li>Cumulative Distribution function</li>
                            <li>Hypothesis Testing & Plotting graph</li>
                            <li>Central limit theorem, Covariance</li>
                            <li>Pearson Correlation Coefficient</li>
                            <li>
                              Spearman Rank Coefficient, Hypothesis Testing
                            </li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Advanced Statistics
                          </h4>
                          <ul>
                            <li>Q-Q plot,Skewness of Data </li>
                            <li>Discrete & continuous distribution</li>
                            <li>Bernoulli & binomial distribution</li>
                            <li>Log normal distribution </li>
                            <li>Pox cox transformation</li>
                            <li>Poisson distribution</li>
                            <li>Application of Non Gaussian distribution</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Statical Analysis of Health Insurance Pricing
                            Forecast
                          </p>
                          <p>
                            2. Climate Change Impacts on the Global Food Supply
                          </p>
                          <p>
                            3. Statistical analysis of road accident in India
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading006">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse006"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 5- Tableau
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse006"
                      className="collapse"
                      aria-labelledby="heading006"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>Chapter 1: Introduction to Tableau ( 3 hrs )</h4>
                          <ul>
                            <li>
                              Installing Tableau and connecting to data sources
                            </li>
                            <li>Creating dashboard pages</li>
                            <li>How to create calculated columns</li>
                            <li>Data cleaning and reshaping</li>
                            <li>Creating a basic visualization</li>
                          </ul>

                          <h4 className="mt-3">Chapter 2: Charts and Graphs</h4>
                          <ul>
                            <li>Basic charts and Graph Types</li>
                            <li>Customizing Charts and Formatting</li>
                            <li>Interactive Features and actions</li>
                            <li>
                              Advanced chart types (e.g., maps, treemaps,
                              scatter plots)
                            </li>
                          </ul>

                          <h4 className="mt-3">Chapter 3: Tableau (Advance)</h4>
                          <ul>
                            <li>Mapping</li>
                            <li>Coordinate points</li>
                            <li>Plotting Latitude and Longitude</li>
                            <li>Custom Geocoding</li>
                            <li>Polygon Maps</li>
                            <li>WMS and Background Image</li>
                          </ul>

                          <h5>Case Study:</h5>
                          <p>1. Connecting data source and data cleansing</p>
                          <p>2. Working with various Charts</p>
                          <p>
                            3. Deployment of Predictive model in visualization
                          </p>

                          <h4 className="mt-3">
                            Chapter 4: Dashboard and Stories
                          </h4>
                          <ul>
                            <li>
                              Working in Views with Dashboards and Stories
                            </li>
                            <li>Working with Sheets Fitting Sheets</li>
                            <li>Legends and Quick Filters</li>
                            <li>Tiled and Floating Layouts</li>
                            <li>Floating Objects</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: Advanced Chart Types and Analytics
                          </h4>
                          <ul>
                            <li>
                              Creating Advanced Chart types (treemaps, heatmaps)
                            </li>
                            <li>Working with Sheets Fitting Sheets</li>
                            <li>
                              Using statistical functions and analytics(trend
                              lines, forecasting)
                            </li>
                            <li>
                              Creating sets, groups, and bins for data analysis
                            </li>
                          </ul>
                          <h5>Projects:</h5>
                          <p>1. Patient Risk Healthcare Dashboard</p>
                          <p>2. Sales Forecast Analysis Dashboard</p>
                          <p>3. Product Availability Dashboard</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading007">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse007"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 6- Power
                          BI
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse007"
                      className="collapse"
                      aria-labelledby="heading007"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Getting Started With Power BI ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Installing Power BI Desktop</li>
                            <li>
                              Overview of the Workflow in Power BI Desktop
                            </li>
                            <li>
                              Introducing the Different Views of the Data Mode
                            </li>
                            <li>Query Editor Interface</li>
                            <li>Working on Data Model</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Programming with Power BI
                          </h4>
                          <ul>
                            <li>Working with Time Series</li>
                            <li>Understanding aggregation and granularity</li>
                            <li>Filters and Slicers in Power BI Maps</li>
                            <li>Scatterplots and BI Reports</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Connecting Dataset with Power BI
                          </h4>
                          <ul>
                            <li>Creating a Customer</li>
                            <li>Segmentation Dashboard</li>
                            <li>Analyzing the Customer</li>
                            <li>Segmentation Dashboard</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Advanced features Power BI
                          </h4>
                          <ul>
                            <li>
                              Creating calculated columns and measures with DAX
                            </li>
                            <li>Using custom visuals</li>
                            <li>
                              Building hierarchical visualizations with
                              drill-downs
                            </li>
                            <li>Creating and using templates</li>
                            <li>
                              Publishing reports and dashboards to the Power BI
                              Service
                            </li>
                          </ul>

                          <h5>Project:</h5>
                          <p>1. Financial Performance Analysis</p>
                          <p>
                            2. Anomaly Detection in Credit Card Transactions
                          </p>
                          <p>
                            3. AutoML Cashflow Optimization for Insurance
                            Company
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading004">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse004"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 7 - Basics
                          of Machine Learning
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse004"
                      className="collapse"
                      aria-labelledby="heading004"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Machine Learning Introduction ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Machine learning elements </li>
                            <li>
                              Algorithm, Model, Predictor Variable, Response
                              Variable
                            </li>
                          </ul>

                          <h4>
                            Chapter 2: Regression Supervised Learning( 3 hrs )
                          </h4>
                          <ul>
                            <li>Linear Regression</li>
                            <li>Support vector machine(SVC)</li>
                            <li>Ridge Regression</li>
                            <li>Logistics Regression</li>
                            <li>Lasso Regression</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Stock Price Prediction using Linear regression
                          </p>
                          <p>2. Spam mail detector for mailbox</p>
                          <p>
                            3. Predict car price using py-torch & SVC egression
                          </p>
                          <p>
                            4. Use logistics regression models to predict wine
                            quality
                          </p>
                          <p>
                            5. Use logistics regression to predict if loan
                            approved or not
                          </p>

                          <h4 className="mt-3">
                            Chapter 3: Supervised Learning - Classification
                          </h4>
                          <ul>
                            <li>
                              Understanding Decision Trees and Naive Bayes
                            </li>
                            <li>Linear classifiers</li>
                            <li>Decision boundaries</li>
                            <li>K-Nearest Neighbours</li>
                            <li>Random forest</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Credit Card Fraud Detection using Classification
                            algorithms
                          </p>
                          <p>
                            2. Build model and evaluate water quality using
                            random forest
                          </p>
                          <p>
                            3. Purchase prediction of customer using random
                            forest
                          </p>
                          <p>
                            4. Confusion Matrix of Multi Class Classification
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="programmright">
                <h2>
                  Program <b>highlights</b>
                </h2>

                <div className="programlist">
                  <ul>
                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">110+ Hours Live sessions</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">3+ Projects</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">1:1 Doubt Session</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">1 Year Subscription </div>
                      </div>
                    </li>
                  </ul>

                  <ul>
                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Life time accessibility</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Job Assistance Program</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Peer to peer Learning</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Mock Interview </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <p style={{ float: "left", width: "100%" }}>
                  <a
                    target="_default"
                    href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
                    className="applnowbtn mt-4"
                  >
                    Talk to our experts
                    <i
                      className="fa fa-angle-right arrowclass"
                      aria-hidden="true"
                    ></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <div className="careerservices-new">
        <div className="container">
          <h2>Career Services By Logicmojo</h2>
          <br></br>
          <div className="careerservices-new-left">
            <img src="assets/images/career-services.png" alt="" />
          </div>
          <div className="careerservices-new-right">
            <div className="projectsnewbg-bottom">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#tab020"
                  >
                    Job Assistance
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab021">
                    Interview Preparation
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab022">
                    Profile Building
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div id="tab020" className="tab-pane active">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Job Assistance starts After Course Completion</h2>
                      <p>
                        Job referrals start after the completion of a course,
                        with career services professionals offering guidance and
                        support to students as they prepare to enter Data
                        Science & AI domain.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Job Assistance Criteria</h2>
                      <p>
                        Job Assistance program for our candidates being regular
                        with classes. Get noticed & referred by our 150+ hiring
                        partners for the profile of Data Scientist, Machine
                        Learning Engineer, Data Analytics, MLOps as well as
                        Business Analytics.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab021" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>
                        Learn Data Analytics, AI & ML with Case Studies & Projects
                      </h2>
                      <p>
                        Learn Full Stack AI & Data Scienece topics with 30+ real
                        projects with datasets. Designed & Implement Models,
                        Deploy in the Prod Environment. Make your profile storng
                        in Data Analytics & AI Field
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Mock Interviews & Mentorship 1 to 1 Sessions</h2>
                      <p>
                        Attend 1 to 1 Classes with the mentor during mentorship
                        program. Make your progress in the right direction under
                        guidance of mentor having 5+ years experience in DS, AI
                        & ML Domain. Check your progress with mock interviews 1
                        to 1 Online Session , experience the actual interview
                        environment.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab022" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Resume Preparation </h2>
                      <p>
                        After completion of the course , we need to prepare
                        candidate resume before applying for IT Data Scientist
                        as well as Data analytics profile" rephrase. Attend 1 to
                        1 session with mentor for resume preparation discussion.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Linkedin Profile Update</h2>
                      <p>
                        For every candidate profile will be updated in Linkedin
                        Portal. Linked is considered to be the major Hub for
                        hiring Data Scientist as well as ML engineer.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <div className="network-reach-newbg">
        <div className="container">
          <h2>The Network Reach of Our Bay</h2>
          <br></br>
          <div className="row">
            <div className="col-lg-5">
              <div className="keyfeaturenew">
                <h2>Our Key Features</h2>
                <ul>
                  <li>
                    We help you build a strong profile and prepare for MNC
                    interviews.
                  </li>
                  <li>
                    Hassle-free and tailored training for MAANG company
                    interviews.
                  </li>
                  <li>
                    Even after a career break, securing a dream job is
                    achievable.
                  </li>
                  <li>
                    A successful career transition even with 0 coding
                    experience.
                  </li>
                </ul>
                {/* <a href="" className="downreportbtn">Download Placement Report <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a> */}
              </div>
            </div>
            <div className="col-lg-7">
              <div className="keyfeaturenew-logo">
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <div className="certificate-companies">
        <div className="container">
          <div className="certificate-companies-img">
            <img src="assets/images/certificate-companies.png" alt="" />
          </div>
          <div className="certificate-companies-text">
            <h5>Data Analytics Certification</h5>
            <h2 style={{ fontSize: 25 }}>
              Get Ahead with Logicmojo's Advance Certificate.
            </h2>
            <br></br>
            <ul>
              <li>
                <b>Get Ahead with Logicmojo's Certificate</b>
              </li>
              <p>
                Our class covers everything, and this Data Analytics certificate
                shows you've made great progress in learning the field.
              </p>
              <li>
                <b>Differentiate yourself with a Certificate</b>
              </li>
              <p>
                The understanding and Data Analytics abilities you've developed
                through projects, assignments, and case studies will put you
                ahead of others.
              </p>
              <li>
                <b>Share your achievement</b>
              </li>
              <p>
                Share your Data Analytics certification on LinkedIn, Twitter,
                and Facebook, enhance your resume, or display it proudly - let
                your friends and colleagues know about your achievement
              </p>
            </ul>
            <a
              target="default"
              href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
            >
              Download Brochure
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="howtoapply-new">
        <div className="container">
          <h2 style={{ fontSize: 30 }}>
            Process of registration For Logicmojo <b>Data Analytics Course</b>
          </h2>
          <div className="row">
            <div className="col-lg-8">
              <div className="howtoapply-new-left">
                <ul>
                  <li>
                    <h4>Step 1</h4>
                    <h3>Submit Application</h3>
                    <p>Book calender call with our Experts</p>
                  </li>
                  <li>
                    <h4>Step 2</h4>
                    <h3>Application Review</h3>
                    <p>
                      Experts will review your profile & answer all your queries
                    </p>
                  </li>
                  <li>
                    <h4>Step 3</h4>
                    <h3>Admission</h3>
                    <p>
                      Candidate can apply for Online Live classes for 6 months
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="howtoapply-new-right">
                <h2>Enroll For Live Course</h2>
                <div className="howtoapply-new-rightform">
                  <form>
                    <div className="row">
                      <div className="form-group col-lg-12">
                        <input
                          type="submit"
                          className="submitbtn"
                          value="Apply For Live Classes"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="programfeenew" id="Fee">
        <div className="container">
          <h2 style={{ fontSize: 30 }}>Data Analytics Course Fee</h2>
          <div className="programfeenew-inner">
            <div className="programfeenew-inner-left">
              <div className="programfeenew-inner-price">
                <p>Total Fee</p>
                <h2>₹ 65,000</h2>
              </div>
            </div>
            <div className="programfeenew-inner-right">
              <h5>No Cost EMI</h5>
              <div className="d-flex align-items-center justify-content-between">
                <h4>
                  <span>As low as</span> ₹ 5,160/month
                </h4>
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
                >
                  Enroll now
                </a>
              </div>
              <p>
                We have partnered with the following financing companies to
                provide competitive finance options at 0% interest rate with no
                hidden costs...
              </p>
              <ul>
                <li>
                  <img src="assets/images/feelogo1.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo2.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo3.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo4.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="eligibility-criteria-row">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h2>Data Analytics Course Eligibility Criteria</h2>
                <ul className="eligibilitylist1">
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon1.png"
                        alt=""
                      />
                    </span>
                    A bachelor's degree with an average of 50% or higher marks
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon2.png"
                        alt=""
                      />
                    </span>
                    Basic understanding of mathematics and statistics
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon3.png"
                        alt=""
                      />
                    </span>
                    Proficiency in programming languages like Python or R can be
                    beneficial
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h2>Who can apply for the Data Analytics course?</h2>
                <ul className="eligibilitylist2">
                  <li>Recent Graduates</li>
                  <li>IT Professionals</li>
                  <li>Data Professionals</li>
                  <li>Business Analysts</li>
                  <li>Finance Experts</li>
                  <li>Marketing Professionals</li>
                  <li>Career Changers</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Enroll For Live Classes</b>
            </a>
          </div>
        </center>
      </section>
      <br />

      <section id="specialisation" className="specialisation-bg">
        <div className="container">
          <h2>
            Data Analytics Course <b>Overview</b>
          </h2>
          <p>
            "Unlock a world of opportunities with Logicmojo's Data Analytics
            Course, precisely designed to provide to both newcomers and seasoned
            professionals in the data domain. We'll guide you on a journey from
            the fundamentals, imparting the knowledge and skills required to
            develop in the dynamic field of data analytics. Grab this perfect
            chance to start your career in data analysis with our Data Analytics
            Course! Elevate your profile as a sought-after data expert in
            today's digital landscape, acquiring the required skills to analyze
            insights, inform decisions, and excel in the world of data-driven
            decision-making."
          </p>
          <div className="faqnewbg-inner">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab023">
                  Introduction to Data Analytics Course
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab025">
                  Certification
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab026">
                  Job assistance
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab027">
                  Mentorships
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab028">
                  Support
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab023" className="tab-pane active">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What Is a Data
                            Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A Data Analytics Course is a comprehensive
                            educational program aimed at equipping students with
                            essential skills for data collection, preparation,
                            analysis, and presentation. These courses are often
                            available online and are structured to provide a
                            solid foundation in the field of data analytics.
                          </p>

                          <p>
                            Throughout the course, students delve into various
                            aspects of data analytics, starting with the
                            fundamentals. They gain proficiency in programming
                            languages such as Python, R, and SQL, which are
                            fundamental for data manipulation and analysis.
                            These languages allow students to perform data
                            cleansing, manipulation, and statistical analysis.
                          </p>

                          <p>
                            Furthermore, Data Analytics Courses also introduce
                            students to essential tools like Microsoft Excel and
                            Tableau. These tools are widely used in the industry
                            for data visualization and reporting. Excel helps
                            students master data handling and basic analysis,
                            while Tableau enables them to create interactive and
                            insightful data visualizations.
                          </p>

                          <p>
                            Overall, a Data Analytics Course empowers students
                            to harness the power of data. It prepares them to
                            work with large datasets, extract valuable insights,
                            and effectively communicate their findings. In an
                            era driven by data-driven decision-making, these
                            courses are invaluable in shaping individuals into
                            proficient data analysts, ready to meet the demands
                            of the ever-evolving data analytics field.
                          </p>
                          <br />
                          <img
                            src="assets/images/Data-analytics/DA1.jpg"
                            style={{ width: "90%" }}
                            alt=""
                          />
                          <br />
                          <br />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is data
                            analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>Data analytics</b> is a powerful discipline in
                            the realm of Data Analytics that involves examining
                            raw data to extract meaningful insights, patterns,
                            and trends. It's a systematic process of
                            transforming data into actionable information, which
                            organizations can use to make informed decisions and
                            gain a competitive edge.
                          </p>

                          <p>Here are key components of data analytics:</p>

                          <ul>
                            <li>
                              <b>Data Collection:</b> The process begins with
                              gathering relevant data from various sources, such
                              as databases, spreadsheets, or sensors.
                            </li>
                            <li>
                              <b>Data Preparation:</b> Raw data often needs
                              cleaning and formatting to remove errors and
                              inconsistencies.
                            </li>
                            <li>
                              <b>Data Analysis:</b> In this stage, statistical
                              techniques, algorithms, and machine learning
                              models are applied to uncover insights and trends
                              within the data.
                            </li>
                            <li>
                              <b>Data Visualization:</b> Visual representations,
                              like charts and graphs, help in presenting
                              findings in a clear and understandable manner.
                            </li>
                            <li>
                              <b>Data Interpretation:</b> Analysts draw
                              conclusions and make data-driven recommendations
                              based on their findings.
                            </li>
                            <li>
                              <b>Decision-Making:</b> Organizations use these
                              insights to make informed decisions, optimize
                              processes, and improve performance.
                            </li>
                          </ul>

                          <p>
                            Data analytics plays a pivotal role across
                            industries, including finance, healthcare,
                            marketing, and more. It empowers professionals to
                            solve complex problems, identify opportunities, and
                            adapt to changing market conditions. In a data
                            analytics course, you'll acquire the skills needed
                            to excel in this field, including data manipulation,
                            statistical analysis, and data visualization, making
                            you a valuable asset in the data-driven landscape.
                          </p>

                          <br />
                          <img
                            src="assets/images/Data-analytics/DA2.jpg"
                            style={{ width: "80%" }}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading020">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse020"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What does a
                            Data Analyst do?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse020"
                        className="collapse"
                        aria-labelledby="heading020"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A <b>Data Analyst</b> is a skilled professional
                            within the field of data analytics who plays a
                            crucial role in transforming raw data into
                            actionable insights. Their responsibilities
                            encompass:
                          </p>

                          <ul>
                            <li>
                              <b>Relevant Data Collection:</b> Data Analysts are
                              adept at gathering data from various sources,
                              ensuring it is relevant to the problem or question
                              at hand. This involves working with databases,
                              APIs, spreadsheets, and more to compile
                              comprehensive datasets.
                            </li>
                            <li>
                              <b>In-Depth Analysis:</b> Once the data is
                              collected, Data Analysts employ statistical
                              techniques, data mining, and machine learning
                              algorithms to delve deep into the dataset. Their
                              goal is to identify patterns, trends, anomalies,
                              and other valuable information that can inform
                              decision-making.
                            </li>
                            <li>
                              <b>Data Reporting & Visualization:</b> Data
                              Analysts communicate their findings effectively
                              through reports and visualizations. They use tools
                              like charts, graphs, and dashboards to present
                              data insights in a clear and understandable
                              manner, aiding stakeholders in making informed
                              choices.
                            </li>
                          </ul>

                          <p>
                            Data Analysts are integral to organizations across
                            various industries, as they provide evidence-based
                            insights that drive strategic decisions, improve
                            processes, and enhance overall performance. By
                            enrolling in a data analytics course, individuals
                            gain the skills and knowledge necessary to excel in
                            this role, becoming proficient in data manipulation,
                            statistical analysis, and data visualization—key
                            components of a successful Data Analyst's toolkit.
                          </p>
                          <br />
                          <img
                            src="assets/images/Data-analytics/DA4.png"
                            style={{ width: "80%" }}
                            alt=""
                          />
                          <br />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Why Data
                            Analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data Analytics is an exciting and rapidly growing
                            field with numerous compelling reasons to consider
                            it as a career choice:
                          </p>

                          <ul>
                            <li>
                              <b>Abundant Job Opportunities:</b> There are over
                              80,000 daily job openings for data analytics
                              professionals on LinkedIn alone. Companies
                              worldwide are investing heavily in this
                              transformative field, creating a robust demand for
                              skilled specialists who can navigate the vast
                              landscape of data.
                            </li>
                            <li>
                              <b>Suitable for All Backgrounds:</b> Whether you
                              come from a technical or non-technical background,
                              data analytics is accessible to anyone willing to
                              master the necessary skills. Your background
                              doesn't limit your potential in this field.
                            </li>
                            <li>
                              <b>Wide Range of Applications:</b> Data analytics
                              transcends industries, from finance to IT and
                              beyond. As a data analyst, you have the
                              flexibility to choose a field of work that aligns
                              with your interests and aspirations.
                            </li>
                            <li>
                              <b>Lucrative Career Path:</b> Data analysts enjoy
                              a highly lucrative career path with endless
                              opportunities to collaborate with industry giants
                              like Google, Meta, Amazon, and more. Your
                              expertise in data analysis opens doors to exciting
                              roles and projects.
                            </li>
                            <li>
                              <b>High Earning Potential:</b> Data analytics
                              offers an impressive salary hike. Professionals in
                              this field can earn as much as 36 lakhs per annum
                              (LPA) or even more, making it a financially
                              rewarding career choice.
                            </li>
                          </ul>

                          <p>
                            Enrolling in a data analytics course is your gateway
                            to seizing these opportunities. It equips you with
                            the essential skills and knowledge to thrive in this
                            dynamic field, setting you on a path toward a
                            fulfilling and prosperous career.
                          </p>
                          <br />
                          <img
                            src="assets/images/Data-analytics/DA7.jpg"
                            style={{ width: "80%" }}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading030">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse030"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            prerequisites for taking up this Data Analytics
                            Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse030"
                        className="collapse"
                        aria-labelledby="heading030"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Before embarking on a Data Analytics Course, it's
                            important to be aware of the prerequisites that can
                            help you succeed in the program:
                          </p>

                          <ul>
                            <li>
                              <b>Educational Background:</b> While a specific
                              degree isn't always mandatory, having a
                              foundational understanding of mathematics and
                              statistics can be highly beneficial. Many courses
                              accept candidates with backgrounds in fields like
                              mathematics, computer science, engineering,
                              business, or related areas.
                            </li>
                            <li>
                              <b>Computer Literacy:</b> A basic level of
                              computer proficiency is essential. You should be
                              comfortable with using computers, including tasks
                              like file management, software installation, and
                              basic programming concepts.
                            </li>
                            <li>
                              <b>Mathematical Aptitude:</b> Data analytics
                              involves working with numbers and statistics.
                              Familiarity with algebra, calculus, and
                              statistical concepts is advantageous for
                              comprehending and applying data analysis
                              techniques.
                            </li>
                            <li>
                              <b>Analytical Mindset:</b> A strong analytical
                              mindset is a key prerequisite. You should possess
                              problem-solving skills, critical thinking
                              abilities, and a curiosity to explore and
                              interpret data.
                            </li>
                            <li>
                              <b>Programming Knowledge:</b> While not always
                              required, having prior exposure to programming
                              languages like Python or R can be advantageous.
                              These languages are commonly used for data
                              manipulation and analysis.
                            </li>
                          </ul>

                          <p>
                            It's important to note that prerequisites can vary
                            depending on the specific Data Analytics Course and
                            its level (beginner, intermediate, or advanced).
                            Before enrolling, carefully review the course
                            requirements and consider any additional
                            prerequisites mentioned by the institution. Taking
                            preparatory courses or self-study in relevant areas
                            can also help bridge any knowledge gaps and ensure
                            you make the most of your data analytics learning
                            journey.
                          </p>
                          <br />
                          <img
                            src="assets/images/Data-analytics/DA8.jpg"
                            style={{ width: "80%" }}
                            alt=""
                          />
                          <br />
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading04">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse04"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the different types of data analytics?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse04"
                            className="collapse"
                            aria-labelledby="heading04"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics is a multifaceted field that
                                offers various approaches to extract insights
                                from data. Here are the primary types:
                              </p>

                              <ul>
                                <li>
                                  <b>Descriptive Analytics:</b> This type
                                  focuses on summarizing historical data to
                                  provide a clear picture of past events and
                                  trends. Descriptive analytics uses techniques
                                  like data aggregation and visualization to
                                  present information in an understandable
                                  format.
                                </li>
                                <li>
                                  <b>Diagnostic Analytics:</b> Diagnostic
                                  analytics goes a step further by delving into
                                  the "why" behind historical data. It aims to
                                  identify the root causes of past outcomes or
                                  issues, helping organizations understand what
                                  led to specific events.
                                </li>
                                <li>
                                  <b>Predictive Analytics:</b> Predictive
                                  analytics uses statistical and machine
                                  learning models to forecast future trends or
                                  outcomes based on historical data. It enables
                                  organizations to make proactive decisions and
                                  anticipate potential challenges.
                                </li>
                                <li>
                                  <b>Prescriptive Analytics:</b> This advanced
                                  form of analytics not only predicts future
                                  scenarios but also recommends specific actions
                                  to optimize outcomes. It provides actionable
                                  insights, guiding organizations on the best
                                  course of action to achieve their goals.
                                </li>
                              </ul>

                              <p>
                                These types of data analytics are often used
                                sequentially to extract the most value from
                                data. Descriptive analytics lays the foundation
                                by summarizing historical data, followed by
                                diagnostic analytics to uncover causes.
                                Predictive analytics then looks into the future,
                                and prescriptive analytics offers actionable
                                recommendations. Mastery of these analytics
                                types is a fundamental part of a comprehensive
                                data analytics course, equipping learners to
                                make informed decisions and solve complex
                                problems across various industries.
                              </p>
                              <br />
                              <img
                                src="assets/images/Data-analytics/DA5.png"
                                style={{ width: "80%" }}
                                alt=""
                              />
                              <br />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading050">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse050"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the different tools and technologies used in
                                data analytics?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse050"
                            className="collapse"
                            aria-labelledby="heading050"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>
                                  Different Tools and Technologies in Data
                                  Analytics
                                </b>
                              </p>

                              <p>
                                Data analytics relies on a diverse set of tools
                                and technologies to collect, process, analyze,
                                and visualize data effectively. Here's an
                                overview of key tools and technologies used in
                                the field:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Visualization Tools:</b> Tools like
                                  Tableau, Power BI, and QlikView enable
                                  analysts to create interactive and insightful
                                  data visualizations, helping stakeholders
                                  grasp data patterns and trends.
                                </li>
                                <li>
                                  <b>Data Analysis Software:</b> Software
                                  packages like Python, R, and SAS are widely
                                  used for data manipulation, statistical
                                  analysis, and machine learning tasks. They
                                  offer extensive libraries and frameworks for
                                  data analytics.
                                </li>
                                <li>
                                  <b>Database Management Systems (DBMS):</b>{" "}
                                  DBMS such as MySQL, PostgreSQL, and MongoDB
                                  store and manage data efficiently. SQL, a
                                  language for querying relational databases, is
                                  essential for data extraction and
                                  transformation.
                                </li>
                                <li>
                                  <b>Big Data Technologies:</b> Hadoop and
                                  Apache Spark handle large-scale data
                                  processing. They are crucial for handling big
                                  data analytics tasks, offering distributed
                                  computing capabilities.
                                </li>
                                <li>
                                  <b>Machine Learning Frameworks:</b>{" "}
                                  TensorFlow, scikit-learn, and PyTorch provide
                                  tools for developing and deploying machine
                                  learning models, facilitating predictive
                                  analytics.
                                </li>
                                <li>
                                  <b>Statistical Tools:</b> Tools like SPSS and
                                  Minitab are used for statistical analysis and
                                  hypothesis testing, supporting data-driven
                                  decision-making.
                                </li>
                                <li>
                                  <b>Data Integration Tools:</b> ETL (Extract,
                                  Transform, Load) tools like Apache Nifi and
                                  Talend help collect data from various sources,
                                  clean it, and prepare it for analysis.
                                </li>
                              </ul>

                              <p>
                                Proficiency in these tools and technologies is
                                essential for data analysts, enabling them to
                                handle diverse data sources, conduct in-depth
                                analysis, and present insights effectively. A
                                comprehensive data analytics course typically
                                covers these tools, empowering learners to
                                leverage them in their data-driven careers.
                              </p>
                              <br />
                              <img
                                src="assets/images/Data-analytics/DA3.png"
                                style={{ width: "80%" }}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What skills
                                i need to become a data analyst?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Becoming a proficient data analyst demands a
                                diverse set of skills that encompass technical,
                                analytical, and interpersonal abilities. Here
                                are the key skills you'll need:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Analysis:</b> Proficiency in data
                                  manipulation, cleaning, and transforming data
                                  is fundamental. You'll use tools like Python,
                                  R, or SQL to perform data operations
                                  efficiently.
                                </li>
                                <li>
                                  <b>Statistical Knowledge:</b> Understanding
                                  statistical concepts and methods is crucial
                                  for drawing meaningful insights from data and
                                  conducting hypothesis testing.
                                </li>
                                <li>
                                  <b>Data Storytelling:</b> Data analysts need
                                  to translate complex findings into a clear and
                                  compelling narrative. This involves data
                                  visualization skills to create informative
                                  charts and graphs.
                                </li>
                                <li>
                                  <b>Communication:</b> Effective communication
                                  is paramount. You must convey your insights to
                                  both technical and non-technical stakeholders
                                  through writing, speaking, and presentation
                                  skills.
                                </li>
                                <li>
                                  <b>Problem-Solving:</b> Data analysts are
                                  problem solvers. You'll encounter diverse
                                  challenges, and the ability to approach them
                                  methodically is essential.
                                </li>
                                <li>
                                  <b>Business Acumen:</b> Understanding the
                                  business context is critical. Data analysts
                                  often work closely with business teams, so
                                  having a grasp of business principles and
                                  goals is advantageous.
                                </li>
                                <li>
                                  <b>Strategic Thinking:</b> Developing a
                                  strategic mindset helps align data analysis
                                  efforts with organizational objectives,
                                  ensuring your insights drive actionable
                                  decisions.
                                </li>
                              </ul>
                              <br />
                              <img
                                src="assets/images/Data-analytics/DA11.jpg"
                                style={{ width: "80%" }}
                                alt=""
                              />
                              <p>
                                In essence, a data analyst's role is to bridge
                                the gap between data and informed
                                decision-making. You'll transform business
                                questions into data-driven inquiries, analyze
                                data to extract answers, and present these
                                findings in a compelling manner. A data
                                analytics course equips you with these essential
                                skills, enabling you to excel in a data-driven
                                world and make valuable contributions to your
                                organization's success.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What You
                                Will Learn From Logicmojo's Data Analytics
                                Course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course is designed to
                                equip you with the comprehensive knowledge and
                                skills needed to excel in the dynamic field of
                                data analytics. Throughout the course, you'll
                                embark on a transformative learning journey that
                                includes:
                              </p>

                              <ul>
                                <li>
                                  <b>Foundational Data Skills:</b> You will
                                  build a solid foundation in data analytics,
                                  covering key concepts, terminology, and the
                                  data analysis process.
                                </li>
                                <li>
                                  <b>Data Manipulation:</b> Learn how to
                                  collect, clean, and preprocess data from
                                  diverse sources to ensure it is ready for
                                  analysis.
                                </li>
                                <li>
                                  <b>Statistical Analysis:</b> Dive into
                                  statistical techniques and methods, allowing
                                  you to draw meaningful insights and make
                                  data-driven decisions.
                                </li>
                                <li>
                                  <b>Data Visualization:</b> Master the art of
                                  creating impactful data visualizations using
                                  tools like Tableau and Power BI to effectively
                                  communicate your findings.
                                </li>
                                <li>
                                  <b>Machine Learning:</b> Explore machine
                                  learning algorithms and their applications for
                                  predictive analytics and data-driven
                                  solutions.
                                </li>
                                <li>
                                  <b>Real-world Projects:</b> Apply your skills
                                  to real-world projects, gaining hands-on
                                  experience and building a strong portfolio
                                  that showcases your expertise.
                                </li>
                                <li>
                                  <b>Business Acumen:</b> Develop a deep
                                  understanding of how data analytics aligns
                                  with business goals, enabling you to make
                                  strategic contributions to your organization.
                                </li>
                                <li>
                                  <b>Effective Communication:</b> Hone your
                                  communication skills, both in writing and
                                  presentation, to convey your data insights
                                  clearly and persuasively.
                                </li>
                              </ul>

                              <p>
                                By the end of this course, you'll be
                                well-prepared to tackle data analysis
                                challenges, work with big data, and leverage
                                data as a powerful tool for informed
                                decision-making. Whether you're starting your
                                career or seeking to enhance your data analytics
                                skills, Logicmojo's course equips you with the
                                knowledge and confidence to thrive in this
                                data-driven era.
                              </p>
                              <br />
                              <img
                                src="assets/images/Data-analytics/DA10.jpg"
                                style={{ width: "80%" }}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading0800">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse0800"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What jobs
                                uses data analytics?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse0800"
                            className="collapse"
                            aria-labelledby="heading0800"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics is a versatile field with
                                applications across various industries.
                                Professionals proficient in data analytics are
                                in high demand in sectors such as:
                              </p>

                              <ul>
                                <li>
                                  <b>Retail:</b> Retailers analyze customer data
                                  to enhance marketing, inventory management,
                                  and customer experience.
                                </li>
                                <li>
                                  <b>Healthcare:</b> Healthcare organizations
                                  use data analytics to improve patient care,
                                  optimize operations, and develop treatment
                                  plans.
                                </li>
                                <li>
                                  <b>Banking and Finance:</b> Financial
                                  institutions employ data analysts to assess
                                  risk, detect fraud, and make investment
                                  decisions.
                                </li>
                                <li>
                                  <b>Transportation:</b> Transportation
                                  companies use data analytics for route
                                  optimization, fuel efficiency, and logistics
                                  management.
                                </li>
                                <li>
                                  <b>Education:</b> Educational institutions
                                  utilize data analytics for student performance
                                  analysis and resource allocation.
                                </li>
                                <li>
                                  <b>Construction:</b> The construction industry
                                  benefits from data analytics for project
                                  management and cost estimation.
                                </li>
                                <li>
                                  <b>Technology:</b> Tech companies employ data
                                  analysts for product development, user
                                  experience optimization, and market research.
                                </li>
                              </ul>

                              <p>
                                Jobs requiring data analytics expertise
                                encompass a wide range of roles:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Scientists:</b> Specialized data
                                  professionals who conduct in-depth analysis
                                  and develop machine learning models.
                                </li>
                                <li>
                                  <b>Business Intelligence Analysts:</b>{" "}
                                  Professionals who create data-driven reports
                                  and dashboards for informed decision-making.
                                </li>
                                <li>
                                  <b>Data Engineers:</b> Experts in data
                                  collection, storage, and transformation to
                                  support analytics processes.
                                </li>
                                <li>
                                  <b>Quantitative Analysts:</b> Professionals
                                  who use mathematical and statistical models
                                  for risk assessment.
                                </li>
                                <li>
                                  <b>Marketing Analysts:</b> Analysts focused on
                                  optimizing marketing campaigns and customer
                                  segmentation.
                                </li>
                                <li>
                                  <b>Project Managers:</b> Managers who leverage
                                  data analytics to drive project success and
                                  efficiency.
                                </li>
                                <li>
                                  <b>IT Systems Analysts:</b> Professionals who
                                  use data to improve IT systems and operations.
                                </li>
                                <li>
                                  <b>Transportation Logistics Specialists:</b>{" "}
                                  Specialists who employ data analytics for
                                  efficient supply chain management.
                                </li>
                              </ul>
                              <img
                                src="assets/images/Data-analytics/DA9.jpg"
                                style={{ width: "80%" }}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Who Should
                                Enroll in a Data Analytics Course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                A Data Analytics Course is a valuable
                                opportunity for individuals from diverse
                                educational backgrounds who possess an
                                analytical mindset and a passion for harnessing
                                data-driven insights. This includes:
                              </p>

                              <ul>
                                <li>
                                  <b>IT Professionals:</b> Those in the IT
                                  industry seeking to enhance their data
                                  analytics skills to excel in data-related
                                  roles.
                                </li>
                                <li>
                                  <b>Banking and Finance Professionals:</b>{" "}
                                  Professionals in banking and finance can
                                  leverage data analytics to make informed
                                  investment decisions, manage risk, and detect
                                  fraudulent activities.
                                </li>
                                <li>
                                  <b>Marketing Managers:</b> Marketing experts
                                  can benefit from data analytics to refine
                                  their strategies, understand customer
                                  behavior, and optimize campaigns.
                                </li>
                                <li>
                                  <b>Sales Professionals:</b> Sales teams can
                                  use data analytics to identify potential
                                  leads, forecast sales, and personalize
                                  customer interactions.
                                </li>
                                <li>
                                  <b>Supply Chain Network Managers:</b>{" "}
                                  Professionals in supply chain management can
                                  employ data analytics to optimize logistics,
                                  reduce costs, and improve efficiency.
                                </li>
                                <li>
                                  <b>Beginners in Data Analytics:</b> Those new
                                  to the data analytics field can gain
                                  foundational knowledge and skills to kickstart
                                  their careers.
                                </li>
                                <li>
                                  <b>Students in UG/ PG Programs:</b>{" "}
                                  Undergraduate and postgraduate students across
                                  disciplines can enhance their employability by
                                  adding data analytics expertise to their skill
                                  set.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading10">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse10"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                career path for a Data Analyst?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse10"
                            className="collapse"
                            aria-labelledby="heading10"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Entering the dynamic field of data analysis
                                opens a multitude of career opportunities.
                                Here's a typical career path you can follow:
                              </p>

                              <ul>
                                <li>
                                  <b>Junior Data Analyst:</b> Begin your journey
                                  as a junior data analyst, where you'll gain
                                  hands-on experience in data collection,
                                  cleaning, and basic analysis.
                                </li>
                                <li>
                                  <b>Senior Data Analyst:</b> With experience,
                                  you can move into senior roles, taking on more
                                  complex projects, and playing a crucial role
                                  in data-driven decision-making processes.
                                </li>
                                <li>
                                  <b>Data Scientist:</b> Progress further to
                                  become a data scientist, specializing in
                                  advanced analytics, machine learning, and
                                  predictive modeling.
                                </li>
                                <li>
                                  <b>Analytics Manager:</b> As an analytics
                                  manager, you'll oversee teams of analysts,
                                  guiding their work and ensuring data
                                  initiatives align with business objectives.
                                </li>
                                <li>
                                  <b>Data Architect:</b> Data architects design
                                  and manage data systems and structures,
                                  ensuring efficient data storage and
                                  accessibility.
                                </li>
                                <li>
                                  <b>Chief Data Officer (CDO):</b> For the
                                  highest leadership role, consider becoming a
                                  Chief Data Officer, responsible for an
                                  organization's overall data strategy and
                                  governance.
                                </li>
                              </ul>
                              <p>
                                A data analytics course equips you with the
                                skills and knowledge needed to embark on this
                                career journey. It provides a strong foundation
                                for those aspiring to excel in data analysis and
                                make valuable contributions to their
                                organizations.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the learning objectives for the course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                The Logicmojo data analytics course is designed
                                to teach you the skills and knowledge you need
                                to become a successful data analyst. Upon
                                completion of the course, you will be able to:
                              </p>
                              <ul>
                                <li>
                                  Understand the fundamentals of data analytics,
                                  including the different types of data, data
                                  collection methods, data cleaning and
                                  preparation, data visualization, and
                                  statistical and machine learning techniques.
                                </li>
                                <li>
                                  Apply data analytics to real-world problems.
                                  You will learn how to identify business
                                  problems that can be solved with data
                                  analytics, and how to develop and implement
                                  data analytics solutions.
                                </li>
                                <li>
                                  Use a variety of data analytics tools and
                                  technologies. You will learn how to use
                                  popular data analytics tools and technologies,
                                  such as Python, R, SQL, and Tableau.
                                </li>
                                <li>
                                  Communicate data analysis results effectively.
                                  You will learn how to communicate the results
                                  of your data analysis to stakeholders in a
                                  clear and concise way.
                                </li>
                              </ul>
                              <p>
                                In addition to these technical skills, the
                                Logicmojo data analytics course also aims to
                                develop your soft skills, such as:
                              </p>
                              <ul>
                                <li>Problem-solving skills</li>
                                <li>Critical thinking skills</li>
                                <li>Communication skills</li>
                                <li>Collaboration skills</li>
                              </ul>

                              <p>
                                By completing the Logicmojo data analytics
                                course, you will be well-prepared for a
                                successful career as a data analyst.
                              </p>

                              <img
                                src="assets/images/Data-analytics/DA6.jpg"
                                style={{ width: "80%" }}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading009">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse009"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                market demand for a Data Analyst?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse009"
                            className="collapse"
                            aria-labelledby="heading009"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>Market Demand for Data Analysts</b>
                              </p>

                              <p>
                                The market demand for Data Analysts is on an
                                upward trajectory, driven by the ever-growing
                                importance of data in the business landscape.
                                Several key factors contribute to this demand:
                              </p>

                              <ul>
                                <li>
                                  <b>World Economic Forum Predictions:</b> The
                                  World Economic Forum anticipates that, by
                                  2025, Data Analysts will be among the most
                                  sought-after professionals in the job market.
                                  Organizations recognize the immense value that
                                  data analysis brings to their decision-making
                                  processes.
                                </li>
                                <li>
                                  <b>Abundance of Data:</b> In today's digital
                                  age, an astonishing 2.5 quintillion bytes of
                                  data are generated daily. This wealth of data
                                  is readily accessible, making data analysis
                                  crucial for extracting actionable insights.
                                </li>
                                <li>
                                  <b>Skill Gap in Data Analytics:</b> There's a
                                  growing gap in the availability of skilled
                                  data analysts, which further amplifies the
                                  demand for professionals in this field.
                                </li>
                              </ul>

                              <p>
                                Professionals venturing into Data Analytics can
                                expect a bright future with abundant job
                                opportunities and competitive salaries. The
                                Future of Jobs Report 2020 predicts that by
                                2025, roles like data analysts and scientists,
                                AI and machine learning specialists, and digital
                                transformation specialists will experience
                                significant growth in demand.
                              </p>

                              <p>
                                According to IBM, the data and analytics job
                                market is expected to expand by 15 percent,
                                reaching 2.72 million jobs by 2020. The finance,
                                insurance, and information technology sectors
                                are expected to have the most significant demand
                                for Data Analysts. In 2019, Glassdoor reported
                                an average salary of $67,377 for Data Analysts.
                              </p>

                              <p>
                                Enrolling in a Data Analytics course, such as
                                Logicmojo's, positions individuals to seize
                                these lucrative opportunities and play a vital
                                role in the data-driven future of businesses.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading039">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse039"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the benefits of taking up this Data Analytics
                                Course by Logicmojo?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse039"
                            className="collapse"
                            aria-labelledby="heading039"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course offers a
                                multitude of advantages for individuals looking
                                to embark on a rewarding career in data
                                analytics. Here are some key benefits:
                              </p>

                              <ul>
                                <li>
                                  <b>Comprehensive Learning:</b> Our course
                                  provides a comprehensive understanding of data
                                  analytics, covering essential concepts, tools,
                                  and techniques. You'll build a strong
                                  foundation and gain hands-on experience
                                  through real-world projects.
                                </li>
                                <li>
                                  <b>Data Manipulation Mastery:</b> Learn how to
                                  collect, clean, preprocess, and analyze data
                                  from various sources, ensuring it's ready for
                                  insightful analysis.
                                </li>
                                <li>
                                  <b>Statistical Expertise:</b> Develop
                                  proficiency in statistical analysis, enabling
                                  you to draw meaningful insights and make
                                  data-driven decisions.
                                </li>
                                <li>
                                  <b>Data Visualization Skills:</b> Master data
                                  visualization tools like Tableau and Power BI
                                  to create compelling charts and graphs that
                                  effectively communicate your findings.
                                </li>
                                <li>
                                  <b>Machine Learning Proficiency:</b> Explore
                                  machine learning algorithms and their
                                  applications, opening doors to predictive
                                  analytics and data-driven solutions.
                                </li>
                                <li>
                                  <b>Hands-on Projects:</b> Apply your skills to
                                  real-world projects, gaining practical
                                  experience and building a robust portfolio to
                                  showcase your expertise.
                                </li>
                                <li>
                                  <b>Business Acumen:</b> Develop a deep
                                  understanding of how data analytics aligns
                                  with business goals, enabling you to make
                                  strategic contributions to your organization.
                                </li>
                                <li>
                                  <b>Lucrative Career Prospects:</b> Enter a
                                  field with abundant job opportunities and
                                  competitive salaries. Data analytics roles are
                                  in high demand across various industries.
                                </li>
                              </ul>

                              <p>
                                With the data-driven future unfolding,
                                Logicmojo's Data Analytics Course equips you
                                with the knowledge and skills needed to thrive
                                in this dynamic landscape. Whether you're a
                                beginner or seeking to enhance your data
                                analytics capabilities, our course sets you on a
                                path toward a fulfilling and prosperous career,
                                with the opportunity to make a significant
                                impact on your organization's success.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading049">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse049"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                some popular languages in Data Analysis?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse049"
                            className="collapse"
                            aria-labelledby="heading049"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analysis relies on various programming
                                languages and tools to manipulate, analyze, and
                                visualize data effectively. Here are some
                                popular programming languages widely used in the
                                field:
                              </p>

                              <ul>
                                <li>
                                  <b>Python:</b> Python is a versatile and
                                  widely adopted language for data analysis. Its
                                  rich ecosystem of libraries, including NumPy,
                                  Pandas, and Matplotlib, makes it a favorite
                                  among data professionals for tasks like data
                                  manipulation, statistical analysis, and data
                                  visualization.
                                </li>
                                <li>
                                  <b>R:</b> R is another powerful language
                                  specifically designed for data analysis and
                                  statistical computing. It offers a vast
                                  collection of packages and libraries for data
                                  manipulation, visualization, and advanced
                                  statistical modeling.
                                </li>
                                <li>
                                  <b>SQL:</b> Structured Query Language (SQL) is
                                  essential for working with databases. It
                                  allows data analysts to retrieve, update, and
                                  manipulate data stored in relational databases
                                  efficiently.
                                </li>
                              </ul>

                              <p>
                                These programming languages serve as the
                                foundation for data analysis, enabling
                                professionals to extract valuable insights,
                                perform statistical analysis, and create
                                informative data visualizations. Proficiency in
                                one or more of these languages is a valuable
                                skill for data analysts and is typically covered
                                in Logicmojo's Data Analytics Course.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading059">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse059"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> what are
                                the job opportunities upon completing this Data
                                Analytics Certification Course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse059"
                            className="collapse"
                            aria-labelledby="heading059"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Upon successfully completing Logicmojo's Data
                                Analytics Certification Course, you will acquire
                                the essential data analytics skills that open
                                doors to a wide range of exciting career
                                opportunities in the data analytics field.
                                Beyond the Data Analyst role, here are some
                                other job titles that you can aspire to:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Analytics Manager/Lead:</b> Progress
                                  into a managerial role where you'll oversee
                                  data analytics teams, guide projects, and
                                  drive data-driven decision-making processes
                                  within organizations.
                                </li>
                                <li>
                                  <b>
                                    Business Analyst/Senior Business Analyst:
                                  </b>{" "}
                                  As a Business Analyst, you'll focus on
                                  analyzing business processes and identifying
                                  opportunities for improvement. Senior Business
                                  Analysts often lead complex projects and
                                  collaborate closely with stakeholders to
                                  achieve business goals.
                                </li>
                                <li>
                                  <b>Business Intelligence Analyst:</b>{" "}
                                  Specialize in business intelligence, where
                                  you'll create data-driven reports, dashboards,
                                  and visualizations to aid in strategic
                                  decision-making.
                                </li>
                                <li>
                                  <b>Business Intelligence Engineer:</b> Take on
                                  a role that involves designing and
                                  implementing data solutions to support
                                  business intelligence initiatives, integrating
                                  data from various sources, and optimizing data
                                  pipelines.
                                </li>
                                <li>
                                  <b> Managerial Roles:</b> Data analytics
                                  expertise is highly valued in managerial
                                  positions across industries. You may explore
                                  opportunities as a manager in areas such as
                                  marketing, finance, or operations, leveraging
                                  your data skills to drive success.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading069">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse069"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of companies hire Data analytics Professional?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse069"
                            className="collapse"
                            aria-labelledby="heading069"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics professionals are in high demand
                                across a wide spectrum of industries. Companies
                                from various sectors recognize the value of data
                                analysis in enhancing their processes, making
                                informed decisions, and driving innovation. Here
                                are some examples of industries that actively
                                hire data analytics professionals:
                              </p>

                              <ul>
                                <li>
                                  <b>Entertainment:</b> Entertainment companies
                                  use data analysis to understand audience
                                  preferences, optimize content distribution,
                                  and personalize user experiences.
                                </li>
                                <li>
                                  <b>Finance:</b> The financial sector relies on
                                  data analysts to assess risk, detect fraud,
                                  make investment decisions, and improve
                                  customer service.
                                </li>
                                <li>
                                  <b>Healthcare:</b> Healthcare organizations
                                  use data analytics for patient care
                                  improvement, resource allocation, and disease
                                  prevention.
                                </li>
                                <li>
                                  <b>Technology:</b> Tech companies leverage
                                  data analysts to enhance user experiences,
                                  optimize software and hardware performance,
                                  and drive product development.
                                </li>
                                <li>
                                  <b>Retail:</b> Retailers use data analysis to
                                  enhance inventory management, optimize pricing
                                  strategies, and personalize marketing efforts.
                                </li>
                              </ul>

                              <p>
                                These are just a few examples, and the demand
                                for data analytics professionals extends to
                                virtually every industry. As businesses
                                increasingly rely on data to make strategic
                                decisions and gain a competitive edge, the need
                                for skilled data analysts continues to grow.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading060">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse060"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What
                                projects are included in this Data Analytics
                                course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse060"
                            className="collapse"
                            aria-labelledby="heading060"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                The Data Analytics Certification Course offered
                                by Logicmojo provides hands-on experience
                                through a diverse range of 20+ real-life
                                projects. These projects span different domains,
                                allowing you to master various data analytics
                                concepts. Here are the project highlights:
                              </p>

                              <p>
                                <b>Capstone Project:</b>
                              </p>

                              <p>
                                As a culmination of your learning journey, you
                                will undertake a Capstone Project. This project
                                involves dedicated mentorship to solve an
                                industry-relevant problem using the skills and
                                technologies you've acquired throughout the
                                course. The Capstone Project covers all key
                                aspects of data analytics, from data extraction
                                and cleaning to visualization, model building,
                                and tuning. You even have the freedom to choose
                                a domain/industry dataset that aligns with your
                                interests and goals. Upon successful project
                                completion, you will receive a capstone
                                certificate, a testament to your expertise that
                                can impress potential employers.
                              </p>

                              <p>
                                <b>Course End Projects:</b>
                              </p>

                              <p>
                                Throughout the course, you will work on projects
                                designed to mimic real-world business problems,
                                reinforcing the concepts you've learned. These
                                projects typically take 3 - 4 hours to complete
                                and cover various domains:
                              </p>

                              <ol>
                                <li>
                                  <b>App Rating Recommendations:</b> Dive into
                                  the technology domain and build a model that
                                  predicts app ratings based on app information.
                                </li>
                                <li>
                                  <b>Comcast Telecom Customer Complaints:</b> In
                                  the telecommunications sector, use an existing
                                  customer complaints database to improve
                                  customer satisfaction.
                                </li>
                                <li>
                                  <b>E-commerce Sales Dashboard:</b> Assist an
                                  e-commerce company in designing a sales
                                  dashboard to analyze sales based on product
                                  categories.
                                </li>
                                <li>
                                  <b>Comparative Study of Countries:</b> In the
                                  geopolitical domain, create a dashboard for
                                  comparative country analysis using sample
                                  insurance data and world development
                                  indicators.
                                </li>
                                <li>
                                  <b>Sales Performance Analysis:</b> In the
                                  retail industry, build a dashboard to
                                  visualize monthly sales performance by product
                                  segment and category.
                                </li>
                                <li>
                                  <b>
                                    Analysis of Sales Report of a Clothing
                                    Manufacturer:
                                  </b>{" "}
                                  Dive into the manufacturing domain to automate
                                  product attribute recommendations, predict
                                  sales trends, and more.
                                </li>
                                <li>
                                  <b>College Admission:</b> In the education
                                  sector, analyze factors influencing student
                                  admissions to colleges in the U.S. to
                                  streamline the process.
                                </li>
                                <li>
                                  <b>
                                    Identifying and Recommending the Best
                                    Restaurants:
                                  </b>{" "}
                                  In the food domain, use data to identify
                                  high-star restaurants and generate
                                  recommendations.
                                </li>
                                <li>
                                  <b>Predicting Loan Defaulters:</b> Delve into
                                  banking by creating a credit risk scoring
                                  model to predict potential vehicle loan
                                  defaults.
                                </li>
                                <li>
                                  <b>
                                    Examining Factors Responsible for Heart
                                    Attacks:
                                  </b>{" "}
                                  In healthcare, study data to identify factors
                                  contributing to heart attacks and develop a
                                  predictive model.
                                </li>
                              </ol>

                              <p>
                                These projects offer practical experience,
                                allowing you to apply your data analytics skills
                                to real-world scenarios, enhancing your
                                proficiency and portfolio.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading099">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse099"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What
                                courses are taught in this data analytics
                                training?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse099"
                            className="collapse"
                            aria-labelledby="heading099"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                The Data Analytics Training provided by
                                Logicmojo encompasses a comprehensive curriculum
                                designed to equip you with a broad range of
                                skills and knowledge essential for a successful
                                career in data analytics. Here are the key
                                courses you'll master:
                              </p>

                              <ul>
                                <li>
                                  <b>Microsoft Excel for Data Analysis:</b>{" "}
                                  Learn to leverage Microsoft Excel for data
                                  manipulation, analysis, and visualization.
                                </li>
                                <li>
                                  <b>SQL for Data Analysis:</b> Acquire
                                  proficiency in Structured Query Language (SQL)
                                  for effective data retrieval and analysis from
                                  databases.
                                </li>
                                <li>
                                  <b>
                                    Introduction to Data Analytics and Statistics:
                                  </b>{" "}
                                  Gain a foundational understanding of data
                                  science principles and statistical concepts.
                                </li>
                                <li>
                                  <b>Presto (SQL Query Interface):</b> Explore
                                  Presto, a powerful SQL query interface used
                                  for querying data across various sources.
                                </li>
                                <li>
                                  <b>
                                    Data Analysis, Project Life Cycle, and Data
                                    Science in the Real World:
                                  </b>{" "}
                                  Understand the data analysis process, project
                                  management, and real-world applications of
                                  Data Analytics.
                                </li>
                                <li>
                                  <b>
                                    Techniques of Evaluation, Experimentation,
                                    and Project Deployment:
                                  </b>{" "}
                                  Learn how to evaluate data analytics projects,
                                  conduct experiments, and deploy solutions
                                  effectively.
                                </li>
                                <li>
                                  <b>Power BI:</b> Master Power BI, a leading
                                  data visualization tool, for creating
                                  insightful reports and dashboards.
                                </li>
                                <li>
                                  <b>Business Case Studies:</b> Analyze real
                                  business scenarios and case studies to apply
                                  data analytics concepts in practical settings.
                                </li>
                                <li>
                                  <b>Machine Learning Techniques:</b> Dive into
                                  machine learning and explore techniques for
                                  predictive modeling and data-driven
                                  decision-making.
                                </li>
                                <li>
                                  <b>Data Analyst Capstone Project:</b> Apply
                                  all your acquired skills to a comprehensive
                                  capstone project, addressing an
                                  industry-specific problem from data extraction
                                  to model building and deployment.
                                </li>
                              </ul>

                              <p>
                                This well-rounded curriculum ensures that you
                                gain the expertise needed to excel in data
                                analytics, from handling data with Excel and SQL
                                to advanced techniques in machine learning and
                                project management. The capstone project serves
                                as a practical culmination of your learning
                                journey, allowing you to showcase your skills to
                                potential employers.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading109">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse109"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How are
                                data analysts and business analysts different
                                from data scientists?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse109"
                            className="collapse"
                            aria-labelledby="heading109"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>
                                  Distinguishing Data Analysts, Business
                                  Analysts, and Data Scientists
                                </b>
                              </p>

                              <p>
                                Understanding the roles of data analysts,
                                business analysts, and data scientists is
                                crucial in the field of data analytics. Here are
                                key differences that set these roles apart:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Analysts:</b>
                                </li>
                                <ul>
                                  <li>
                                    Perform the complete life-cycle of data
                                    analysis.
                                  </li>
                                  <li>
                                    Focus on data cleaning, transformation, and
                                    visualization to derive actionable insights.
                                  </li>
                                  <li>
                                    Apply statistical and analytical techniques
                                    to understand historical data and make
                                    data-driven recommendations.
                                  </li>
                                </ul>
                                <li>
                                  <b>Business Analysts:</b>
                                </li>
                                <ul>
                                  <li>
                                    Implement, build, analyze, and report on the
                                    capabilities of the business.
                                  </li>
                                  <li>
                                    Translate business requirements into
                                    technical solutions and vice versa.
                                  </li>
                                  <li>
                                    Bridge the gap between business stakeholders
                                    and technical teams, ensuring alignment with
                                    organizational goals.
                                  </li>
                                </ul>
                                <li>
                                  <b>Data Scientists:</b>
                                </li>
                                <ul>
                                  <li>
                                    Focus on statistical analysis and machine
                                    learning to build predictive models and
                                    data-driven systems.
                                  </li>
                                  <li>
                                    Develop algorithms and models to extract
                                    insights and make predictions from data.
                                  </li>
                                  <li>
                                    Often involved in research and innovation to
                                    solve complex, open-ended problems.
                                  </li>
                                </ul>
                              </ul>

                              <p>
                                While data analysts delve into data manipulation
                                and visualization to generate insights, business
                                analysts act as intermediaries, connecting
                                business needs with technical solutions. Data
                                scientists, on the other hand, specialize in
                                advanced statistical analysis and machine
                                learning, aiming to build predictive models and
                                innovative data-driven solutions.
                              </p>

                              <p>
                                Each role plays a unique part in harnessing the
                                power of data to drive business decisions, with
                                varying degrees of technical depth and
                                specialization.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading119">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse119"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                average salary of a data analyst in India?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse119"
                            className="collapse"
                            aria-labelledby="heading119"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                For aspiring data analysts in India,
                                understanding the average salary in the field is
                                essential. According to Glassdoor, the average
                                annual salary for Data Analysts in India is
                                ₹6,48,045. However, this figure can vary based
                                on factors such as experience, location, and the
                                specific industry.
                              </p>

                              <p>
                                Additionally, data analysts may receive
                                additional cash compensation, which averages
                                around ₹66,545 per year, with a range spanning
                                from ₹30,000 to ₹1,10,000. These additional
                                earnings can come in the form of bonuses,
                                incentives, or other performance-based rewards.
                              </p>

                              <p>
                                It's worth noting that salary estimates are
                                derived from a dataset of 15,344 salaries
                                submitted anonymously by Data Analyst employees
                                in India. The variation in salaries reflects the
                                diversity of roles, industries, and regions in
                                the country. As you gain experience and
                                expertise in data analytics, your earning
                                potential in this dynamic field is likely to
                                increase.
                              </p>

                              <p>
                                These figures serve as valuable insights for
                                individuals considering a career in data
                                analytics and highlight the rewarding nature of
                                the profession.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading139">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse139"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>How should I
                                start to learn Data Analyst?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse139"
                            className="collapse"
                            aria-labelledby="heading139"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                If you're eager to embark on a journey into the
                                world of data analysis, there are foundational
                                steps to follow. Here's a roadmap to kickstart
                                your data analyst learning path:
                              </p>

                              <ul>
                                <li>
                                  <b>Learn Programming:</b> Start by acquiring
                                  proficiency in programming languages like
                                  Python and R. These languages serve as the
                                  bedrock of data analysis, providing the tools
                                  needed to manipulate and analyze data
                                  efficiently.
                                </li>
                                <li>
                                  <b>Master Key Skills:</b> Once you've grasped
                                  the programming basics, dive deeper into key
                                  data analysis skills, including:
                                </li>
                                <ul>
                                  <li>
                                    <b>Data Visualization:</b> Learn to create
                                    compelling visual representations of data to
                                    uncover patterns and insights.
                                  </li>
                                  <li>
                                    <b>Communication:</b> Enhance your ability
                                    to convey complex findings effectively to
                                    both technical and non-technical
                                    stakeholders.
                                  </li>
                                  <li>
                                    <b>Problem-Solving:</b> Develop
                                    problem-solving skills to tackle real-world
                                    data challenges methodically.
                                  </li>
                                  <li>
                                    <b>Data Cleansing:</b> Understand the
                                    importance of data cleaning to ensure the
                                    quality and reliability of your data.
                                  </li>
                                  <li>
                                    <b>Data Warehouse:</b> Familiarize yourself
                                    with data warehousing concepts to
                                    efficiently store and manage large datasets.
                                  </li>
                                  <li>
                                    <b>Analytical Skills:</b> Hone your
                                    analytical prowess to dissect data, derive
                                    meaningful insights, and make data-driven
                                    decisions.
                                  </li>
                                </ul>
                              </ul>

                              <p>
                                As a beginner, it's essential to build a strong
                                foundation in these areas. Once you've gained
                                proficiency in programming and core data
                                analysis skills, you can apply your newfound
                                knowledge to real-time problem-solving. Data
                                analysis is a dynamic field, and continuous
                                learning and practical application will be key
                                to your success.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab025" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is Pursuing a
                            Data Analytics Certification Worthwhile for Your
                            Career?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Undoubtedly, the pursuit of a Data Analytics
                            Certification can be a game-changer for your career
                            trajectory. Here's why:
                          </p>

                          <ul>
                            <li>
                              <b>Industry Recognition:</b> A reputable
                              certification in data analytics is widely
                              recognized and respected by employers across
                              various sectors. It serves as tangible proof of
                              your expertise in handling data and deriving
                              actionable insights.
                            </li>
                            <li>
                              <b>Competitive Advantage:</b> In a job market
                              where data skills are in high demand,
                              certification sets you apart from competitors. It
                              not only validates your knowledge but also
                              demonstrates your commitment to staying current in
                              a rapidly evolving field.
                            </li>
                            <li>
                              <b>Career Opportunities:</b> Holding a data
                              analytics certification opens doors to a diverse
                              range of career opportunities. Data analysts are
                              sought after in nearly every industry, from
                              finance to healthcare, offering the flexibility to
                              choose a career path that aligns with your
                              interests.
                            </li>
                            <li>
                              <b>Skill Enhancement:</b> Certification programs
                              are designed to cover a comprehensive curriculum,
                              equipping you with essential skills in data
                              analysis, visualization, and interpretation.
                              You'll gain hands-on experience and the ability to
                              solve complex data-related challenges.
                            </li>
                            <li>
                              <b>Professional Network:</b> Enrolling in a
                              certification course often connects you with a
                              network of fellow learners, instructors, and
                              industry experts. This network can prove
                              invaluable for mentorship, collaboration, and
                              career advancement.
                            </li>
                          </ul>

                          <p>
                            At Logicmojo, our data analytics certification
                            course offers a well-structured curriculum, hands-on
                            projects, and the guidance of experienced
                            instructors, ensuring you gain the expertise and
                            confidence to thrive in the world of data analytics.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> will i be able
                            to get the certification?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            If you're wondering whether you'll be able to obtain
                            a certification through Logicmojo's data analytics
                            course, the answer is a resounding "Yes!" We're
                            committed to recognizing your hard work and
                            dedication to mastering data analytics. Upon
                            successful completion of our course, you will
                            receive not one, but three valuable certificates:
                          </p>

                          <ul>
                            <li>
                              <b>Course Completion Certificate:</b> This
                              certificate acknowledges your successful journey
                              through our data analytics course. It signifies
                              your commitment to learning and mastering
                              essential data analysis skills.
                            </li>
                            <li>
                              <b>Internship Onboarding Certificate:</b> As part
                              of our comprehensive program, you'll receive an
                              internship onboarding certificate, highlighting
                              your readiness to apply your knowledge in
                              real-world scenarios.
                            </li>
                            <li>
                              <b>Internship Completion Certificate:</b> Upon
                              successfully completing your internship
                              experience, you'll be awarded an internship
                              completion certificate. This testament to your
                              practical skills demonstrates your readiness for a
                              career in data analytics.
                            </li>
                          </ul>

                          <p>
                            Our certification process is designed to empower you
                            with the credentials and confidence you need to
                            thrive in the data analytics field. Rest assured
                            that Logicmojo is here to support your learning
                            journey and celebrate your achievements.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How is the
                            certificate awarded?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo's Data Analytics Course, we take pride
                            in recognizing your dedication and proficiency in
                            the field of data analytics. Our certification
                            process is designed to acknowledge your achievements
                            and provide you with a prestigious credential.
                            Here's how the certification is awarded:
                          </p>

                          <ol>
                            <li>
                              <b>Complete Course Modules and Assignments:</b>{" "}
                              Your journey toward certification begins with
                              thorough learning, hands-on projects, and
                              assessments. Ensure that you successfully complete
                              all the course modules and assignments to
                              demonstrate your mastery of the subject matter.
                            </li>
                            <li>
                              <b>Meet Attendance and Participation Criteria:</b>{" "}
                              Active participation in the program is vital.
                              Engage in interactive sessions, workshops, and
                              discussions, and meet the attendance and
                              participation criteria set by the course. This
                              involvement is integral to earning your
                              certification.
                            </li>
                            <li>
                              <b>Pass Assessments and Examinations:</b> Some
                              courses may include assessments and examinations
                              to assess your understanding of the material.
                              Passing these evaluations is a significant
                              milestone on your path to certification.
                            </li>
                            <li>
                              <b>Fulfill Additional Requirements:</b> Depending
                              on the specific program, there may be additional
                              prerequisites, such as project submissions,
                              portfolio development, or practical
                              demonstrations. Ensure that you fulfill all such
                              criteria as outlined in the course.
                            </li>
                            <li>
                              <b>Receive Your Certificate:</b> Once you've
                              successfully met all the prerequisites and
                              completed the program in its entirety, Logicmojo
                              Academy will proudly award you with a certificate.
                              This certificate serves as a tangible
                              representation of your Data Analysis expertise,
                              signifying your dedication and proficiency to
                              potential employers and the professional
                              community.
                            </li>
                          </ol>

                          <p>
                            Receiving a certificate from Logicmojo Academy not
                            only validates your hard work and commitment but
                            also elevates your career prospects in the field of
                            data analytics. It's a recognition of your expertise
                            and an invaluable asset as you embark on a rewarding
                            journey in the data-driven world.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            prerequisites for taking this online data analytics
                            certification?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            When it comes to pursuing an online Data Analytics
                            Certification with Logicmojo, we prioritize
                            accessibility and inclusivity. We want to make sure
                            that aspiring data analysts can embark on this
                            learning journey without unnecessary barriers.
                            Here's the scoop on prerequisites:
                          </p>

                          <ul>
                            <li>
                              <b>No Formal Prerequisites:</b> We believe in
                              democratizing access to education. That's why we
                              have intentionally designed our online data
                              analytics courses to have no formal prerequisites.
                              Whether you come from a technical or non-technical
                              background, you are welcome to enroll.
                            </li>
                            <li>
                              <b>Beneficial Background:</b> While there are no
                              strict prerequisites, having a basic understanding
                              of data analysis, statistics, and probability can
                              be advantageous. These foundational concepts may
                              help you grasp the course material more quickly
                              and comfortably.
                            </li>
                          </ul>

                          <p>
                            At Logicmojo, we are committed to providing a
                            supportive and inclusive learning environment. Our
                            data analytics certification is open to learners
                            from various educational backgrounds, ensuring that
                            anyone with a passion for data analysis can pursue
                            this valuable certification.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            benefits of obtaining the certification?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Obtaining a Data Analytics Certification with
                            Logicmojo is a significant milestone that offers
                            numerous advantages to boost your career. Here are
                            some compelling benefits:
                          </p>

                          <ul>
                            <li>
                              <b>Industry Recognition:</b> Logicmojo's
                              certification is well-regarded in the industry,
                              serving as a recognized testament to your data
                              analytics expertise. It signifies that you have
                              acquired the knowledge and skills needed to excel
                              in this dynamic field.
                            </li>
                            <li>
                              <b>Competitive Edge:</b> In a job market where
                              data skills are highly sought after, certification
                              sets you apart from the competition. It not only
                              validates your proficiency but also showcases your
                              commitment to staying updated in a rapidly
                              evolving field.
                            </li>
                            <li>
                              <b>Diverse Career Opportunities:</b> Data analysts
                              are in demand across various industries, offering
                              you the flexibility to choose a career path that
                              aligns with your interests. Whether you aspire to
                              work in finance, healthcare, or technology,
                              certification opens doors to diverse job
                              prospects.
                            </li>
                            <li>
                              <b>Skill Enhancement:</b> Our certification
                              program covers a comprehensive curriculum,
                              equipping you with essential data analysis,
                              visualization, and interpretation skills. You'll
                              gain practical experience and the ability to solve
                              complex data-related challenges.
                            </li>
                            <li>
                              <b>Professional Network:</b> Enrolling in our
                              certification course connects you with a network
                              of fellow learners, experienced instructors, and
                              industry experts. This network can be invaluable
                              for mentorship, collaboration, and career
                              advancement.
                            </li>
                          </ul>

                          <p>
                            By earning a Data Analytics Certification with
                            Logicmojo, you not only validate your hard work and
                            commitment but also gain a valuable credential that
                            can elevate your career prospects in the data-driven
                            world. It's a recognition of your expertise and a
                            significant step towards a successful and rewarding
                            career in data analytics.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading05">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse05"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> is this course
                            required any prior programming knowledge?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse05"
                        className="collapse"
                        aria-labelledby="heading05"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            One of the most common concerns among aspiring data
                            analysts is whether prior programming knowledge is
                            required to excel in Logicmojo's Data Analytics
                            Course. Here's the lowdown:
                          </p>

                          <ul>
                            <li>
                              <b>No Prerequisite Programming Knowledge:</b> We
                              are committed to making our data analytics course
                              accessible to a wide range of learners. As such,
                              there is no strict requirement for prior
                              programming knowledge. Our course is designed to
                              accommodate both beginners and individuals with
                              some programming background.
                            </li>
                            <li>
                              <b>Accessible Learning Path:</b> Whether you're
                              new to programming or have some familiarity with
                              it, our curriculum is structured to provide a
                              smooth and supportive learning experience. We
                              start from the basics and gradually build your
                              programming skills as you progress through the
                              course.
                            </li>
                            <li>
                              <b>Beneficial for All Levels:</b> If you do have
                              prior programming knowledge, it can be
                              advantageous as you may find certain aspects of
                              the course more familiar. However, our course is
                              thoughtfully crafted to cater to learners with
                              varying levels of programming expertise.
                            </li>
                          </ul>

                          <p>
                            At Logicmojo, our goal is to empower learners from
                            diverse backgrounds to embark on a rewarding journey
                            in data analytics. Whether you're a programming
                            novice or have some experience under your belt, our
                            course is designed to help you build the skills and
                            knowledge needed to excel in the world of data
                            analytics.
                          </p>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How will I
                                benefit from Industry Mentors?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course offers a
                                unique opportunity to connect with industry
                                mentors, and you may wonder how this can enhance
                                your learning experience. Here's how you'll
                                benefit from having industry mentors by your
                                side:
                              </p>

                              <ul>
                                <li>
                                  <b>Real-World Insights:</b> Our industry
                                  mentors bring years of practical experience to
                                  the table. They can offer invaluable insights
                                  into the real-world application of data
                                  analytics, sharing their experiences,
                                  challenges, and solutions from the field.
                                </li>
                                <li>
                                  <b>Guidance and Mentorship:</b> Industry
                                  mentors serve as guides on your learning
                                  journey. They can provide personalized advice,
                                  clarify concepts, and help you navigate
                                  complex data analysis scenarios, accelerating
                                  your understanding and growth.
                                </li>
                                <li>
                                  <b>Networking Opportunities:</b> Interacting
                                  with industry mentors exposes you to a
                                  professional network that can be instrumental
                                  in your career. You may forge valuable
                                  connections, receive career advice, or even
                                  explore internship and job opportunities
                                  through these connections.
                                </li>
                                <li>
                                  <b>Stay Updated:</b> Data analytics is a
                                  dynamic field with evolving technologies and
                                  practices. Industry mentors keep you up to
                                  date with the latest trends, tools, and best
                                  practices, ensuring that your knowledge
                                  remains relevant and cutting-edge.
                                </li>
                                <li>
                                  <b>Practical Project Guidance:</b> When
                                  working on industry projects, having mentors
                                  to guide you can significantly impact your
                                  project's quality and success. Their expertise
                                  can help you tackle real-world challenges
                                  effectively.
                                </li>
                              </ul>

                              <p>
                                Industry mentors play a pivotal role in bridging
                                the gap between theory and practice. Their
                                mentorship not only enriches your learning
                                experience but also equips you with the skills,
                                knowledge, and connections needed to thrive in
                                the data analytics industry.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Why Online
                                Data Analytics Course is better than offline?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Choosing between online and offline data
                                analytics courses is a significant decision, and
                                it's important to understand the advantages of
                                online learning. Here's why Logicmojo's Online
                                Data Analytics Course stands out:
                              </p>

                              <ul>
                                <li>
                                  <b>Flexibility and Convenience:</b> Online
                                  courses offer unmatched flexibility, allowing
                                  you to learn at your own pace and on your
                                  schedule. Whether you're a working
                                  professional or a student, you can access
                                  course materials anytime, anywhere,
                                  eliminating the need for a fixed classroom
                                  schedule.
                                </li>
                                <li>
                                  <b>Accessibility:</b> Online courses break
                                  down geographical barriers. You can enroll in
                                  Logicmojo's course regardless of your
                                  location, providing access to top-quality
                                  education and industry mentors no matter where
                                  you are.
                                </li>
                                <li>
                                  <b>Cost-Effective:</b> Online courses often
                                  come at a lower cost than traditional offline
                                  programs. You can save on commuting,
                                  accommodation, and material expenses, making
                                  education more affordable.
                                </li>
                                <li>
                                  <b>Personalized Learning:</b> Logicmojo's
                                  online course offers personalized learning
                                  experiences. You can revisit lectures, pause
                                  and rewind, and delve deeper into topics that
                                  require additional understanding, tailoring
                                  your learning to your needs.
                                </li>
                                <li>
                                  <b>Industry Experts and Mentors:</b> Online
                                  courses like Logicmojo's provide access to
                                  industry mentors who bring real-world insights
                                  to your learning. This exposure to experts in
                                  the field can be challenging to replicate in
                                  offline settings.
                                </li>
                                <li>
                                  <b>Peer Interaction:</b> Online platforms
                                  facilitate interaction with a diverse group of
                                  peers from around the world. Engaging in
                                  discussions, sharing experiences, and
                                  collaborating on projects can broaden your
                                  perspective and enrich your learning journey.
                                </li>
                                <li>
                                  <b>Continuous Support:</b> Online courses
                                  often offer comprehensive support, including
                                  forums, chat, email, and mentorship. You're
                                  never alone in your learning journey, and
                                  assistance is just a click away.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading08">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse08"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is coding
                                required to learn Data Analytics course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse08"
                            className="collapse"
                            aria-labelledby="heading08"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                One common question that arises when considering
                                a Data Analytics course is whether coding skills
                                are necessary. Let's delve into this aspect to
                                provide clarity:
                              </p>

                              <p>
                                <b>Coding as a Valuable Skill:</b> While coding
                                is not always a strict requirement for
                                introductory Data Analytics courses, it is an
                                incredibly valuable skill to possess in the
                                field. Coding languages like Python and R are
                                commonly used in data analysis due to their
                                versatility, powerful libraries, and data
                                manipulation capabilities.
                              </p>

                              <p>
                                <b>Python and R for Data Analytics:</b>{" "}
                                Logicmojo's Data Analytics Course emphasizes the
                                importance of Python and R programming
                                languages. These languages play a pivotal role
                                in data preprocessing, statistical analysis,
                                data visualization, and machine learning tasks.
                                Learning them can significantly enhance your
                                ability to analyze and interpret data
                                effectively.
                              </p>

                              <p>
                                <b>Advantages of Coding Skills:</b> Here's why
                                coding skills are advantageous in Data
                                Analytics:
                              </p>

                              <ul>
                                <li>
                                  <b>Data Manipulation:</b> Coding allows you to
                                  manipulate and clean large datasets
                                  efficiently, a crucial step in the data
                                  analysis process.
                                </li>
                                <li>
                                  <b>Statistical Analysis:</b> Python and R
                                  offer rich libraries for statistical analysis,
                                  hypothesis testing, and regression modeling.
                                </li>
                                <li>
                                  <b>Data Visualization:</b> You can create
                                  compelling visualizations using coding, making
                                  it easier to communicate your findings.
                                </li>
                                <li>
                                  <b>Machine Learning:</b> Coding is essential
                                  for implementing machine learning algorithms,
                                  enabling predictive modeling and data-driven
                                  decision-making.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Does the
                                course offer any specialized or optional
                                certifications in specific areas of data
                                analytics?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                As you explore Logicmojo's Data Analytics
                                Course, you may wonder whether it offers
                                specialized or optional certifications in
                                specific areas of data analytics. Let's dive
                                into this aspect to provide you with a clear
                                understanding:
                              </p>

                              <p>
                                <b>Focus on Comprehensive Learning:</b>{" "}
                                Logicmojo's Data Analytics Course is designed to
                                provide you with a strong foundation in data
                                analytics, covering a wide range of topics
                                essential for a successful career in this field.
                                The course curriculum includes:
                              </p>

                              <ul>
                                <li>Microsoft Excel for data analysis</li>
                                <li>SQL for data analysis</li>
                                <li>
                                  Introduction to Data Analytics and statistics
                                </li>
                                <li>Presto (SQL Query Interface)</li>
                                <li>
                                  Data analysis, project life cycle, and data
                                  science in the real world
                                </li>
                                <li>
                                  Techniques of evaluation, experimentation, and
                                  project deployment
                                </li>
                                <li>Power BI</li>
                                <li>Business case studies</li>
                                <li>Machine learning techniques</li>
                                <li>Data Analyst capstone project</li>
                              </ul>

                              <p>
                                <b>Comprehensive Skill Set:</b> By completing
                                this course, you will acquire a comprehensive
                                skill set in data analytics, including data
                                analysis, statistical knowledge, data
                                storytelling, and machine learning techniques.
                                This broad knowledge base prepares you for
                                various roles in data analytics.
                              </p>

                              <p>
                                <b>Industry-Relevant Expertise:</b> Logicmojo's
                                course focuses on providing you with the skills
                                and knowledge that are in high demand across
                                industries. The curriculum is designed to ensure
                                that you can excel in roles such as Data
                                Analyst, Business Intelligence Analyst, and
                                more.
                              </p>

                              <p>
                                <b>Optional Certifications:</b> While the course
                                itself doesn't offer specialized or optional
                                certifications in specific areas of data
                                analytics, the skills and knowledge you gain are
                                highly valuable and can be applied to a wide
                                range of scenarios. Additionally, you may
                                explore specialized certifications in specific
                                areas of interest after completing the course to
                                further enhance your expertise.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Do I need a
                                computer science background to enroll for this
                                course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                If you're considering enrolling in Logicmojo's
                                Data Analytics Course, you may be wondering
                                whether a computer science background is
                                necessary. Let's address this question to help
                                you make an informed decision:
                              </p>

                              <p>
                                <b>No Computer Science Background Required:</b>{" "}
                                The beauty of Logicmojo's Data Analytics Course
                                is its accessibility to individuals from diverse
                                educational backgrounds. You do not need a
                                computer science background to enroll in this
                                course. Whether you come from a technical or
                                non-technical field, you can pursue a career in
                                data analytics.
                              </p>

                              <p>
                                <b>Foundational Knowledge:</b> While a computer
                                science background is not a requirement, having
                                some foundational knowledge of mathematics,
                                statistics, and logical reasoning can be
                                advantageous. These skills can help you grasp
                                certain concepts more easily during the course.
                              </p>

                              <p>
                                <b>Comprehensive Learning:</b> The course is
                                structured to provide comprehensive learning,
                                starting from the basics and gradually building
                                your expertise. You'll receive training in
                                essential areas such as data analysis,
                                statistical analysis, data visualization, and
                                machine learning techniques.
                              </p>

                              <p>
                                <b>Real-World Application:</b> Logicmojo's Data
                                Analytics Course is designed to prepare you for
                                real-world scenarios. The skills you acquire can
                                be applied in various industries, including
                                finance, healthcare, marketing, and more. The
                                focus is on practical skills that make you
                                job-ready.
                              </p>

                              <p>
                                <b>Guidance and Support:</b> Throughout the
                                course, you'll have access to industry mentors
                                who can provide guidance and support, regardless
                                of your educational background. They can assist
                                you in mastering the skills needed to succeed in
                                the data analytics field.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                process of Admission in Data Analytics Course ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                If you're considering enrolling in Logicmojo's
                                Data Analytics Course, you'll find that the
                                admission process is designed to be
                                straightforward and hassle-free. Here's a
                                step-by-step overview of how to get started:
                              </p>

                              <ol>
                                <li>
                                  Visit our official website and navigate to the
                                  Data Analytics Course page.
                                </li>
                                <li>
                                  Click on the "Apply Now" button to initiate
                                  your application process.
                                </li>
                                <li>
                                  Complete the application form by providing
                                  your relevant details and submit it.
                                </li>
                                <li>
                                  Once your application is submitted, our
                                  dedicated admissions team will carefully
                                  review it.
                                </li>
                                <li>
                                  If your application is accepted, you will
                                  receive further instructions regarding the
                                  enrollment process and payment details.
                                </li>
                                <li>
                                  Upon successful enrollment, you'll gain access
                                  to an exciting and enriching journey in the
                                  field of Data Analytics with Logicmojo!
                                </li>
                              </ol>
                              <p>
                                Take the first step towards a rewarding career
                                in data analytics by applying to Logicmojo's
                                Data Analytics Course today!
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>How much
                                attendance is mandatory for completing of the
                                course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's courses do not impose a mandatory
                                attendance policy. You have the flexibility to
                                choose between attending live sessions or
                                learning at your own pace through recorded
                                lectures.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is Data
                                Analytics Course Suitable for Freshers?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Yes, the Data Analytics Course at Logicmojo is
                                highly suitable for freshers who are eager to
                                embark on a rewarding career in the field of
                                data analytics. Here are a few compelling
                                reasons why this course is an excellent choice
                                for individuals who are new to the industry:
                              </p>

                              <ul>
                                <li>
                                  <b>No Prerequisites:</b> Our Data Analytics
                                  Course has no prerequisites, making it
                                  accessible to beginners with limited or no
                                  prior experience in the field.
                                </li>
                                <li>
                                  <b>Comprehensive Learning:</b> The course
                                  covers a wide range of topics, starting from
                                  the fundamentals and gradually progressing to
                                  advanced concepts. This approach ensures that
                                  freshers receive a well-rounded education in
                                  data analytics.
                                </li>
                                <li>
                                  <b>Industry-Relevant Projects:</b> Throughout
                                  the course, students have the opportunity to
                                  work on real-life projects in various domains.
                                  This practical experience helps freshers build
                                  a strong portfolio and gain practical skills.
                                </li>
                                <li>
                                  <b>Mentorship:</b> Logicmojo provides industry
                                  mentors who guide and support students,
                                  helping them bridge the gap between
                                  theoretical knowledge and practical
                                  application.
                                </li>
                                <li>
                                  <b>Job Placement Assistance:</b> We offer job
                                  placement assistance to help freshers
                                  kickstart their careers. Our tie-ups with 50+
                                  companies provide ample job opportunities.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> You May
                                Question If Data Analytics Certification Is
                                Worth It ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Undoubtedly, pursuing a Data Analytics
                                Certification can be a highly valuable
                                investment in your career. Here are compelling
                                reasons why obtaining a certification in data
                                analytics is worthwhile:
                              </p>
                              <ul>
                                <li>
                                  <b>High Demand:</b> The field of data
                                  analytics is experiencing unprecedented
                                  growth, with a shortage of skilled
                                  professionals. Organizations across various
                                  industries seek data analysts to extract
                                  insights from their data, making it a
                                  lucrative career choice.
                                </li>
                                <li>
                                  <b>Lucrative Salaries:</b> Data analysts
                                  typically earn competitive salaries, and
                                  certified professionals often command higher
                                  pay than their non-certified counterparts.
                                </li>
                                <li>
                                  <b>Increased Job Opportunities:</b> Data
                                  analytics certifications enhance your
                                  marketability and open doors to a wide range
                                  of job opportunities in sectors such as
                                  finance, healthcare, technology, and more.
                                </li>
                                <li>
                                  <b>Skill Validation:</b> Certification
                                  validates your data analysis skills, giving
                                  you credibility and demonstrating your
                                  expertise to potential employers.
                                </li>
                                <li>
                                  <b>Structured Learning:</b> Data analytics
                                  certification programs provide structured and
                                  comprehensive learning paths, ensuring you
                                  acquire the necessary knowledge and skills to
                                  excel in the field.
                                </li>
                                <li>
                                  <b>Hands-On Experience:</b> Many certification
                                  programs include practical projects and
                                  hands-on experience, allowing you to apply
                                  your skills in real-world scenarios.
                                </li>
                                <li>
                                  <b>Networking Opportunities:</b> Certification
                                  courses often provide access to a network of
                                  industry professionals, mentors, and peers,
                                  fostering valuable connections for your
                                  career.
                                </li>
                                <li>
                                  <b>Career Advancement:</b> With a data
                                  analytics certification, you're better
                                  positioned for career advancement and can
                                  explore roles such as senior data analyst,
                                  data scientist, or analytics manager.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading16">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse16"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Are there
                                any additional fees associated with obtaining or
                                maintaining the certification?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse16"
                            className="collapse"
                            aria-labelledby="heading16"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                When considering pursuing a Data Analytics
                                Certification, it's essential to understand the
                                potential associated costs. The good news is
                                that with Logicmojo's Data Analytics Course,
                                there are <b>no additional fees</b> beyond the
                                course tuition. This means that once you enroll
                                in the program and pay the specified tuition,
                                you won't encounter any hidden or supplementary
                                charges related to certification.
                              </p>

                              <p>
                                This transparent and straightforward fee
                                structure ensures that you can focus on your
                                learning journey without worrying about
                                unexpected financial burdens. It reflects
                                Logicmojo's commitment to providing accessible
                                and affordable education in the field of data
                                analytics.
                              </p>

                              <p>
                                Before enrolling in any certification program,
                                it's advisable to inquire about the fee
                                structure to make informed decisions about your
                                investment in your education and career.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading17">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse17"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Is
                                Logicmojo's Data Analyitcs Course Exclusively
                                for Computer Science or Mathematics Backgrounds?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse17"
                            className="collapse"
                            aria-labelledby="heading17"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course is designed to
                                be inclusive and welcomes individuals from a
                                wide range of educational backgrounds. Contrary
                                to the misconception that data analytics is
                                exclusively for those with computer science or
                                mathematics backgrounds, this course is open to
                                anyone with an interest in data analysis and the
                                motivation to learn.
                              </p>

                              <p>
                                Whether you come from a computer science,
                                mathematics, engineering, business, or even
                                non-technical background, you can benefit from
                                this course. Data analytics is a versatile field
                                that requires diverse skills, including data
                                interpretation, problem-solving, and
                                communication, making it accessible to
                                individuals with different educational
                                experiences.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading18">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse18"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                validity period of the certification, and is
                                there an option for renewal or recertification?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse18"
                            className="collapse"
                            aria-labelledby="heading18"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course offers you the
                                advantage of a certification with lifetime
                                validity. This means that once you successfully
                                complete the course and earn your certification,
                                it remains valid indefinitely. You won't have to
                                worry about expiration dates or the need for
                                renewal or recertification.
                              </p>

                              <p>
                                The lifetime validity of the certification
                                reflects our commitment to providing you with a
                                lasting credential that you can proudly showcase
                                throughout your career. Whether you choose to
                                embark on a data analytics career immediately or
                                down the line, your Logicmojo certification will
                                continue to hold its value.
                              </p>

                              <p>
                                You can confidently add your Logicmojo Data
                                Analytics Course certification to your resume,
                                LinkedIn profile, and professional portfolio,
                                knowing that it remains relevant and recognized
                                in the industry for years to come. This ensures
                                that you enjoy the benefits of your
                                certification throughout your career journey.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading19">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse19"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What will
                                be the schedule of Live Classes ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse19"
                            className="collapse"
                            aria-labelledby="heading19"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <b>Frequent Live Classes:</b>

                              <p>
                                At Logicmojo, we understand the importance of
                                live interaction and real-time learning. That's
                                why our Data Analytics Course features frequent
                                live classes. These live sessions are typically
                                scheduled twice a week, providing ample
                                opportunities for engagement and learning. We
                                believe that live classes foster an interactive
                                and dynamic learning environment, allowing you
                                to actively participate, ask questions, and
                                receive immediate feedback.
                              </p>

                              <b>Flexible Timings:</b>

                              <p>
                                We recognize that our learners have diverse
                                schedules and commitments. To cater to the needs
                                of our software engineer learners, our live
                                classes are conveniently held in the late
                                evening or night on weekdays. This flexibility
                                ensures that you can join our live sessions
                                without disrupting your daily routine, making it
                                easier to balance your professional and
                                educational pursuits.
                              </p>

                              <b>Weekend Options:</b>

                              <p>
                                For added flexibility and convenience, we also
                                offer live classes at suitable times over the
                                weekends. We understand that weekends may be
                                your preferred time for focused learning, and
                                our weekend live sessions are designed to
                                accommodate this. Whether you're working on
                                weekdays or simply prefer weekend classes,
                                you'll find options that fit your schedule.
                              </p>

                              <p>
                                Our commitment to providing flexible live class
                                schedules reflects our dedication to making
                                quality education accessible to a wide range of
                                learners. Whether you're a working professional,
                                a student, or someone with various
                                responsibilities, our flexible live class
                                timings ensure that you can participate actively
                                and benefit from our Data Analytics Course.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading20">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse20"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can you
                                provide more details about the assessment
                                criteria for earning the certification?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse20"
                            className="collapse"
                            aria-labelledby="heading20"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                At Logicmojo, we have established a
                                comprehensive assessment framework to ensure
                                that you gain the skills and knowledge necessary
                                to earn your Data Analytics Certification. Our
                                assessment criteria are designed to evaluate
                                your proficiency and understanding of data
                                analytics concepts. Here's an overview of the
                                assessment components:
                              </p>

                              <ul>
                                <li>
                                  <b>Course Modules and Assignments:</b>{" "}
                                  Throughout the course, you'll engage in
                                  various modules and assignments that cover a
                                  wide range of data analytics topics.
                                  Successful completion of these assignments
                                  demonstrates your ability to apply the
                                  knowledge you've gained in practical
                                  scenarios.
                                </li>

                                <li>
                                  <b>Attendance and Participation:</b> Active
                                  participation in the program is crucial to
                                  meeting the course's criteria for
                                  certification. This includes attending live
                                  classes, engaging in interactive sessions,
                                  workshops, and discussions, and actively
                                  contributing to the learning community.
                                </li>

                                <li>
                                  <b>Assessments and Examinations:</b> Depending
                                  on the course, you may be required to complete
                                  assessments and examinations to evaluate your
                                  understanding of the material. These
                                  assessments are designed to test your
                                  knowledge and problem-solving skills in the
                                  field of data analytics.
                                </li>

                                <li>
                                  <b>Additional Requirements:</b> In some cases,
                                  there may be additional requirements such as
                                  project submissions, portfolio development, or
                                  practical demonstrations. Meeting these
                                  additional criteria demonstrates your ability
                                  to apply data analytics concepts in real-world
                                  scenarios.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading21">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse21"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                job placement rate for graduates of the course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse21"
                            className="collapse"
                            aria-labelledby="heading21"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                One of the key indicators of the success of
                                Logicmojo's Data Analytics Course is the job
                                placement rate for our graduates. We take
                                immense pride in our commitment to helping our
                                students achieve their career goals in the field
                                of data analytics. Here are some insights into
                                our job placement rate:
                              </p>

                              <ul>
                                <li>
                                  <b>High Placement Success:</b> Logicmojo's
                                  Data Analytics Course boasts a remarkable job
                                  placement rate, with a significant percentage
                                  of our graduates successfully securing
                                  positions in reputable organizations.
                                </li>

                                <li>
                                  <b>Industry Connections:</b> Our strong
                                  industry connections and partnerships play a
                                  pivotal role in facilitating job placements
                                  for our students. We collaborate with a wide
                                  range of companies, from startups to
                                  established enterprises, to create career
                                  opportunities for our graduates.
                                </li>

                                <li>
                                  <b>Internship Programs:</b> To enhance
                                  employability, we offer internship
                                  opportunities to our learners, allowing them
                                  to gain practical experience and build a
                                  strong professional network. Many students
                                  transition into full-time roles at the
                                  companies where they interned.
                                </li>

                                <li>
                                  <b>Comprehensive Career Support:</b> Logicmojo
                                  provides comprehensive career support
                                  services, including resume building, interview
                                  preparation, and job search assistance. Our
                                  career services team is dedicated to helping
                                  you succeed in your job search.
                                </li>
                              </ul>
                              <p>
                                For specific placement statistics and success
                                stories, we encourage you to reach out to our
                                admissions or career services team for the most
                                up-to-date information.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab026" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What types of
                            job assistance are provided in the course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Data Analytics Course is committed to not only
                            equipping you with the essential skills and
                            knowledge for a successful career in data analytics
                            but also to support you in your job search and
                            career advancement. We offer a comprehensive range
                            of job assistance services to empower you in
                            achieving your professional goals:
                          </p>

                          <ul>
                            <li>
                              <b>Resume Building:</b> Crafting an impressive and
                              tailored resume is a crucial step in your job
                              search. Our career services team provides guidance
                              and resources to help you create a compelling
                              resume that highlights your qualifications and
                              achievements.
                            </li>

                            <li>
                              <b>Interview Preparation:</b> Mastering the art of
                              interviews is essential. We offer interview
                              coaching, conduct mock interviews, and provide
                              tips on answering common interview questions. This
                              preparation ensures that you enter interviews with
                              confidence.
                            </li>

                            <li>
                              <b>Job Search Support:</b> We assist you in your
                              job search by providing job postings, industry
                              insights, and guidance on how to find job openings
                              that align with your career objectives.
                            </li>

                            <li>
                              <b>Career Counseling:</b> Our career advisors are
                              available to provide personalized guidance and
                              advice on your career path. They can help you make
                              informed decisions about your professional
                              journey.
                            </li>

                            <li>
                              <b>Internship Opportunities:</b> Many students
                              benefit from internship programs offered as part
                              of the course. These internships can serve as a
                              stepping stone to full-time roles and provide you
                              with valuable work experience.
                            </li>

                            <li>
                              <b>Networking Events:</b> Building a professional
                              network is vital in the data analytics industry.
                              We organize networking events and connect you with
                              industry professionals and potential employers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Could someone
                            help me do mock interviews?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, at Logicmojo, we offer mock interview support
                            as part of our comprehensive job assistance program.
                            You can benefit from the experience and guidance of
                            our career services team to conduct mock interviews.
                            These practice interviews are designed to help you
                            prepare for real job interviews effectively. Our
                            experts will provide you with valuable feedback,
                            assess your interview performance, and offer tips
                            for improvement, ensuring you're well-prepared to
                            excel in your data analytics job interviews.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the tutor in this course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our tutors play a pivotal role in your data
                            analytics learning journey at Logicmojo. They are
                            highly experienced professionals with extensive
                            knowledge in the field. As your mentors, they
                            provide guidance, support, and expertise throughout
                            the course. Their responsibilities include
                            conducting live classes, offering clarifications on
                            course material, facilitating interactive
                            discussions, and assisting with assignments and
                            projects. Tutors ensure a dynamic learning
                            experience by sharing real-world insights, industry
                            best practices, and hands-on guidance. They are
                            committed to your success, helping you grasp complex
                            concepts, develop practical skills, and achieve your
                            goals in the data analytics field.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What types of
                            job assistance services are offered ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our comprehensive data analytics course includes
                            various job assistance services to support your
                            career goals. These services encompass resume
                            building, interview preparation, and job search
                            guidance. You'll have access to mock interviews and
                            interview preparation sessions to refine your
                            interviewing skills. Additionally, we provide
                            assistance in crafting a professional resume
                            tailored for data analytics roles. Our dedicated
                            team helps you identify suitable job opportunities
                            and guides you in your job search, connecting you
                            with potential employers to kick-start your career
                            in data analytics.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            jobs have students gotten after completing the
                            course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Upon successful completion of our data analytics
                            course, students have ventured into various
                            promising career paths. Some have secured roles as
                            Data Analysts, where they leverage their newfound
                            data analysis skills to extract insights from vast
                            datasets. Others have stepped into roles as Business
                            Analysts, contributing to strategic decision-making
                            by interpreting data trends and patterns.
                            Additionally, several graduates have embraced the
                            role of a Business Intelligence Analyst,
                            specializing in data-driven decision support
                            systems.
                          </p>

                          <p>
                            With expertise in data analysis and machine learning
                            techniques, some graduates have transitioned into
                            the dynamic domain of Data Analytics. They serve as
                            Data Scientists or Machine Learning Engineers,
                            creating sophisticated models for predictive
                            analytics. Meanwhile, those interested in management
                            and leadership have pursued Data Analytics Manager
                            or Data Analytics Lead positions, overseeing teams
                            and analytics projects. These career outcomes
                            highlight the versatility and industry demand for
                            data analytics professionals.
                          </p>

                          <p>
                            The course equips students with the knowledge,
                            practical skills, and project experience needed to
                            succeed in diverse data-driven roles, ensuring that
                            they are well-prepared to make impactful
                            contributions in their chosen careers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading05">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse05"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                some good Data Analytics course for beginners
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse05"
                            className="collapse"
                            aria-labelledby="heading05"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                For those aspiring to study data analytics
                                abroad, there are numerous reputable
                                institutions offering specialized programs to
                                help you master this in-demand field. Here are
                                some noteworthy options:
                              </p>

                              <b>1. Harvard University, USA:</b>
                              <p>
                                Harvard offers a comprehensive Data Analytics
                                program that covers data analysis, machine
                                learning, and data visualization. This program
                                is ideal for students looking to gain in-depth
                                expertise.
                              </p>

                              <b>2. University of Oxford, UK:</b>
                              <p>
                                Oxford's Data Analytics program focuses on
                                statistics and machine learning. Students have
                                access to the university's renowned research
                                facilities and faculty.
                              </p>

                              <b>3. University of Melbourne, Australia:</b>
                              <p>
                                The University of Melbourne offers a Master of
                                Data Analytics program. It provides students with
                                practical skills and real-world projects in data
                                analytics.
                              </p>

                              <b>4. University of Toronto, Canada:</b>
                              <p>
                                The University of Toronto provides a Master of
                                Science in Applied Computing with a focus on
                                data mining and data analytics, preparing
                                students for advanced roles in the industry.
                              </p>

                              <b>
                                5. National University of Singapore, Singapore:
                              </b>
                              <p>
                                The National University of Singapore offers a
                                Master of Science in Data Analytics and Machine
                                Learning. It combines data analysis, machine
                                learning, and artificial intelligence.
                              </p>

                              <b>6. HEC Paris, France:</b>
                              <p>
                                HEC Paris offers an MSc in Data Analytics for
                                Business program, emphasizing the application of
                                data analysis in the business context.
                              </p>

                              <p>
                                These courses provide international exposure,
                                networking opportunities, and cutting-edge
                                education to prepare you for a successful career
                                in data analytics. Admission requirements and
                                program specifics vary, so it's essential to
                                research and choose the one that aligns with
                                your career goals.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can You Get
                                a Job in Data Analyitcs Without a Degree After
                                Completing This Course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Yes, it is possible to secure a job in data
                                analytics without a traditional degree,
                                particularly after completing a specialized
                                certification course. While a degree can be
                                advantageous, the field of data analytics places
                                a significant emphasis on practical skills,
                                problem-solving abilities, and hands-on
                                experience. Here's how you can make it happen:
                              </p>

                              <b>1. Specialized Certification:</b>
                              <p>
                                Completing a reputable data analytics
                                certification course, like Logicmojo's, can
                                equip you with the knowledge and skills needed
                                for the job market. These courses often focus on
                                real-world projects and practical applications,
                                making you job-ready.
                              </p>

                              <b>2. Build a Strong Portfolio:</b>
                              <p>
                                Create a portfolio showcasing your projects,
                                case studies, and data analysis work. This can
                                demonstrate your abilities to potential
                                employers, offering tangible evidence of your
                                skills.
                              </p>

                              <b>3. Gain Experience:</b>
                              <p>
                                Consider internships, freelance work, or
                                entry-level positions in data analytics.
                                Practical experience can outweigh formal
                                education in many cases, and it's an excellent
                                way to get your foot in the door.
                              </p>

                              <b>4. Networking:</b>
                              <p>
                                Engage with data analytics communities, attend
                                meetups, and connect with professionals in the
                                field. Networking can lead to job opportunities
                                and mentorship, even if you lack a formal
                                degree.
                              </p>

                              <b>5. Showcase Soft Skills:</b>
                              <p>
                                Data analytics roles often require
                                problem-solving, communication, and critical
                                thinking. Emphasize these soft skills in
                                interviews and on your resume to prove your
                                competency.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can I
                                request for a support session if I need to
                                better understand the topics?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <b>
                                Requesting Support Sessions for a Deeper
                                Understanding:
                              </b>

                              <p>
                                Yes, you can indeed request support sessions if
                                you need further clarification or a deeper
                                understanding of the topics covered in a data
                                analytics course. These support sessions play a
                                vital role in enhancing your learning
                                experience, and here's how they work:
                              </p>

                              <b>1. Personalized Assistance:</b>
                              <p>
                                If you find certain concepts challenging or need
                                additional guidance, support sessions allow you
                                to get one-on-one or small group assistance.
                                This personalized approach ensures that your
                                specific questions are addressed, leading to
                                better comprehension.
                              </p>

                              <b>2. Clarifying Complex Topics:</b>
                              <p>
                                Data analytics can involve intricate topics, and
                                it's common to encounter complexities. Support
                                sessions are an opportunity to break down these
                                complex subjects into more digestible
                                components. Tutors can provide step-by-step
                                explanations and real-world examples to simplify
                                learning.
                              </p>

                              <b>3. Flexibility:</b>
                              <p>
                                Most courses offer flexible support session
                                scheduling, accommodating your availability and
                                pacing. You can schedule sessions when you're
                                ready to delve into specific subjects, making
                                the learning process adaptable to your needs.
                              </p>

                              <b>4. Extra Practice:</b>
                              <p>
                                In these sessions, you can work on practical
                                problems and projects, applying what you've
                                learned. This hands-on experience is invaluable
                                for reinforcing your understanding of data
                                analytics concepts.
                              </p>

                              <b>5. Encouragement:</b>
                              <p>
                                Support sessions can offer motivation and
                                encouragement, particularly when tackling
                                challenging material. Tutors can provide
                                constructive feedback and keep you on the path
                                to success.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading08">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse08"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Difference
                                Between Data Analytics and Data Analytics Courses
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse08"
                            className="collapse"
                            aria-labelledby="heading08"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data Analytics and Data Analytics are closely
                                related fields, but they have distinct focuses
                                and course objectives. Understanding the
                                differences between these two domains is crucial
                                for selecting the right educational path:
                              </p>

                              <b>Data Analytics:</b>
                              <ol>
                                <li>
                                  <b>Comprehensive Knowledge:</b> Data Analytics
                                  courses provide a comprehensive understanding
                                  of data, covering various aspects such as data
                                  collection, cleaning, analysis, and
                                  interpretation.
                                </li>
                                <li>
                                  <b>Advanced Techniques:</b> Data Analytics
                                  courses often delve into advanced topics,
                                  including machine learning, deep learning, and
                                  artificial intelligence. These are used to
                                  develop predictive models and algorithms.
                                </li>
                                <li>
                                  <b>Big Data:</b> Data Analytics emphasizes
                                  working with large datasets, often referred to
                                  as "big data." This involves technologies like
                                  Hadoop and Spark.
                                </li>
                                <li>
                                  <b>Research-Oriented:</b> Data Analytics courses
                                  often have a research-oriented approach,
                                  focusing on solving complex problems and
                                  contributing to scientific knowledge.
                                </li>
                                <li>
                                  <b>Programming:</b> Proficiency in programming
                                  languages such as Python and R is essential in
                                  Data Analytics.
                                </li>
                              </ol>

                              <b>Data Analytics:</b>
                              <ol>
                                <li>
                                  <b>Business-Focused:</b> Data Analytics
                                  courses concentrate on using data to solve
                                  practical business problems and make
                                  data-driven decisions.
                                </li>
                                <li>
                                  <b>Data Interpretation:</b> These courses
                                  teach you how to interpret data, create
                                  visualizations, and generate insights for
                                  decision-makers.
                                </li>
                                <li>
                                  <b>Statistical Analysis:</b> Data Analytics
                                  emphasizes statistical techniques for
                                  understanding data patterns and trends.
                                </li>
                                <li>
                                  <b>Tool-Based:</b> Proficiency in tools such
                                  as Excel, SQL, and data visualization tools
                                  like Tableau or Power BI is a priority for
                                  Data Analytics courses.
                                </li>
                                <li>
                                  <b>Real-World Applications:</b> Data Analytics
                                  courses often include real-world case studies
                                  and practical projects that simulate industry
                                  scenarios.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Does Job
                                Assistance Guarantee a Job?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Job assistance, a common feature in many
                                educational programs, is designed to support
                                students and graduates in their job search. It
                                involves services like resume building,
                                interview coaching, networking opportunities,
                                and job placement resources. While job
                                assistance programs can significantly enhance
                                your job prospects, it's crucial to clarify that
                                they do not guarantee job placement. Here's why:
                              </p>

                              <ol>
                                <li>
                                  <b>Market Factors:</b> The job market is
                                  influenced by various external factors, such
                                  as economic conditions, industry trends, and
                                  competition. These factors are beyond the
                                  control of job assistance programs.
                                </li>
                                <li>
                                  <b>Individual Effort:</b> Securing a job
                                  ultimately depends on the individual's
                                  efforts, including their skills, experience,
                                  interview performance, and networking
                                  abilities. Job assistance can help improve
                                  these aspects, but success isn't assured.
                                </li>
                                <li>
                                  <b>Employer Decisions:</b> Employers have
                                  specific criteria and preferences when hiring.
                                  Even with job assistance, a candidate must
                                  align with an employer's requirements to
                                  secure a position.
                                </li>
                                <li>
                                  <b>Matching Opportunities:</b> Job assistance
                                  programs can connect you with job
                                  opportunities, but it's essential to find
                                  roles that match your qualifications and
                                  career goals. Not every opportunity will be
                                  suitable.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading10">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse10"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How Will a
                                Data Analytics Course Benefit Your Current Job?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse10"
                            className="collapse"
                            aria-labelledby="heading10"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics courses offer significant
                                benefits for professionals looking to advance
                                their careers and add value to their current
                                jobs. Here's how enrolling in such a program can
                                benefit your current role:
                              </p>

                              <ol>
                                <li>
                                  <b>Improved Decision-Making:</b> Data
                                  analytics skills empower you to make
                                  data-driven decisions. Whether you're in
                                  marketing, finance, or any other field, the
                                  ability to analyze and interpret data can lead
                                  to more informed and effective choices.
                                </li>
                                <li>
                                  <b>Enhanced Problem-Solving:</b> Data analysts
                                  are skilled problem-solvers. You can apply
                                  these skills to identify and resolve
                                  challenges within your current role. By
                                  analyzing data, you can find innovative
                                  solutions to complex problems.
                                </li>
                                <li>
                                  <b>Increased Efficiency:</b> Data analytics
                                  tools and techniques streamline processes. You
                                  can use these skills to optimize workflows and
                                  increase the efficiency of tasks, saving time
                                  and resources for your organization.
                                </li>
                                <li>
                                  <b>Better Performance Measurement:</b> Data
                                  analysis provides a robust way to measure
                                  performance. You can track key performance
                                  indicators (KPIs), assess your progress, and
                                  set achievable goals for yourself and your
                                  team.
                                </li>
                                <li>
                                  <b>Career Advancement:</b> With data analytics
                                  expertise, you become a valuable asset in your
                                  organization. It opens doors to promotions and
                                  leadership roles. Your ability to derive
                                  actionable insights from data can set you
                                  apart from your peers.
                                </li>
                              </ol>

                              <p>
                                Whether you're a marketer, a project manager, a
                                financial analyst, or work in another field,
                                data analytics skills are universally
                                applicable. They can transform your current job
                                by making you more efficient, effective, and
                                well-equipped to drive meaningful changes in
                                your organization.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                some good Data analytics courses for beginners
                                in India?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                If you are a beginner interested in learning
                                data analytics in India, there are many good
                                courses available. Here are a few examples:
                              </p>

                              <ul>
                                <li>
                                  <b>Logicmojo's Data Analytics Course</b>: This
                                  course is designed for beginners and covers
                                  all the essential topics in data analytics,
                                  including data mining, machine learning, and
                                  statistical analysis. The course is taught by
                                  experienced and qualified faculty members, and
                                  it includes hands-on projects to help you
                                  apply what you have learned.
                                </li>
                                <li>
                                  <b>
                                    Simplilearn's Post Graduate Program in Data
                                    Analytics
                                  </b>
                                  : This course is a more comprehensive program
                                  that covers advanced topics in data analytics,
                                  such as natural language processing and
                                  artificial intelligence. The course is also
                                  taught by experienced faculty members, and it
                                  includes hands-on projects and a capstone
                                  project.
                                </li>
                                <li>
                                  <b>
                                    Udemy's Complete Python Bootcamp for Data
                                    Science
                                  </b>
                                  : This course is a good option for beginners
                                  who want to learn Python, a popular
                                  programming language for data analytics. The
                                  course covers all the basics of Python, as
                                  well as more advanced topics such as data
                                  manipulation and visualization.
                                </li>
                                <li>
                                  <b>Coursera's Data Analytics Specialization</b>:
                                  This specialization consists of four courses
                                  that cover the fundamentals of Data Analytics,
                                  including data mining, machine learning, and
                                  statistical analysis. The courses are taught
                                  by experts in the field, and they include
                                  hands-on projects to help you practice what
                                  you have learned.
                                </li>
                              </ul>

                              <p>
                                When choosing a data analytics course, it is
                                important to consider the following factors:
                              </p>

                              <ul>
                                <li>
                                  <b>Curriculum</b>: Make sure that the course
                                  covers the topics that you are interested in,
                                  such as data mining, machine learning, and
                                  statistical analysis.
                                </li>
                                <li>
                                  <b>Faculty</b>: Look for a course with
                                  experienced and qualified faculty members.
                                </li>
                                <li>
                                  <b>Reputation</b>: Choose a course from a
                                  reputable institution.
                                </li>
                                <li>
                                  <b>Cost</b>: Consider the cost of the course,
                                  including tuition, living expenses, and travel
                                  costs.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the best books to read that help in a Data
                                Analytics course ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                For individuals pursuing a data analytics
                                course, gaining knowledge from well-curated
                                books can be immensely beneficial. Here are some
                                highly recommended books to complement your
                                learning and deepen your understanding of data
                                analytics:
                              </p>

                              <ol>
                                <li>
                                  <b>
                                    <b>
                                      "Python for Data Analysis" by Wes
                                      McKinney:
                                    </b>
                                  </b>{" "}
                                  This book is an excellent resource for
                                  learning how to use Python, a fundamental
                                  programming language in data analytics, for
                                  data analysis. It covers data manipulation,
                                  cleaning, and visualization, offering
                                  practical insights for hands-on work.
                                </li>

                                <li>
                                  <b>
                                    <b>
                                      "Data Analytics for Business" by Foster
                                      Provost and Tom Fawcett:
                                    </b>
                                  </b>{" "}
                                  This book bridges the gap between technical
                                  aspects and business applications of data
                                  analytics. It's perfect for understanding how
                                  Data Analytics can be leveraged for
                                  decision-making and strategy in an
                                  organization.
                                </li>

                                <li>
                                  <b>
                                    <b>
                                      "Storytelling with Data" by Cole
                                      Nussbaumer Knaflic:
                                    </b>
                                  </b>{" "}
                                  Data analysts often need to convey complex
                                  findings to non-technical stakeholders. This
                                  book helps you master the art of data
                                  visualization and effective storytelling to
                                  make your insights compelling and actionable.
                                </li>

                                <li>
                                  <b>
                                    <b>
                                      "The Data Warehouse Toolkit" by Ralph
                                      Kimball:
                                    </b>
                                  </b>{" "}
                                  Understanding data warehousing is crucial in
                                  data analytics. This book provides a
                                  comprehensive guide to designing and managing
                                  data warehouses, a core component of data
                                  analysis infrastructure.
                                </li>

                                <li>
                                  <b>
                                    <b>
                                      "Predictive Analytics: The Power to
                                      Predict Who Will Click, Buy, Lie, or Die"
                                      by Eric Siegel:
                                    </b>
                                  </b>{" "}
                                  Delve into predictive analytics and machine
                                  learning with this book. It explains
                                  predictive modeling concepts in a
                                  non-technical manner, making it accessible to
                                  beginners.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Does the
                                course offer networking opportunities with
                                potential employers?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                One of the distinct advantages of enrolling in
                                Logicmojo's Data Analytics Course is the
                                platform it provides for networking with
                                potential employers and industry professionals.
                                Networking is a crucial aspect of career
                                development, and this course is designed to
                                foster meaningful connections and opportunities
                                for students. Here's how the program supports
                                networking:
                              </p>

                              <ol>
                                <li>
                                  <b>
                                    <b>Industry Expert Mentors:</b>
                                  </b>{" "}
                                  Throughout the course, you will have the
                                  chance to interact with industry experts who
                                  serve as mentors. These mentors bring vast
                                  experience and insights, and their guidance
                                  can open doors to various career prospects.
                                  They often have connections in the industry
                                  that they can leverage for your benefit.
                                </li>

                                <li>
                                  <b>
                                    <b>Capstone Project Collaboration:</b>
                                  </b>{" "}
                                  The capstone project in the course is a
                                  real-world industry project. Collaborating
                                  with organizations or businesses on this
                                  project not only gives you hands-on experience
                                  but also introduces you to professionals who
                                  could become valuable contacts for future job
                                  opportunities.
                                </li>

                                <li>
                                  <b>
                                    <b>Job Assistance Programs:</b>
                                  </b>{" "}
                                  The job assistance programs offered include
                                  connections to a network of partner companies
                                  actively seeking data analytics professionals.
                                  Logicmojo maintains relationships with these
                                  employers and can facilitate introductions and
                                  interviews with students who complete the
                                  course successfully.
                                </li>

                                <li>
                                  <b>
                                    <b>Networking Events:</b>
                                  </b>{" "}
                                  Logicmojo often organizes networking events
                                  and webinars where students can interact with
                                  alumni, industry leaders, and potential
                                  employers. These events create a platform for
                                  building relationships and exploring job
                                  prospects.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What are the
                                Data Analytics course for MBA students ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics is a rapidly growing field, and
                                MBA students who have skills in data analytics
                                are in high demand. Data analytics can help MBA
                                students to make better business decisions, to
                                improve operational efficiency, and to identify
                                new market opportunities.
                              </p>

                              <p>
                                Here are a few examples of data analytics
                                courses that are available to MBA students:
                              </p>

                              <ul>
                                <li>
                                  <b>Business Analytics</b>: This course covers
                                  the basics of data analytics, such as data
                                  collection, data cleaning, and data analysis.
                                  Students will learn how to use data analytics
                                  tools to solve business problems.
                                </li>
                                <li>
                                  <b>Big Data Analytics</b>: This course covers
                                  more advanced topics in data analytics, such
                                  as big data processing, machine learning, and
                                  artificial intelligence. Students will learn
                                  how to use these tools to analyze large and
                                  complex datasets.
                                </li>
                                <li>
                                  <b>Data Visualization</b>: This course teaches
                                  students how to create effective data
                                  visualizations to communicate insights to
                                  others. Students will learn how to use charts,
                                  graphs, and other data visualization
                                  techniques to tell stories with data.
                                </li>
                                <li>
                                  <b>Marketing Analytics</b>: This course
                                  teaches students how to use data analytics to
                                  make better marketing decisions. Students will
                                  learn how to use data to understand customer
                                  behavior, to target customers more
                                  effectively, and to measure the effectiveness
                                  of marketing campaigns.
                                </li>
                                <li>
                                  <b>Financial Analytics</b>: This course
                                  teaches students how to use data analytics to
                                  make better financial decisions. Students will
                                  learn how to use data to assess risk, to make
                                  investment decisions, and to manage financial
                                  performance.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What are the
                                prerequisites for a Data Analytics course for
                                Non-IT students ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data analytics is a dynamic and
                                multidisciplinary field that welcomes
                                individuals from various educational
                                backgrounds. While there are no strict
                                prerequisites for non-IT students, having
                                certain foundational skills and knowledge can be
                                advantageous in your journey to becoming a data
                                analyst. Logicmojo's Data Analytics Course is
                                designed to accommodate students from diverse
                                backgrounds and equip them with the necessary
                                skills. Here's a breakdown of the prerequisites:
                              </p>

                              <ol>
                                <li>
                                  <b>
                                    <b>Basic Computer Literacy:</b>
                                  </b>{" "}
                                  As a non-IT student, having fundamental
                                  computer skills is crucial. You should be
                                  comfortable navigating software, working with
                                  spreadsheets, and using the internet.
                                </li>

                                <li>
                                  <b>
                                    <b>Mathematical Proficiency:</b>
                                  </b>{" "}
                                  Data analytics involves mathematics,
                                  particularly statistics. While you don't need
                                  an advanced math degree, a solid grasp of
                                  basic math concepts like algebra and
                                  statistics can be beneficial.
                                </li>

                                <li>
                                  <b>
                                    <b>Analytical Thinking:</b>
                                  </b>{" "}
                                  Non-IT students often excel in analytical
                                  thinking, which is a valuable asset in data
                                  analytics. Logicmojo's course will further
                                  enhance your analytical skills.
                                </li>

                                <li>
                                  <b>
                                    <b>Willingness to Learn:</b>
                                  </b>{" "}
                                  The most important prerequisite is the
                                  eagerness to learn. Data analytics is about
                                  continuous learning and problem-solving.
                                  Non-IT students willing to invest time and
                                  effort will thrive in this field.
                                </li>

                                <li>
                                  <b>
                                    <b>Interest in Data:</b>
                                  </b>{" "}
                                  Having a natural curiosity about data,
                                  patterns, and insights can be a driving force.
                                  Logicmojo's course will nurture and direct
                                  that curiosity into a structured skill set.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading16">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse16"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                future scope of Logicmojo Data Analytics course
                                ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse16"
                            className="collapse"
                            aria-labelledby="heading16"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Logicmojo's Data Analytics Course offers a
                                promising and dynamic pathway for individuals
                                aspiring to thrive in the data-driven world.
                                With the proliferation of data across
                                industries, the demand for skilled data analysts
                                is soaring. As a result, Logicmojo's Data
                                Analytics Course is positioned to provide
                                graduates with a wealth of opportunities and a
                                bright career outlook.
                              </p>

                              <p>
                                <b>1. High Demand for Data Analysts:</b> Data
                                analysts are essential in helping organizations
                                make data-informed decisions. The course equips
                                students with a diverse skill set, making them
                                highly marketable in various industries, from
                                finance to healthcare.
                              </p>

                              <p>
                                <b>2. Diverse Job Opportunities:</b> Graduates
                                of the course can explore a multitude of job
                                titles, from data analyst and business analyst
                                to business intelligence engineer and more. The
                                program provides a versatile foundation, opening
                                doors to a wide array of positions.
                              </p>

                              <p>
                                <b>3. Competitive Salaries:</b> The data
                                analytics field offers competitive salaries, and
                                Logicmojo's certification can significantly
                                enhance earning potential. The course's
                                practical projects and capstone project make
                                graduates job-ready and attractive to employers.
                              </p>

                              <p>
                                <b>4. Lifelong Learning:</b> The course not only
                                prepares students for their first job but also
                                provides them with the skills needed for
                                continuous learning. The rapidly evolving field
                                of data analytics necessitates adaptability, and
                                Logicmojo's course instills a culture of
                                lifelong learning.
                              </p>

                              <p>
                                <b>5. Industry-Relevant Curriculum:</b>{" "}
                                Logicmojo continuously updates its curriculum to
                                reflect industry trends. Graduates remain
                                current in their knowledge and skills, ensuring
                                they are well-suited to the evolving demands of
                                the job market.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading17">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse17"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How does
                                one choose the right Data Analyitcs course for
                                their career goals ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse17"
                            className="collapse"
                            aria-labelledby="heading17"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Opting for the right data analytics course is a
                                crucial decision that can significantly impact
                                your career. To align your choice with your
                                career goals, consider the following factors:
                              </p>

                              <p>
                                <b>1. Course Content:</b> Ensure the course
                                covers a comprehensive range of topics,
                                including data analysis, Data Analytics,
                                statistics, and relevant tools like Python and
                                SQL. Logicmojo's Data Analytics Course, for
                                example, provides a well-rounded curriculum.
                              </p>

                              <p>
                                <b>2. Practical Projects:</b> Look for courses
                                that emphasize hands-on experience. Practical
                                projects are invaluable in preparing you for
                                real-world scenarios, and Logicmojo's course
                                offers numerous real-life projects for skill
                                development.
                              </p>

                              <p>
                                <b>3. Industry Relevance:</b> Assess if the
                                course content aligns with industry needs.
                                Logicmojo continually updates its curriculum to
                                reflect current industry trends, ensuring you
                                acquire the latest skills.
                              </p>

                              <p>
                                <b>4. Support and Mentorship:</b> Seek courses
                                with mentorship opportunities. Logicmojo's
                                course offers industry mentors who guide you
                                through the learning journey, providing
                                invaluable insights and networking
                                opportunities.
                              </p>

                              <p>
                                <b>5. Job Assistance:</b> Consider courses that
                                offer job assistance, such as resume building,
                                interview preparation, and career guidance.
                                Logicmojo's job assistance programs can enhance
                                your job prospects.
                              </p>

                              <p>
                                <b>6. Certification:</b> Choose a course that
                                awards a recognized certification upon
                                completion. Logicmojo provides certificates to
                                validate your skills and knowledge.
                              </p>

                              <p>
                                <b>7. Flexibility:</b> Assess the course's
                                flexibility and availability of live classes.
                                Logicmojo offers convenient schedules with
                                weekday and weekend options.
                              </p>

                              <p>
                                <b>8. Prerequisites:</b> Ensure the course
                                aligns with your educational background and
                                level of expertise. Logicmojo's course is open
                                to learners from various backgrounds.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading18">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse18"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                difference between Data Analytics and Business
                                Analytics and their courses ?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse18"
                            className="collapse"
                            aria-labelledby="heading18"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Both Data Analytics and Business Analytics are
                                essential disciplines in the data-driven world,
                                but they focus on different aspects and have
                                corresponding courses to match.
                              </p>

                              <p>
                                <b>Data Analytics:</b>
                              </p>
                              <ul>
                                <li>
                                  Data Analytics is primarily concerned with
                                  analyzing and interpreting data to discover
                                  meaningful insights. It involves a more
                                  technical and statistical approach.
                                </li>
                                <li>
                                  Course Content: Data Analytics courses, like
                                  Logicmojo's Data Analytics Course, typically
                                  cover topics such as data manipulation,
                                  statistics, machine learning, data
                                  visualization, and tools like Python and SQL.
                                </li>
                                <li>
                                  Goal: Data Analysts aim to extract valuable
                                  information from data, often to support
                                  decision-making or identify trends.
                                </li>
                                <li>
                                  Course Emphasis: Data Analytics courses
                                  prioritize data processing and analysis
                                  techniques, preparing learners for roles like
                                  Data Analyst or Data Scientist.
                                </li>
                              </ul>

                              <p>
                                <b>Business Analytics:</b>
                              </p>
                              <ul>
                                <li>
                                  Business Analytics, on the other hand, is
                                  centered around using data to drive business
                                  decision-making and strategy.
                                </li>
                                <li>
                                  Course Content: Courses like Logicmojo's
                                  Business Analytics Course typically cover
                                  areas like data-driven decision-making,
                                  business intelligence, predictive analytics,
                                  and tools such as Tableau and Excel.
                                </li>
                                <li>
                                  Goal: Business Analysts leverage data insights
                                  to solve business problems, improve processes,
                                  and guide strategic planning.
                                </li>
                                <li>
                                  Course Emphasis: Business Analytics courses
                                  emphasize the application of analytics in a
                                  business context, equipping learners for roles
                                  like Business Analyst or Business Intelligence
                                  Analyst.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab027" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading05">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse05"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the Mentorship?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse05"
                        className="collapse"
                        aria-labelledby="heading05"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Mentorship plays a crucial role in Logicmojo's Data
                            Analytics Course, offering learners valuable
                            guidance, support, and insights throughout their
                            educational journey. Here's an overview of the
                            significance and responsibilities of mentors in the
                            course:
                          </p>

                          <ul>
                            <li>
                              <b>Subject Matter Expertise:</b> Mentors are
                              industry professionals with extensive subject
                              matter expertise in Data Analyst. They possess
                              in-depth knowledge of the technologies, tools, and
                              best practices relevant to the field.
                            </li>

                            <li>
                              <b>Guidance and Clarification:</b> Mentors provide
                              learners with guidance on various course topics,
                              clarifying doubts, and explaining complex
                              concepts. They offer a clear path for learners to
                              follow, ensuring they stay on track with their
                              studies.
                            </li>

                            <li>
                              <b>Project Assistance:</b> Throughout the course,
                              learners work on practical projects. Mentors offer
                              assistance in project development, helping
                              learners overcome challenges and implement
                              solutions effectively.
                            </li>

                            <li>
                              <b>Code Reviews:</b> Mentors review learners' code
                              submissions, offering constructive feedback to
                              improve code quality, adherence to best practices,
                              and overall project performance.
                            </li>

                            <li>
                              <b>1:1 Sessions:</b> Learners have the opportunity
                              to engage in one-on-one sessions with mentors.
                              These personalized interactions allow learners to
                              seek advice, discuss career goals, and receive
                              mentorship tailored to their specific needs.
                            </li>

                            <li>
                              <b>Industry Insights:</b> Mentors share real-world
                              insights into the data industry, including current
                              trends, job market dynamics, and industry
                              expectations. This information helps learners
                              align their skills with industry demands.
                            </li>

                            <li>
                              <b>Mock Interviews:</b> As part of job
                              preparation, mentors often conduct mock interviews
                              with learners. These practice sessions simulate
                              real interview scenarios, enabling learners to
                              enhance their interview skills and gain
                              confidence.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading06">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse06"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are some
                            tips for getting the most out of a mentorship for a
                            Data Analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse06"
                        className="collapse"
                        aria-labelledby="heading06"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Mentorship is a valuable resource in a Data
                            Analytics Course, offering personalized guidance and
                            support. To make the most of your mentorship
                            experience, consider these tips:
                          </p>

                          <ul>
                            <li>
                              <b>Set Clear Goals:</b> Define your learning
                              objectives and career goals. Share these with your
                              mentor to create a roadmap for your analytical
                              journey.
                            </li>

                            <li>
                              <b>Active Engagement:</b> Actively participate in
                              mentorship sessions and discussions. Ask
                              questions, seek clarification, and share your
                              challenges and progress.
                            </li>

                            <li>
                              <b>Open Communication:</b> Maintain open and
                              honest communication with your mentor. Share your
                              concerns, aspirations, and any obstacles you
                              encounter.
                            </li>

                            <li>
                              <b>Be Proactive:</b> Take the initiative to
                              explore topics independently. Use mentorship
                              sessions to delve deeper into complex concepts and
                              seek guidance on practical applications.
                            </li>

                            <li>
                              <b>Regular Feedback:</b> Request feedback from
                              your mentor on your projects and assignments.
                              Constructive criticism helps you improve your
                              skills and code quality.
                            </li>

                            <li>
                              <b>Implement Advice:</b> Act on the advice and
                              recommendations provided by your mentor. Apply
                              their insights to your coding practices and
                              projects.
                            </li>

                            <li>
                              <b>Stay Organized:</b> Keep track of your
                              progress, mentorship sessions, and goals. Organize
                              your learning materials for easy reference.
                            </li>

                            <li>
                              <b>Respect Their Time:</b> Value your mentor's
                              time by being punctual for meetings and respecting
                              their availability. Be mindful of their schedule.
                            </li>

                            <li>
                              <b>Seek Career Guidance:</b> Utilize mentorship
                              not only for technical guidance but also for
                              career advice. Discuss job market trends, industry
                              insights, and job-seeking strategies.
                            </li>

                            <li>
                              <b>Build a Professional Relationship:</b> Foster a
                              professional relationship with your mentor.
                              Networking can lead to valuable opportunities in
                              the industry.
                            </li>

                            <li>
                              <b>Express Gratitude:</b> Show appreciation for
                              your mentor's guidance and support. A simple
                              thank-you can go a long way in maintaining a
                              positive mentorship relationship.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            benefits of having a mentor for a Data Analytics
                            course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Mentorship plays a crucial role in enhancing your
                            learning experience and career prospects in a Data
                            Analytics Course. Here are several key benefits of
                            having a mentor:
                          </p>

                          <ul>
                            <li>
                              <b>Guidance and Expertise:</b> A mentor offers
                              valuable insights and expertise gained through
                              their experience in the field. They can provide
                              guidance on best practices, industry trends, and
                              real-world challenges.
                            </li>

                            <li>
                              <b>Personalized Learning:</b> Mentors tailor their
                              advice and recommendations to your specific needs
                              and goals. This personalized approach accelerates
                              your learning and skill development.
                            </li>

                            <li>
                              <b>Problem Solving:</b> When you encounter
                              technical issues or coding challenges, a mentor
                              can assist you in problem-solving. They offer
                              solutions, alternative approaches, and debugging
                              assistance.
                            </li>

                            <li>
                              <b>Feedback and Code Review:</b> Mentors review
                              your code, projects, and assignments, offering
                              constructive feedback. This helps you improve your
                              coding style, code quality, and adherence to best
                              practices.
                            </li>

                            <li>
                              <b>Motivation and Accountability:</b> Mentors
                              inspire and motivate you to stay committed to your
                              learning journey. They hold you accountable for
                              your goals and milestones, ensuring consistent
                              progress.
                            </li>

                            <li>
                              <b>Career Guidance:</b> Beyond technical skills,
                              mentors provide insights into career paths, job
                              market trends, and job-seeking strategies. They
                              may assist with resume building, interview
                              preparation, and networking.
                            </li>

                            <li>
                              <b>Networking Opportunities:</b> Mentors often
                              have extensive professional networks. Through
                              mentorship, you can access valuable networking
                              opportunities, including introductions to industry
                              professionals.
                            </li>

                            <li>
                              <b>Confidence Building:</b> Interacting with a
                              mentor boosts your confidence in your coding
                              abilities and problem-solving skills. This
                              self-assurance is essential for taking on complex
                              projects and challenges.
                            </li>

                            <li>
                              <b>Industry Insights:</b> Mentors share their
                              knowledge of industry best practices, emerging
                              technologies, and the latest tools. This keeps you
                              updated and competitive in the job market.
                            </li>

                            <li>
                              <b>Support System:</b> A mentor serves as a
                              supportive resource, offering encouragement during
                              moments of doubt or difficulty. Knowing you have
                              someone to turn to can reduce stress and
                              frustration.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            companies hire Data Analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data Analysts are in high demand across various
                            industries, reflecting the universal need to make
                            data-driven decisions. Companies of all sizes and
                            types rely on Data Analysts to extract insights from
                            data. Here are some examples of industries and
                            companies that hire Data Analysts:
                          </p>

                          <b>1. Technology Companies:</b>
                          <ul>
                            <li>
                              Technology giants like Google, Facebook, and
                              Amazon hire Data Analysts to improve user
                              experiences, optimize advertising, and enhance
                              their products.
                            </li>
                          </ul>

                          <b>2. Finance and Banking:</b>
                          <ul>
                            <li>
                              Financial institutions such as JPMorgan Chase and
                              Goldman Sachs employ Data Analysts to assess
                              risks, detect fraud, and make investment
                              decisions.
                            </li>
                          </ul>

                          <b>3. Healthcare:</b>
                          <ul>
                            <li>
                              Healthcare organizations like Mayo Clinic and
                              pharmaceutical companies like Pfizer utilize Data
                              Analysts to analyze patient data, conduct
                              research, and improve healthcare outcomes.
                            </li>
                          </ul>

                          <b>4. E-commerce:</b>
                          <ul>
                            <li>
                              Online retailers such as Amazon and Alibaba hire
                              Data Analysts to optimize pricing, recommend
                              products, and enhance the shopping experience.
                            </li>
                          </ul>

                          <b>5. Government:</b>
                          <ul>
                            <li>
                              Government agencies use Data Analysts to analyze
                              data on various aspects, from public health to
                              economic trends, to make informed policy
                              decisions.
                            </li>
                          </ul>

                          <b>6. Marketing and Advertising:</b>
                          <ul>
                            <li>
                              Marketing agencies and advertising firms like
                              Ogilvy and Mather rely on Data Analysts to measure
                              campaign performance, target audiences
                              effectively, and improve ROI.
                            </li>
                          </ul>

                          <b>7. Energy and Utilities:</b>
                          <ul>
                            <li>
                              Companies in the energy sector, such as
                              ExxonMobil, use Data Analysts to optimize
                              operations, monitor energy consumption, and assess
                              environmental impact.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How do i build
                            portfolio of Data Analytics projects?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <b>Building a Data Analytics Portfolio:</b>

                          <p>
                            Creating a strong portfolio of Data Analytics
                            projects is essential to demonstrate your skills and
                            experience to potential employers. Here's a
                            step-by-step guide on how to build an impressive
                            Data Analytics portfolio:
                          </p>

                          <b>1. Choose Diverse Projects:</b>
                          <ul>
                            <li>
                              Select a variety of projects that showcase your
                              ability to work with different types of data and
                              solve real-world problems. Include projects in
                              areas like finance, healthcare, e-commerce, or any
                              domain you're interested in.
                            </li>
                          </ul>

                          <b>2. Real Data Sets:</b>
                          <ul>
                            <li>
                              Use real data sets whenever possible. Working with
                              authentic data helps you address complex,
                              practical issues that organizations face.
                            </li>
                          </ul>

                          <b>3. Data Cleaning and Preprocessing:</b>
                          <ul>
                            <li>
                              Include examples where you've cleaned and
                              preprocessed data. Data cleaning is a fundamental
                              skill in Data Analytics.
                            </li>
                          </ul>

                          <b>4. Data Visualization:</b>
                          <ul>
                            <li>
                              Create visualizations to effectively communicate
                              your findings. Charts, graphs, and dashboards make
                              your analysis more accessible.
                            </li>
                          </ul>

                          <b>5. Storytelling:</b>
                          <ul>
                            <li>
                              Explain your analysis and insights clearly. Show
                              how your work can inform decision-making.
                              Effective storytelling is crucial in Data
                              Analytics.
                            </li>
                          </ul>

                          <b>6. Open Source Tools:</b>
                          <ul>
                            <li>
                              Use tools like Python, R, SQL, and visualization
                              libraries. Showcase your proficiency in the tools
                              commonly used in the industry.
                            </li>
                          </ul>

                          <b>7. GitHub:</b>
                          <ul>
                            <li>
                              Host your projects on GitHub. It's a widely
                              recognized platform for sharing code and projects.
                              Keep your repository organized and include README
                              files with project details.
                            </li>
                          </ul>

                          <b>8. Personal Blog or Website:</b>
                          <ul>
                            <li>
                              Create a personal blog or website to document your
                              projects. Share your thought process, challenges
                              faced, and lessons learned.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can i Work
                                at my own pace in this Data Analytics course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <b>
                                Working at Your Own Pace in the Data Analytics
                                Course:
                              </b>

                              <p>
                                One of the advantages of enrolling in
                                Logicmojo's Data Analytics course is the
                                flexibility it offers. You can indeed work at
                                your own pace, making it suitable for a wide
                                range of learners. Here's how it works:
                              </p>

                              <b>1. Self-Paced Learning:</b>
                              <ul>
                                <li>
                                  Logicmojo's Data Analytics course is designed
                                  to accommodate self-paced learning. The course
                                  material is available online, and you can
                                  access it at any time that suits you.
                                </li>
                              </ul>

                              <b>2. No Fixed Schedules:</b>
                              <ul>
                                <li>
                                  You won't be bound by rigid class schedules or
                                  deadlines. This allows you to balance your
                                  learning with other commitments, such as work
                                  or personal life.
                                </li>
                              </ul>

                              <b>3. Progress Tracking:</b>
                              <ul>
                                <li>
                                  You can track your own progress through the
                                  course. This means you can spend more time on
                                  challenging topics or move faster through
                                  sections you find easier.
                                </li>
                              </ul>

                              <b>4. Mentor Support:</b>
                              <ul>
                                <li>
                                  Although you have the flexibility to work at
                                  your own pace, Logicmojo provides mentor
                                  support when you need it. You can reach out to
                                  mentors for clarification or guidance.
                                </li>
                              </ul>

                              <b>5. Lifetime Access:</b>
                              <ul>
                                <li>
                                  Once enrolled, you have lifetime access to the
                                  course materials. This means you can revisit
                                  and review the content as needed, even after
                                  completing the course.
                                </li>
                              </ul>

                              <p>
                                Working at your own pace allows you to tailor
                                your learning experience to your needs and
                                goals. It's a valuable feature for individuals
                                with varying levels of prior experience and time
                                constraints.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading110">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse110"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the most in-demand skills for Data Analytics in
                                today's market?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse110"
                            className="collapse"
                            aria-labelledby="heading110"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                Data Analytics is an ever-evolving field, and
                                the demand for specific skills can vary
                                depending on industry trends and technological
                                advancements. In 2023, several skills are
                                particularly sought after by employers in the
                                Data Analytics job market:
                              </p>

                              <b>1. Data Analysis and Visualization:</b>
                              <ul>
                                <li>
                                  Proficiency in data analysis tools and
                                  techniques is fundamental. Data analysts
                                  should excel in extracting insights from
                                  complex datasets and presenting them through
                                  clear visualizations.
                                </li>
                              </ul>

                              <b>2. Programming Languages:</b>
                              <ul>
                                <li>
                                  Skills in programming languages like Python
                                  and R remain crucial. Python's versatility and
                                  R's statistical capabilities are highly
                                  valued.
                                </li>
                              </ul>

                              <b>3. Data Manipulation:</b>
                              <ul>
                                <li>
                                  Expertise in data cleaning, transformation,
                                  and preparation is essential. Data analysts
                                  must ensure data quality and consistency
                                  before analysis.
                                </li>
                              </ul>

                              <b>4. SQL Database Management:</b>
                              <ul>
                                <li>
                                  Proficiency in SQL (Structured Query Language)
                                  for managing and querying databases is a
                                  foundational skill. SQL is used to retrieve
                                  and manipulate data.
                                </li>
                              </ul>

                              <b>5. Machine Learning:</b>
                              <ul>
                                <li>
                                  Understanding machine learning techniques and
                                  algorithms is increasingly valuable. Machine
                                  learning can help predict trends and patterns
                                  within data.
                                </li>
                              </ul>

                              <b>6. Business Acumen:</b>
                              <ul>
                                <li>
                                  Data analysts should have a strong
                                  understanding of the specific industry they
                                  work in. They need to interpret data within
                                  the context of business goals and objectives.
                                </li>
                              </ul>

                              <b>7. Data Privacy and Ethics:</b>
                              <ul>
                                <li>
                                  With growing concerns about data privacy,
                                  knowledge of data ethics and compliance is
                                  critical. Data analysts should be well-versed
                                  in handling data responsibly.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of support is available during the course, such
                                as access to instructors or mentors?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>
                                  During the Course, you can expect to receive
                                  comprehensive support to ensure your success:
                                </b>
                              </p>

                              <ul>
                                <li>
                                  <b>Instructors:</b> You will have access to
                                  experienced instructors who will guide you
                                  through the course material, answer your
                                  questions, and provide insights into industry
                                  best practices.
                                </li>
                                <li>
                                  <b>Mentors:</b> Industry mentors with
                                  expertise in Data Field will be available to
                                  provide one-on-one guidance, conduct mock
                                  interviews, and offer feedback to help you
                                  excel.
                                </li>
                                <li>
                                  <b>24/7 Query Resolution:</b> You can raise
                                  queries or seek assistance at any time, as
                                  there is a dedicated support team available
                                  24/7 to address your questions and concerns.
                                </li>
                                <li>
                                  <b>Email Support:</b> You can communicate with
                                  the support team via email to resolve your
                                  queries and receive prompt responses.
                                </li>
                                <li>
                                  <b>1:1 Support Sessions:</b> If needed, you
                                  can arrange one-on-one support sessions with
                                  the team to delve deeper into specific topics
                                  or challenges.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of projects will be included in the Data
                                Analytics course and what level of proficiency
                                will be achieved after completing them?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                In a Data Analytics course, students typically
                                engage in various real-life projects designed to
                                enhance their skills and proficiency. These
                                projects cover different domains and provide
                                hands-on experience in solving practical
                                problems. Here's an overview of the projects
                                commonly included in such a course:
                              </p>

                              <b>1. Data Visualization Project:</b>
                              <ul>
                                <li>
                                  <i>Proficiency Level:</i> Beginner to
                                  Intermediate
                                </li>
                                <li>
                                  Students learn to create compelling data
                                  visualizations using tools like Tableau, Power
                                  BI, or Matplotlib in Python. They gain skills
                                  in translating data into meaningful insights.
                                </li>
                              </ul>

                              <b>2. Predictive Modeling Project:</b>
                              <ul>
                                <li>
                                  <i>Proficiency Level:</i> Intermediate
                                </li>
                                <li>
                                  Students build predictive models to forecast
                                  future trends, such as stock prices, sales, or
                                  customer behavior. This project deepens their
                                  understanding of machine learning techniques.
                                </li>
                              </ul>

                              <b>
                                3. Data Cleaning and Transformation Project:
                              </b>
                              <ul>
                                <li>
                                  <i>Proficiency Level:</i> Intermediate
                                </li>
                                <li>
                                  Participants work with real-world messy
                                  datasets, cleansing and transforming data into
                                  a usable format. They develop skills in data
                                  preprocessing.
                                </li>
                              </ul>

                              <b>4. Business Case Analysis:</b>
                              <ul>
                                <li>
                                  <i>Proficiency Level:</i> Intermediate to
                                  Advanced
                                </li>
                                <li>
                                  Students analyze a business case to make
                                  data-driven recommendations. This project
                                  hones their business acumen and communication
                                  skills.
                                </li>
                              </ul>

                              <b>5. Industry-Specific Capstone Project:</b>
                              <ul>
                                <li>
                                  <i>Proficiency Level:</i> Advanced
                                </li>
                                <li>
                                  The capstone project is often
                                  industry-specific, allowing students to apply
                                  their accumulated skills to a real business
                                  problem. It involves data extraction,
                                  analysis, modeling, and presentation,
                                  providing a comprehensive experience.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                level of difficulty in a Data Analytics course?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>
                                  The level of difficulty in a Data Analytics
                                  Course, such as the one offered by Logicmojo,
                                  can vary based on individual backgrounds and
                                  prior experience. However, here's a general
                                  overview:
                                </b>
                              </p>

                              <ul>
                                <li>
                                  <b>Beginner-Friendly:</b> This courses are
                                  typically designed to accommodate beginners.
                                  They start with foundational concepts and
                                  gradually progress to more advanced topics. If
                                  you are new in data field, you can still
                                  follow along and learn effectively.
                                </li>
                                <li>
                                  <b>Structured Learning:</b> These courses
                                  often provide structured learning paths, clear
                                  explanations, and practical examples. The
                                  course materials are designed to make complex
                                  concepts accessible, making it suitable for
                                  learners of all levels.
                                </li>
                                <li>
                                  <b>Challenging Aspects:</b> While
                                  beginner-friendly, Data Analytics does involve
                                  learning multiple technologies and concepts.
                                  Some learners may find certain aspects, such
                                  as server-side programming or database
                                  management, more challenging than others.
                                </li>
                                <li>
                                  <b>Hands-On Practice:</b> The courses
                                  emphasize hands-on practice through projects
                                  and assignments. The difficulty level of these
                                  projects may increase progressively, allowing
                                  learners to build confidence and proficiency.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h2 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                refund policy in case I am unable to complete
                                the course or am unsatisfied with the
                                instruction?
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p>
                                <b>
                                  The refund policy for Logicmojo's Data
                                  Analytics Course is designed to provide
                                  flexibility and options for learners who may
                                  face challenges in completing the course or
                                  are unsatisfied with the instruction. Here are
                                  the key points:
                                </b>
                              </p>

                              <ul>
                                <li>
                                  <b>30-Day Money-Back Guarantee:</b> Logicmojo
                                  offers a 30-day money-back guarantee. If you
                                  are unsatisfied with the course within the
                                  first 30 days of enrollment, you can request a
                                  full refund.
                                </li>
                                <li>
                                  <b>Prorated Refund:</b> After the initial 30
                                  days, if you decide to discontinue the course,
                                  Logicmojo may offer a prorated refund based on
                                  the remaining duration of your course access.
                                  The specific refund amount may vary.
                                </li>
                                <li>
                                  <b>Refund Request Process:</b> To request a
                                  refund, you typically need to contact
                                  Logicmojo's customer support or follow the
                                  refund request process outlined in the course
                                  terms and conditions.
                                </li>
                                <li>
                                  <b>Course Completion:</b> If you have
                                  completed a significant portion of the course
                                  or have accessed course materials beyond the
                                  30-day period, Logicmojo may assess your
                                  progress and eligibility for a refund on a
                                  case-by-case basis.
                                </li>
                                <li>
                                  <b>Refund Eligibility:</b> It's essential to
                                  review Logicmojo's refund policy before
                                  enrolling to understand the specific
                                  eligibility criteria and refund conditions.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab028" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading05">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse05"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            best ways to get the most out of the support that is
                            available?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse05"
                        className="collapse"
                        aria-labelledby="heading05 "
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              To maximize the benefits of the support available
                              in the Course, consider the following strategies:
                            </b>
                          </p>

                          <ul>
                            <li>
                              <b>Active Participation:</b> Engage actively in
                              the course materials and assignments. The more you
                              immerse yourself in the content, the better you'll
                              be able to pinpoint areas where you need
                              assistance.
                            </li>
                            <li>
                              <b>Timely Queries:</b> Don't hesitate to seek
                              support when you encounter difficulties or have
                              questions. Promptly ask for clarification or
                              assistance to prevent issues from accumulating.
                            </li>
                            <li>
                              <b>Effective Communication:</b> When communicating
                              with instructors, mentors, or support teams, be
                              clear and concise in describing your challenges or
                              concerns. This helps them understand your needs
                              better.
                            </li>
                            <li>
                              <b>Utilize Discussion Forums:</b> If available,
                              participate in online discussion forums or
                              communities related to the course. Sharing and
                              discussing topics with peers can provide valuable
                              insights and solutions.
                            </li>
                            <li>
                              <b>Regular Check-Ins:</b> Schedule periodic
                              check-ins with mentors or instructors to review
                              your progress and address any long-standing
                              challenges or questions.
                            </li>
                            <li>
                              <b>Feedback Sharing:</b> If you have feedback or
                              suggestions about the course, don't hesitate to
                              provide them constructively. Your insights can
                              contribute to the continuous improvement of the
                              program.
                            </li>
                            <li>
                              <b>Stay Organized:</b> Keep your course materials,
                              assignments, and notes well-organized. This can
                              help you quickly locate information and identify
                              areas where you need assistance.
                            </li>
                            <li>
                              <b>Time Management:</b> Manage your time
                              effectively to ensure you have ample opportunity
                              to engage with course content and seek support
                              when necessary.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is the course
                            self-paced, or are there specific deadlines or
                            timelines for completing assignments and projects?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              The course structure typically combines elements
                              of self-pacing and structured timelines:
                            </b>
                          </p>

                          <ul>
                            <li>
                              <b>Self-Paced Learning:</b> Logicmojo often allows
                              learners to access course materials and content at
                              their convenience. This self-paced approach means
                              you can study and progress through the course
                              modules at a speed that suits your schedule.
                            </li>
                            <li>
                              <b>Weekly Commitment:</b> While the course offers
                              flexibility, there is often a recommended or
                              suggested weekly commitment, which could range
                              from 12 to 18 hours per week. This guideline helps
                              learners stay on track and make steady progress.
                            </li>
                            <li>
                              <b>Structured Content:</b> The course typically
                              provides structured content, including video
                              lectures, assignments, and projects, that you can
                              follow sequentially. While you have flexibility,
                              it's advisable to complete assignments and
                              projects within suggested timeframes to benefit
                              fully from the learning experience.
                            </li>
                            <li>
                              <b>Timed Assessments:</b> Some courses may have
                              timed assessments or quizzes to evaluate your
                              understanding of the material. These assessments
                              may have specific deadlines to encourage regular
                              participation.
                            </li>
                            <li>
                              <b>Course Duration:</b> Logicmojo courses often
                              have a defined duration, such as several months,
                              during which learners can access course materials
                              and support.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            feedback and evaluation will be provided throughout
                            this course to track progress and ensure
                            understanding of the material?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              Throughout the Course, you can expect various
                              feedback and evaluation mechanisms to track your
                              progress and ensure comprehension of the material:
                            </b>
                          </p>

                          <ul>
                            <li>
                              <b>Regular Assessments:</b> Logicmojo often
                              incorporates regular quizzes, assignments, and
                              assessments into the course structure. These
                              assessments are designed to test your
                              understanding of the concepts covered and provide
                              immediate feedback on your performance.
                            </li>
                            <li>
                              <b>Project-Based Learning:</b> Many courses
                              emphasize hands-on project work. These projects
                              allow you to apply what you've learned in
                              real-world scenarios. Your performance on these
                              projects will often be evaluated, and you'll
                              receive feedback to help you improve your
                              practical skills.
                            </li>
                            <li>
                              <b>Peer Interaction:</b> Some courses encourage
                              peer interaction through discussion forums or
                              group projects. Engaging with peers can provide
                              additional perspectives and help reinforce your
                              understanding of the material.
                            </li>
                            <li>
                              <b>Feedback from Instructors:</b> Logicmojo
                              instructors or mentors typically provide feedback
                              on assignments and projects. This feedback can
                              include specific suggestions for improvement and
                              insights into your progress.
                            </li>
                            <li>
                              <b>Progress Tracking:</b> Learning platforms often
                              include progress tracking features that allow you
                              to monitor your advancement through course
                              modules. You can use these tools to identify areas
                              where you may need additional focus.
                            </li>
                            <li>
                              <b>Office Hours or Q&A Sessions:</b> Some courses
                              offer regular office hours or live Q&A sessions
                              where you can interact with instructors or
                              mentors, ask questions, and seek clarification on
                              challenging topics.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are
                            assessments and grades handled in the course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              In the Course, assessments and grading are
                              typically managed through the following process:
                            </b>
                          </p>
                          <ul>
                            <li>
                              <b>Regular Assessments:</b> The course includes a
                              series of regular assessments, quizzes, and
                              assignments. These assessments are designed to
                              test your understanding of the material covered in
                              each module.
                            </li>
                            <li>
                              <b>Project Evaluation:</b> Projects play a crucial
                              role in the course. You'll often be required to
                              complete hands-on projects that demonstrate your
                              practical skills. These projects are evaluated
                              based on specific criteria, and your performance
                              contributes to your overall grade.
                            </li>
                            <li>
                              <b>Grading Criteria:</b> Logicmojo provides clear
                              grading criteria for each assessment and project.
                              This criteria typically includes factors such as
                              correctness, completeness, code quality, and
                              adherence to best practices.
                            </li>
                            <li>
                              <b>Feedback and Improvement:</b> Instructors or
                              mentors review your assessments and projects and
                              provide feedback. This feedback is constructive
                              and helps you understand where you can improve.
                              You may have the opportunity to revise and
                              resubmit assignments based on this feedback.
                            </li>
                            <li>
                              <b>Progress Tracking:</b> You can monitor your
                              assessment scores and grades throughout the
                              course. Most courses have a grading dashboard that
                              allows you to track your performance in real-time.
                            </li>
                            <li>
                              <b>Completion Requirements:</b> To successfully
                              complete the course, you typically need to meet
                              certain minimum requirements for assessments,
                              projects, and overall course progress. These
                              requirements are outlined in the course syllabus.
                            </li>
                            <li>
                              <b>Certification:</b> Upon meeting all course
                              requirements and achieving a passing grade, you'll
                              receive a certificate of completion from
                              Logicmojo. This certificate can be a valuable
                              credential to showcase your skills to potential
                              employers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support is available for technical issues or
                            difficulties with the course material?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              <b>Technical Support Team:</b> Logicmojo has a
                              dedicated technical support team that can be
                              reached through various channels, including email,
                              chat, or phone. They are available to help resolve
                              any technical problems you may encounter during
                              the course.
                            </li>
                            <li>
                              <b>24/7 Query Resolution:</b> Learners have access
                              to 24/7 query resolution, allowing them to seek
                              assistance at any time, day or night. This ensures
                              that learners can receive prompt help when facing
                              technical challenges.
                            </li>
                            <li>
                              <b>Email Support:</b> You can send your technical
                              queries via email, and the support team will
                              respond with solutions or guidance to address your
                              issues.
                            </li>
                            <li>
                              <b>One-on-One Support Sessions:</b> In some cases,
                              when technical problems are complex or require
                              personalized assistance, Logicmojo may arrange
                              one-on-one support sessions to provide tailored
                              guidance and solutions.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How up-to-date
                            is the course material, and is it regularly updated
                            to reflect changes in the field of Data Analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              The course material in this Course is meticulously
                              maintained and regularly updated to stay current
                              with the rapidly evolving field of Data Analytics:
                            </b>
                          </p>
                          <ul>
                            <li>
                              <b>Continuous Monitoring:</b> Logicmojo keeps a
                              vigilant eye on industry trends, emerging
                              technologies, and changes in the Data field. This
                              involves monitoring shifts in best practices,
                              tools, and frameworks.
                            </li>
                            <li>
                              <b>Content Updates:</b> When significant changes
                              or advancements occur in Data Analytics, the
                              course content is promptly reviewed and updated.
                              This ensures that learners are exposed to the
                              latest industry knowledge.
                            </li>
                            <li>
                              <b>Feedback Integration:</b> Learner feedback is
                              actively sought and valued. Suggestions and
                              comments from learners are used to enhance the
                              course material and address any areas that may
                              need improvement.
                            </li>
                            <li>
                              <b>Adherence to Industry Standards:</b> Logicmojo
                              aligns the course material with prevailing
                              industry standards, ensuring that learners are
                              equipped with skills and knowledge that meet
                              industry demands.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="careeropp" className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <section className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>
            Our Data Analytics Course Industry Mentors
          </h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Ranjan-kumar.jpg" />
                </div>

                <h3 className="name">Ranjan Kumar</h3>
                <p className="title">Data Analytics Mentor</p>
                <p className="description">
                  Ranjan is currently working as a senior Developer in Amazon.
                  He has a vast experince of teaching Data Analytics.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Mohammed-Shirhaan.jpg" />
                </div>

                <h3 className="name">Mohamed Shirhaan</h3>
                <p className="title">senior Data Analytics Mentor </p>
                <p className="description">
                  Shirhaan working as R & D Group of Informatica as senior data
                  Science Developer.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/priya1.png" />
                </div>
                <h3 className="name">Priya Singh</h3>
                <p className="title">Senior Mentor Data Scientist</p>
                <p className="description">
                  Priya work as a senior developer in Cisco as a Data Scientist.
                  Experienced in the field of Data Scientist.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>Data Analytics Course Faculty</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Experinced Senior Faculty Data Analytics</p>
                <p className="description">
                  Ravi has been part of multiple companies, gaining a wide array
                  of knowledge in Data Analytics. His background involves handling
                  various data kinds, applying diverse analysis methods.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/diwakar.png" />
                </div>

                <h3 className="name">Diwakar Choudhary</h3>
                <p className="title">Senior Faculty Member Data Analytics</p>
                <p className="description">
                  Diwakar has collaborated with numerous organizations, amassing
                  an extensive scope of expertise in Data Analytics. His
                  experience encompasses managing an assortment of data types
                  and employing a range of analytical approaches.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Soumodeep-Mallick.jpg" />
                </div>
                <h3 className="name">Soumodeep Mallick</h3>
                <p className="title">Faculty Of Data Analytics</p>
                <p className="description">
                  Soumodeep has partnered with countless companies, building up
                  an impressive depth of proficiency in the Data Analytics field.
                  His experiences involve dealing with numerous data categories
                  and applying a wide spectrum of analytical techniques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="datareviewsbg" id="ratingreviews">
        <div className="whatpeoplesaybg" id="Review">
          <div className="container">
            <h2>What People Say</h2>
            <h4>
              How it has helped them accelerate their careers to the next level.
            </h4>
            <div className="row">
              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      140%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img loading="lazy" src="assets/images/sid1.png" alt="" />
                    <div className="top_heading">
                      <h3>Siddharth Pande</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    One of the Best Resources for Live Training Classes. Indepth
                    concepts are covered with all topics expalined with projects
                    at the end. Logicmojo Course Helped me Multiple Times During
                    Interview Preparation For Companies like Walmart, Oracle,
                    and Microsoft. No Need of Any Other Online Materials
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Oracle
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/microsoftlogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      295%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src=" assets/images/anjani.png"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Anjani Kumar</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    Very Well-arranged Course and its Amazing Lecture Delivery
                    by Trainers. Expert Team is always Available to solve Any
                    Technical Queries. Logicmojo Live Preparation Training Helps
                    me to Crack Zynga and Now Amazon Interview.
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Zynga
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src=" assets/images/amazonlogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      190%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src=" assets/images/afnaan.png"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Afnaan Rafique</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    I have a very great experience with Logicmojo. Learning by
                    doing is a great way to learn something which Logicmojo team
                    encouraged me to do so. After completion of the topic,
                    project works starts. The course has a big contribution to
                    my success.
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> GlobalLogic
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/paypalLogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      270%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src=" assets/images/piyush.png"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Piyush Mittal</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    The Course Curriculum is of the Best Quality Along with the
                    Best Learning Experience from my Tutor. Best Course to
                    Prepare For top product companies Interview. I Cracked
                    Paytm, Adobe, Intuit, and Microsoft. Finally joined
                    Microsoft at 1.3 Cr LPA Hyderabad MS IDC
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Paytm
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/microsoftlogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      170%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src="assets/images/diwakar.png"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Diwakar Choudhary</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    Excellent Course for Interview Preparation, Very Straight to
                    the Point ,In-Depth Coverage of Every Point in Live Classes.
                    Speecially Focus on Practical Implementation of machine
                    learning & Data Analytics.
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Cirtix
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src=" assets/images/walmartlbslogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      160%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img loading="lazy" src="assets/images/priya1.png" alt="" />
                    <div className="top_heading">
                      <h3>Priya Singh</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    The Course Curriculum is of Best Quality Along with best
                    Project work that Discussed in the Class. Materials are
                    Helpful even After Completion of the Course.
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> MindTree
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/ciscologo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      130%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src=" assets/images/rajnish.jpg"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Rajnish Kumar</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    Great course! Definitely helped me open some new doors in
                    understanding how Machine Learning work and implementing
                    solutions for the different exercises & assignment. Live
                    Courses are recommended for Working Professionals.
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Cred
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/flipcart.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="whatpeoplesaybox">
                  <div className="hikebox">
                    <span>
                      220%{" "}
                      <i className="fa fa-line-chart" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="whatpeoplesaybox-top">
                    <img
                      loading="lazy"
                      src="assets/images/arvindo.jpg"
                      alt=""
                    />
                    <div className="top_heading">
                      <h3>Aravindo Swain</h3>
                    </div>
                  </div>
                  <div className="whatpeoplesaybox-dec">
                    {" "}
                    I Would say the Best Part is the Explanation by the Trainer,
                    Concise and Clear. Great Quality of Online Materials and
                    Classes, It Covers all topics of ML & AI asked During
                    Interviews
                  </div>
                  <div className="whatpeoplesaybox-mid">
                    <div className="prelogic">
                      <div className="scalerbox scalerbox_left">
                        <label htmlFor="">Pre Logicmojo</label> Oracle
                      </div>
                    </div>
                    <div className="arrow">
                      <div className="scalerbox-arrow">
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="postlogic">
                      <div className="scalerbox">
                        <label htmlFor="">Post Logicmojo</label>{" "}
                        <img
                          loading="lazy"
                          style={{ height: "auto" }}
                          src="assets/images/microsoftlogo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*
        <div style={{ textAlign: "center" }}>
          <a
            target="_default"
            href="https://logicmojo.com/reviews"
            className="btn btn-primary"
          >
            View more reviews
          </a>
        </div>
        */}
        </div>
        {/*
        <div className="container">
          <h2>Learner Reviews for our Data Analytics Programs</h2>

          <div className="row">
            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/shivam.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Shivam Bajpai</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  I recently wrapped up a Data Analytics course and would like to
                  discuss my impressions and insights from the program. Overall,
                  I believe the course is a great asset for those interested in
                  entering the Data Analytics field or improving their current
                  abilities. The course curriculum was skillfully crafted,
                  encompassing all key aspects of Data Analytics, such as
                  statistics, Python, machine learning, data analysis, and
                  large-scale data processing. The lessons were thoughtfully
                  arranged, beginning with fundamental concepts and gradually
                  advancing to more complex topics, making it simple to
                  comprehend and follow the material.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/puneet.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Puneet</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  I recently completed an online Data Analytics course and would
                  like to share my feedback and experiences about the program.
                  The course proved to be an exceptional learning opportunity
                  for those looking to delve into Data Analytics or improve their
                  existing skills in the field. The course was meticulously
                  structured, encompassing a broad array of crucial Data Analytics
                  topics.The instructors were not only experts in their
                  respective fields but also highly accessible and supportive.
                  They offered clear explanations and promptly addressed any
                  questions or concerns
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/diwakar.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Diwakar Choudhary</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  A key aspect of the Data Analytics course was its emphasis on
                  practical, hands-on learning experiences. Throughout the
                  program, students were tasked with completing a variety of
                  assignments, quizzes, and projects, encouraging them to apply
                  their newfound knowledge to real-world scenarios. This
                  approach not only deepened my understanding of the subject
                  matter but also allowed me to build a compelling portfolio to
                  showcase my skills to prospective employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/afnaan.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Afnaan Rafique</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  The online format of the Data Analytics course provided the
                  flexibility to learn at my own pace and according to my
                  schedule. This was particularly beneficial for individuals,
                  like myself, balancing work, family, and other commitments,
                  making it an appealing option for learners with varying levels
                  of availability.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/piyush.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Piyush Mittal</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  A crucial element of the Data Analytics course focused on
                  providing practical, experiential learning opportunities.
                  During the program, students engaged in numerous tasks, tests,
                  and projects that pushed them to utilize their acquired
                  knowledge in real-life situations. This method not only
                  enriched my comprehension of the topics but also enabled me to
                  create an impressive portfolio to demonstrate my abilities to
                  potential employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/priya.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Priya Singh</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  The digital structure of the Data Analytics course allowed for
                  the adaptability to study at a pace and schedule that suited
                  me. This proved to be especially advantageous for people,
                  including myself, who had to juggle work, family, and other
                  responsibilities, rendering it an attractive choice for
                  students with diverse time commitments.
                </p>
              </div>
            </div>
            <center>
              <a
                target="_default"
                href="https://www.google.com/search?q=logicmojo+review&oq=log&aqs=chrome.1.69i65j69i59j46i39i175i199j69i60l4j69i65.1921j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"
                className="btn btn-link collapsed"
              >
                View more reviews
              </a>
            </center>
          </div>
        </div>
                                */}
      </section>
{/*
      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2>Data Analytics Blogs</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-interview-questions"
                >
                  <img src="assets/images/data-science-interview.jpeg" alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Data Analytics Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-introduction"
                >
                  <img
                    src="assets/images/mac/what-is-data-science-Intro.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Introduction : What is Data Analytics</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/machine-learning-interview-questions"
                >
                  <img
                    src="assets/images/mac/machine-learning-interview-question.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Machine Learning Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-scientist-salary"
                >
                  <img
                    src="assets/images/mac/Data-Scientist-Salary.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Data Scientist Salary in India</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
                              */}
{/*
      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2>Related Data Analytics Courses</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-Data-Science-ML-Program">
                  <img
                    src="assets/images/resources/advance_data_Science_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Advance Data Analytics & AI Program
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>5096 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-AI-ML-program">
                  <img
                    src="assets/images/resources/advance_ai_ml_program.jpg"
                    alt=""
                  />
                </Link>

                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>Advance AI & ML Program </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>8976 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/master-data-Science-ai-program">
                  <img
                    src="assets/images/resources/data_science_master_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Big Data & Data Analytics Program
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>10022 Learners</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-For-Freshers">
                  <img
                    src="assets/images/resources/Data-Science-Fundamental.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Analytics Course For Freshers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>986 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-Course-For-Managers">
                  <img
                    src="assets/images/resources/data-Science-for-Managers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Analytics Course For Managers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1786 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Practical-Decision-Making-in-Data-Science">
                  <img
                    src="assets/images/resources/Data-Science-Freshers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>AI Fundamental Course</h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1586 Learners</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
                            */}
{/*
      <section className="city-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 master-page-city-wrapper">
              <h4>
                <strong>
                  Find Data Analytics Course Training in Other Regions
                </strong>
              </h4>
              <div className="city-link-container">
                <Link
                  title="Data Analytics Course in Pune"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pune
                </Link>
                <Link
                  title="Data Analytics Course in Bangalore"
                  to="/Data-Science-Course-in-bangalore"
                >
                  Bangalore
                </Link>
                <Link
                  title="Data Analytics Course in Ahmedabad"
                  to="/Data-Science-Course-Ahmedabad"
                >
                  Ahmedabad
                </Link>
                <Link
                  title="Data Analytics Course in Bhilai"
                  to="/Data-Science-Course-Bhilai"
                >
                  Bhilai
                </Link>
                <Link
                  title="Data Analytics Course in Bhopal"
                  to="/Data-Science-Course-Bhopal"
                >
                  Bhopal
                </Link>
                <Link
                  title="Data Analytics Course in Bhubaneshwar"
                  to="/Data-Science-Course-Bhubaneshwar"
                >
                  Bhubaneshwar
                </Link>
                <Link
                  title="Data Analytics Course in Boston"
                  to="/Data-Science-Course-Boston"
                >
                  Boston
                </Link>
                <Link
                  title="Data Analytics Course in Chandigarh"
                  to="/Data-Science-Course-Chandigarh"
                >
                  Chandigarh
                </Link>
                <Link
                  title="Data Analytics Course in Chennai"
                  to="/Data-Science-Course-Chennai"
                >
                  Chennai
                </Link>
                <Link
                  title="Data Analytics Course in Chicago"
                  to="/Data-Science-Course-Chicago"
                >
                  Chicago
                </Link>
                <Link
                  title="Data Analytics Course in Cochin"
                  to="/Data-Science-Course-Cochin"
                >
                  Cochin
                </Link>
                <Link
                  title="Data Analytics Course in Coimbatore"
                  to="/Data-Science-Course-Coimbatore"
                >
                  Coimbatore
                </Link>
                <Link
                  title="Data Analytics Course in Dallas"
                  to="/Data-Science-Course-Dallas"
                >
                  Dallas
                </Link>
                <Link
                  title="Data Analytics Course in Dehradun"
                  to="/Data-Science-Course-Dehradun"
                >
                  Dehradun
                </Link>
                <Link
                  title="Data Analytics Course in Delhi"
                  to="/Data-Science-Course-Delhi"
                >
                  Delhi
                </Link>
                <Link
                  title="Data Analytics Course in Dubai"
                  to="/Data-Science-Course-Dubai"
                >
                  Dubai
                </Link>
                <Link
                  title="Data Analytics Course in Durban"
                  to="/Data-Science-Course-Durban"
                >
                  Durban
                </Link>
                <Link
                  title="Data Analytics Course in Faridabad"
                  to="/Data-Science-Course-Faridabad"
                >
                  Faridabad
                </Link>
                <Link
                  title="Data Analytics Course in Ghaziabad"
                  to="/Data-Science-Course-Ghaziabad"
                >
                  Ghaziabad
                </Link>
                <Link
                  title="Data Analytics Course in Guntur"
                  to="/Data-Science-Course-Guntur"
                >
                  Guntur
                </Link>
                <Link
                  title="Data Analytics Course in Gurgaon"
                  to="/Data-Science-Course-Gurgaon"
                >
                  Gurgaon
                </Link>
                <Link
                  title="Data Analytics Course in Guwahati"
                  to="/Data-Science-Course-Guwahati"
                >
                  Guwahati
                </Link>
                <Link
                  title="Data Analytics Course in HongKong"
                  to="/Data-Science-Course-HongKong"
                >
                  HongKong
                </Link>
                <Link
                  title="Data Analytics Course in Hyderabad"
                  to="/Data-Science-Course-Hyderabad"
                >
                  Hyderabad
                </Link>
                <Link
                  title="Data Analytics Course in Jaipur"
                  to="/Data-Science-Course-Jaipur"
                >
                  Jaipur
                </Link>
                <Link
                  title="Data Analytics Course in Johannesburg"
                  to="/Data-Science-Course-Johannesburg"
                >
                  Johannesburg
                </Link>
                <Link
                  title="Data Analytics Course in Los Kanpur"
                  to="/Data-Science-Course-Kanpur"
                >
                  Kanpur
                </Link>
                <Link
                  title="Data Analytics Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Analytics Course in Kolkata"
                  to="/Data-Science-Course-Kolkata"
                >
                  Kolkata
                </Link>
                <Link
                  title="Data Analytics Course in LosAngeles"
                  to="/Data-Science-Course-LosAngeles"
                >
                  LosAngeles
                </Link>
                <Link
                  title="Data Analytics Course in Lucknow"
                  to="/Data-Science-Course-Lucknow"
                >
                  Lucknow
                </Link>
                <Link
                  title="Data Analytics Course in Madurai"
                  to="/Data-Science-Course-Madurai"
                >
                  Madurai
                </Link>
                <Link
                  title="Data Analytics Course in Miami"
                  to="/Data-Science-Course-Miami"
                >
                  Miami
                </Link>
                <Link
                  title="Data Analytics Course in Mumbai"
                  to="/Data-Science-Course-Mumbai"
                >
                  Mumbai
                </Link>
                <Link
                  title="Data Analytics Course in Mysore"
                  to="/Data-Science-Course-Mysore"
                >
                  Mysore
                </Link>
                <Link
                  title="Data Analytics Course in Nagpur"
                  to="/Data-Science-Course-Nagpur"
                >
                  Nagpur
                </Link>
                <Link
                  title="Data Analytics Course in Noida"
                  to="/Data-Science-Course-Noida"
                >
                  Noida
                </Link>
                <Link
                  title="Data Analytics Course in Patna"
                  to="/Data-Science-Course-Patna"
                >
                  Patna
                </Link>
                <Link
                  title="Data Analytics Course in Pondicherry"
                  to="/Data-Science-Course-Pondicherry"
                >
                  Pondicherry
                </Link>
                <Link
                  title="Data Analytics Course in Ranchi"
                  to="/Data-Science-Course-Ranchi"
                >
                  Ranchi
                </Link>
                <Link
                  title="Data Analytics Course in Seattle"
                  to="/Data-Science-Course-Seattle"
                >
                  Seattle
                </Link>
                <Link
                  title="Data Analytics Course in Shimoga"
                  to="/Data-Science-Course-Shimoga"
                >
                  Shimoga
                </Link>
                <Link
                  title="Data Analytics Course in Surat"
                  to="/Data-Science-Course-Surat"
                >
                  Surat
                </Link>
                <Link
                  title="Data Analytics Course in Thane"
                  to="/Data-Science-Course-Thane"
                >
                  Thane
                </Link>
                <Link
                  title="Data Analytics Course in Thiruvananthapuram"
                  to="/Data-Science-Course-Thiruvananthapuram"
                >
                  Thiruvananthapuram
                </Link>
                <Link
                  title="Data Analytics Course in Tiruchchirappalli"
                  to="/Data-Science-Course-Tiruchchirappalli"
                >
                  Tiruchchirappalli
                </Link>
                <Link
                  title="Data Analytics Course in Tirupati"
                  to="/Data-Science-Course-Tirupati"
                >
                  Tirupati
                </Link>
                <Link
                  title="Data Analytics Course in Toronto"
                  to="/Data-Science-Course-Toronto"
                >
                  Toronto
                </Link>
                <Link
                  title="Data Analytics Course in Trichur"
                  to="/Data-Science-Course-Trichur"
                >
                  Trichur
                </Link>
                <Link
                  title="Data Analytics Course in Vadodara"
                  to="/Data-Science-Course-Vadodara"
                >
                  Vadodara
                </Link>
                <Link
                  title="Data Analytics Course in Visakhapatnam"
                  to="/Data-Science-Course-Visakhapatnam"
                >
                  Visakhapatnam
                </Link>
                <Link
                  title="Data Analytics Course in Warangal"
                  to="/Data-Science-Course-Warangal"
                >
                  Warangal
                </Link>
                <Link
                  title="Data Analytics Course in Washington"
                  to="/Data-Science-Course-Washington"
                >
                  Washington
                </Link>
                <Link
                  title="Data Analytics Course in Mountain View"
                  to="/Data-Science-Course-MountainView"
                >
                  Mountain View
                </Link>
                <Link
                  title="Data Analytics Course in Ashburn"
                  to="/Data-Science-Course-Ashburn"
                >
                  Ashburn
                </Link>
                <Link
                  title="Data Analytics Course in Charlotte"
                  to="/Data-Science-Course-Charlotte"
                >
                  Charlotte
                </Link>
                <Link
                  title="Data Analytics Course in Austin"
                  to="/Data-Science-Course-Austin"
                >
                  Austin
                </Link>
                <Link
                  title="Data Analytics Course in San Diego"
                  to="/Data-Science-Course-SanDiego"
                >
                  San Diego
                </Link>
                <Link
                  title="Data Analytics Course in Irving"
                  to="/Data-Science-Course-Irving"
                >
                  Irving
                </Link>
                <Link
                  title="Data Analytics Course in Columbus"
                  to="/Data-Science-Course-Columbus"
                >
                  Columbus
                </Link>
                <Link
                  title="Data Analytics Course in Sunnyvale"
                  to="/Data-Science-Course-Sunnyvale"
                >
                  Sunnyvale
                </Link>
                <Link
                  title="Data Analytics Course in Fremont"
                  to="/Data-Science-Course-Fremont"
                >
                  Fremont
                </Link>
                <Link
                  title="Data Analytics Course in Denver"
                  to="/Data-Science-Course-Denver"
                >
                  Denver
                </Link>
                <Link
                  title="Data Analytics Course in Philadelphia"
                  to="/Data-Science-Course-Philadelphia"
                >
                  Philadelphia
                </Link>
                <Link
                  title="Data Analytics Course in Vijayawada"
                  to="/Data-Science-Course-Vijayawada"
                >
                  Vijayawada
                </Link>
                <Link
                  title="Data Analytics Course in Ireland"
                  to="/Data-Science-Course-Ireland"
                >
                  Ireland
                </Link>

                <Link
                  title="Data Analytics Course in Jamshedpur"
                  to="/Data-Science-Course-Jamshedpur"
                >
                  Jamshedpur
                </Link>
                <Link
                  title="Data Analytics Course in Kerala"
                  to="/Data-Science-Course-Kerala"
                >
                  Kerala
                </Link>
                <Link
                  title="Data Analytics Course in TamilNadu"
                  to="/Data-Science-Course-TamilNadu"
                >
                  TamilNadu
                </Link>

                <Link
                  title="Data Analytics Course in AbuDhabi"
                  to="/Data-Science-Course-AbuDhabi"
                >
                  AbuDhabi
                </Link>
                <Link
                  title="Data Analytics Course in Ludhiana"
                  to="/Data-Science-Course-Ludhiana"
                >
                  Ludhiana
                </Link>
                <Link
                  title="Data Analytics Course in Ernakulam"
                  to="/Data-Science-Course-Ernakulam"
                >
                  Ernakulam
                </Link>
                <Link
                  title="Data Analytics Course in Kottayam"
                  to="/Data-Science-Course-Kottayam"
                >
                  Kottayam
                </Link>
                <Link
                  title="Data Analytics Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Analytics Course in Jacksonville"
                  to="/Data-Science-Course-Jacksonville"
                >
                  Jacksonville
                </Link>
                <Link
                  title="Data Analytics Course in Newark"
                  to="/Data-Science-Course-Newark"
                >
                  Newark
                </Link>
                <Link
                  title="Data Analytics Course in Pittsburgh"
                  to="/Data-Science-Course-Pittsburgh"
                >
                  Pittsburgh
                </Link>
                <Link
                  title="Data Analytics Course in Raleigh"
                  to="/Data-Science-Course-Raleigh"
                >
                  Raleigh
                </Link>
                <Link
                  title="Data Analytics Course in Salem"
                  to="/Data-Science-Course-Salem"
                >
                  Salem
                </Link>
                <Link
                  title="Data Analytics Course in Sarasota"
                  to="/Data-Science-Course-Sarasota"
                >
                  Sarasota
                </Link>
                <Link
                  title="Data Analytics Course in Tacoma"
                  to="/Data-Science-Course-Tacoma"
                >
                  Tacoma
                </Link>
                <Link
                  title="Data Analytics Course in Tampa"
                  to="/Data-Science-Course-Tampa"
                >
                  Tampa
                </Link>
                <Link
                  title="Data Analytics Course in Abuja"
                  to="/Data-Science-Course-Abuja"
                >
                  Abuja
                </Link>
                <Link
                  title="Data Analytics Course in Lagos"
                  to="/Data-Science-Course-Lagos"
                >
                  Lagos
                </Link>
                <Link
                  title="Data Analytics Course in Manila"
                  to="/Data-Science-Course-Manila"
                >
                  Manila
                </Link>
                <Link
                  title="Data Analytics Course in CapeTown"
                  to="/Data-Science-Course-CapeTown"
                >
                  CapeTown
                </Link>
                <Link
                  title="Data Analytics Course in Calgary"
                  to="/Data-Science-Course-Calgary"
                >
                  Calgary
                </Link>
                <Link
                  title="Data Analytics Course in Montreal"
                  to="/Data-Science-Course-Montreal"
                >
                  Montreal
                </Link>
                <Link
                  title="Data Analytics Course in Vancouver"
                  to="/Data-Science-Course-Vancouver"
                >
                  Vancouver
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
                          */}

      <section id="faqs" className="faqnewbg py-0">
        <div className="container">
          <h2>
            <b>Frequently Asked Questions (FAQs)</b>
          </h2>
          <div className="faqnewbg-inner">
            <div className="faqnew">
              <div className="accordion" id="accordionExample2">
                <div className="card">
                  <div className="card-header" id="heading00">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse00"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What is Logicmojo's
                        " Data Analytics Course"?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse00"
                    className="collapse"
                    aria-labelledby="heading00"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        Logicmojo offers a comprehensive Data Analytics Course
                        designed to equip individuals with the skills and
                        knowledge necessary for a successful career in data
                        analysis. The course, tailored to meet the latest
                        industry demands, covers a wide range of topics and
                        provides practical experience. Here's what you can
                        expect:
                      </p>

                      <b>Course Highlights:</b>
                      <ul>
                        <li>
                          <i>Data Analysis Tools:</i> You'll learn to work with
                          essential data analysis tools such as Python, SQL, and
                          data visualization tools.
                        </li>
                        <li>
                          <i>Statistical Analysis:</i> Gain proficiency in
                          statistical analysis, hypothesis testing, and
                          regression techniques.
                        </li>
                        <li>
                          <i>Real-World Projects:</i> Apply your skills to real
                          data analysis projects, developing a strong portfolio.
                        </li>
                        <li>
                          <i>Machine Learning:</i> Explore machine learning
                          techniques for predictive analytics.
                        </li>
                        <li>
                          <i>Business Cases:</i> Analyze real business cases to
                          understand data-driven decision-making.
                        </li>
                      </ul>

                      <b>Additional Certifications:</b>
                      <p>
                        Logicmojo's course often includes multiple
                        certifications, including a course completion
                        certificate, internship onboarding certificate, and
                        internship completion certificate, enhancing your
                        credentials.
                      </p>

                      <b>Mentorship and Support:</b>
                      <p>
                        The course offers mentorship from industry experts, job
                        assistance, and support sessions for a holistic learning
                        experience.
                      </p>

                      <p>
                        Logicmojo's Data Analytics Course opens doors to various
                        career opportunities in data analysis and equips you
                        with the necessary skills to excel in this rapidly
                        growing field.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading02">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse02"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Who Should Take
                        Logicmojo's Data Analytics Course ?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse02"
                    className="collapse"
                    aria-labelledby="heading02"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        If you are looking to embark on a data-driven career and
                        harness the power of data for informed decision-making,
                        Logicmojo's Data Analytics Course is tailored for you.
                        This course caters to a diverse audience and is suitable
                        for:
                      </p>

                      <b>1. Aspiring Data Analysts:</b>
                      <ul>
                        <li>
                          Individuals who are new to the field of data analysis
                          and want to build a strong foundation in data
                          analytics.
                        </li>
                      </ul>

                      <b>2. Career Changers:</b>
                      <ul>
                        <li>
                          Professionals from various backgrounds looking to
                          transition into data analysis and leverage data for
                          their career growth.
                        </li>
                      </ul>

                      <b>3. Recent Graduates:</b>
                      <ul>
                        <li>
                          Recent graduates seeking to enhance their job
                          prospects and acquire practical skills in data
                          analysis.
                        </li>
                      </ul>

                      <b>4. Business Professionals:</b>
                      <ul>
                        <li>
                          Business professionals, including managers and
                          entrepreneurs, who want to make data-driven decisions
                          and understand the power of data analytics.
                        </li>
                      </ul>

                      <b>5. Anyone Interested in Data:</b>
                      <ul>
                        <li>
                          Enthusiasts who are curious about data analysis and
                          its applications across various industries.
                        </li>
                      </ul>

                      <p>
                        With no prior programming knowledge required, this
                        course accommodates beginners and equips them with the
                        skills needed for a successful career in data analytics,
                        regardless of their background.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading04">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse04"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> How much time do I
                        have to commit to this certification course?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse04"
                    className="collapse"
                    aria-labelledby="heading04"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        To successfully complete the Data Analytics
                        Certification Course, you should be prepared to dedicate
                        approximately 10 - 12 hours per week to your learning
                        journey.
                      </p>

                      <p>
                        This program offers flexibility in terms of class
                        schedules. You can choose from classes conducted on both
                        weekends and weekdays, depending on your batch's
                        availability. This flexibility ensures that you can
                        balance your learning with your existing commitments and
                        responsibilities.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading050">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse050"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What type of
                        learning experience should I expect to be a Data
                        Analyst?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse050"
                    className="collapse"
                    aria-labelledby="heading050"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        As a participant in Logicmojo's Data Analytics Course,
                        you can anticipate an immersive and hands-on learning
                        journey designed to equip you with the knowledge and
                        skills necessary to excel as a data analyst. The
                        learning experience includes:
                      </p>

                      <b>1. Enriched Content:</b>
                      <ul>
                        <li>
                          You'll have access to comprehensive and up-to-date
                          course materials, including interactive lectures by
                          industry experts and esteemed faculty members.
                        </li>
                      </ul>

                      <b>2. Live Sessions:</b>
                      <ul>
                        <li>
                          Engage in live lectures and interactive hangout
                          sessions that allow for real-time Q&A, academic
                          support, and clarification of concepts. This
                          facilitates a dynamic learning experience.
                        </li>
                      </ul>

                      <b>3. Peer Interaction:</b>
                      <ul>
                        <li>
                          Connect and collaborate with fellow learners through
                          peer-to-peer interactions, discussions, and group
                          activities, promoting a supportive learning community.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <button
                  onClick={() => setTg(!toggle)}
                  className="btn btn-primary mb-3 viewmorebtn"
                >
                  {toggle ? "View Less" : "View More"}
                </button>

                {toggle && (
                  <div className="morefaq">
                    <div className="card">
                      <div className="card-header" id="heading07">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse07"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            job opportunities after Data Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse07"
                        className="collapse"
                        aria-labelledby="heading07"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Upon completing Logicmojo's Data Analytics Course,
                            you'll find a range of enticing job opportunities
                            tailored to your specialization. Logicmojo provides
                            personalized recommendations based on your
                            background and skills. Here's an overview of
                            potential career paths:
                          </p>

                          <ul>
                            <li>
                              <b>Deep Learning:</b> Ideal for engineers,
                              software professionals, and IT experts who want to
                              delve into advanced machine learning and neural
                              networks.
                            </li>
                            <li>
                              <b>Natural Language Processing:</b> Suited for
                              engineers, software professionals, and IT experts
                              with an interest in language-related applications,
                              like chatbots and sentiment analysis.
                            </li>
                            <li>
                              <b>Business Intelligence/Data Analytics:</b> An
                              excellent choice for engineers, marketing and
                              sales professionals, and freshers aiming to work
                              with data analysis, reporting, and
                              decision-making.
                            </li>
                            <li>
                              <b>Business Analytics:</b> Perfect for engineers,
                              managers, marketing and sales professionals, and
                              domain experts looking to apply data insights to
                              improve business strategies.
                            </li>
                            <li>
                              <b>Data Engineering:</b> Designed for software and
                              IT professionals focused on data architecture, ETL
                              processes, and data warehousing.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I become
                            data analyst after 12th?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            If you aspire to become a data analyst after
                            completing your 12th grade, there are several
                            pathways available in 2023 to achieve this goal.
                            While a direct career as a data analyst right after
                            12th grade is less common, it's entirely possible
                            with the right education and training. Here are the
                            key steps to consider:
                          </p>

                          <ul>
                            <li>
                              <b>Pursue a Bachelor's Degree:</b> Start by
                              enrolling in a bachelor's program related to data
                              science, data analytics, or a similar field. These
                              programs typically require you to have a strong
                              foundation in mathematics, so make sure to meet
                              the admission criteria.
                            </li>
                            <li>
                              <b>Choose Relevant Courses:</b> Complement your
                              degree with courses in statistics, programming,
                              and data analysis to build a solid skill set.
                            </li>
                            <li>
                              <b>Educational Institutions:</b> Many universities
                              and colleges offer undergraduate programs in data
                              science, which can be a great way to begin your
                              journey as a data analyst.
                            </li>
                            <li>
                              <b>Pursue a Master's Degree (Optional):</b>{" "}
                              Although not mandatory, a master's degree in data
                              analytics or Data Analytics can enhance your career
                              prospects by providing advanced knowledge and
                              expertise.
                            </li>
                            <li>
                              <b>Online Courses:</b> Alternatively, you can
                              start building your skills right after 12th grade
                              by enrolling in online data analytics courses,
                              which often provide certificates of completion.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Analytics Course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A Flexi Subscription in the Data Analytics Course
                            offers:
                          </p>

                          <ul>
                            <li>
                              Access to live classroom training in Data
                              Analytics.
                            </li>
                            <li>
                              2 years of access to ongoing batch information.
                            </li>
                            <li>
                              The ability to attend live sessions from any
                              batch, providing flexibility in learning.
                            </li>
                            <li>
                              An opportunity for participants to learn at their
                              own pace, accommodating various schedules,
                              including those who work shifts or weekends.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What study
                            material will be provided to me for the Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              Online live lectures on weekdays and online or
                              classroom sessions on weekends for core learning.
                            </li>
                            <li>
                              Recordings of the online lectures for convenient
                              review and reference.
                            </li>
                            <li>
                              Access to comprehensive student notes, exercises,
                              and additional study materials.
                            </li>
                            <li>
                              Assessments to track your progress and
                              understanding.
                            </li>
                            <li>
                              Full integration with an online learning portal
                              for easy access and organization of resources.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which stream is
                            best for data analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse11"
                        className="collapse"
                        aria-labelledby="heading11"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            When it comes to pursuing a career in data
                            analytics, the choice of an academic stream can play
                            a crucial role in building the necessary foundation.
                            In 2023, the ideal stream for aspiring data analysts
                            is typically the science stream. This stream is
                            often recommended because it provides a strong base
                            in subjects that are directly relevant to data
                            analysis.
                          </p>

                          <p>
                            Here's why the science stream is considered one of
                            the best choices:
                          </p>

                          <ul>
                            <li>
                              <b>Mathematics:</b> The science stream includes
                              advanced mathematics, which is fundamental for
                              data analysis. It equips students with the
                              mathematical and statistical skills required for
                              data interpretation and analysis.
                            </li>
                            <li>
                              <b>Statistics:</b> Many science stream curricula
                              incorporate statistics as a subject. Statistics is
                              at the core of data analysis, and a strong
                              foundation in this area is invaluable.
                            </li>
                            <li>
                              <b>Analytical Thinking:</b> The science stream
                              promotes analytical thinking and problem-solving
                              skills, which are essential for dissecting complex
                              data sets and drawing meaningful insights.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What knowledge
                            can be gained from this top-notch Logicmojo's Data
                            Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse12"
                        className="collapse"
                        aria-labelledby="heading12"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo's Data Analytics Course is designed to
                            provide learners with comprehensive knowledge and
                            practical skills in the field of data analytics.
                            Here are the key areas of knowledge that
                            participants can expect to gain from this top-notch
                            course:
                          </p>

                          <ul>
                            <li>
                              <b>Data Analysis Techniques:</b> The course covers
                              various data analysis techniques, including
                              statistical analysis, data visualization, and
                              machine learning. Participants will learn how to
                              process and analyze data to extract meaningful
                              insights.
                            </li>
                            <li>
                              <b>Data Visualization:</b> Learners will acquire
                              the skills to create informative and visually
                              appealing data visualizations using tools like
                              Power BI and other data visualization platforms.
                            </li>
                            <li>
                              <b>SQL and Database Management:</b> The course
                              provides a solid foundation in SQL, a critical
                              skill for data analysis. Participants will learn
                              how to retrieve, manipulate, and manage data
                              stored in databases.
                            </li>
                            <li>
                              <b>Machine Learning:</b> Machine learning is a key
                              focus of the course, enabling participants to
                              understand and apply various machine learning
                              algorithms to real-world data analysis problems.
                            </li>
                            <li>
                              <b>Business Case Studies:</b> The course includes
                              practical business case studies that allow
                              learners to apply their data analysis skills to
                              solve real-world problems.
                            </li>
                            <li>
                              <b>Data Ethics:</b> Participants will gain an
                              understanding of the ethical considerations and
                              best practices in data analytics, ensuring
                              responsible data usage.
                            </li>
                            <li>
                              <b>Project Experience:</b> Logicmojo's Data
                              Analytics Course emphasizes hands-on experience
                              through projects, allowing learners to apply their
                              knowledge in a practical context.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading14">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse14"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the job
                            of data analyst? / What Does a Data Analyst Do?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse14"
                        className="collapse"
                        aria-labelledby="heading14"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A data analyst plays a crucial role in the modern
                            business landscape, contributing to data-driven
                            decision-making and problem-solving. Here's an
                            in-depth look at what a data analyst does:
                          </p>

                          <ul>
                            <li>
                              <b>Data Review:</b> Data analysts are responsible
                              for collecting, cleaning, and organizing data from
                              various sources. They review and scrutinize data
                              to identify patterns, trends, and valuable
                              insights that can help organizations better
                              understand their customers and operations.
                            </li>
                            <li>
                              <b>Insight Generation:</b> One of the primary
                              tasks of a data analyst is to extract actionable
                              insights from data. They use statistical and data
                              analysis techniques to uncover meaningful
                              information that can drive business improvements.
                            </li>
                            <li>
                              <b>Problem Solving:</b> Data analysts use data to
                              solve complex business problems. They identify
                              challenges and opportunities within an
                              organization and propose data-driven solutions and
                              strategies to address them.
                            </li>
                            <li>
                              <b>Communication:</b> Effective communication is
                              key. Data analysts must convey their findings and
                              insights to company leadership and stakeholders.
                              This involves creating reports, visualizations,
                              and presentations that make data accessible to
                              non-technical audiences.
                            </li>
                            <li>
                              <b>Data Visualization:</b> Data analysts often use
                              data visualization tools to create charts, graphs,
                              and dashboards that make complex data more
                              understandable and actionable for decision-makers.
                            </li>
                            <li>
                              <b>Continuous Learning:</b> The field of data
                              analysis is dynamic, with new tools and techniques
                              emerging regularly. Data analysts need to stay
                              updated with the latest trends and technologies to
                              remain effective in their roles.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading15">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse15"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Is Data
                            Analytics a Lucrative Career Choice?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse15"
                        className="collapse"
                        aria-labelledby="heading15"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data analytics is undeniably one of the most
                            promising and rewarding career choices in today's
                            data-driven world. Here's why:
                          </p>

                          <ul>
                            <li>
                              <b>Abundant Opportunities:</b> Data analytics is a
                              versatile field with applications in virtually
                              every industry, from healthcare and finance to
                              e-commerce and entertainment. This versatility
                              means there's a wide range of job opportunities
                              available.
                            </li>
                            <li>
                              <b>Competitive Salaries:</b> The earning potential
                              for data analysts is impressive. Entry-level
                              positions can offer salaries reaching nearly
                              10,00,000 Indian Rupees per annum (LPA). As
                              professionals gain experience and expertise, their
                              earning capacity can increase substantially.
                            </li>
                            <li>
                              <b>Continuous Growth:</b> The data analytics field
                              is continually evolving. With the advent of big
                              data, artificial intelligence, and machine
                              learning, the demand for skilled data analysts is
                              expected to grow. This field rewards professionals
                              who stay updated on emerging trends and
                              technologies.
                            </li>
                            <li>
                              <b>Problem-Solving and Impact:</b> Data analysts
                              have the opportunity to work on real-world
                              challenges and contribute to data-driven
                              decision-making. Their insights can directly
                              impact a company's performance and success.
                            </li>
                            <li>
                              <b>Global Relevance:</b> Data analytics skills are
                              in demand not only in India but also worldwide.
                              This global relevance means data analysts can
                              explore job opportunities internationally.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading16">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse16"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I join data
                            analyst as a fresher?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse16"
                        className="collapse"
                        aria-labelledby="heading16"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Entering the data analytics field as a fresher is
                            not only possible but increasingly common in today's
                            job market. Here's how you can kickstart your career
                            as an entry-level data analyst:
                          </p>

                          <ul>
                            <li>
                              <b>Educational Path:</b> Graduating from a data
                              analytics course or bootcamp provides you with the
                              necessary skills and knowledge to get started.
                              These programs often cover data analysis tools,
                              techniques, and best practices.
                            </li>
                            <li>
                              <b>Portfolio Building:</b> As a fresher, building
                              a strong portfolio can be a game-changer. Work on
                              personal or open-source projects that showcase
                              your data analysis skills. Include these projects
                              in your resume to demonstrate your capabilities.
                            </li>
                            <li>
                              <b>Internships and Part-Time Roles:</b> Consider
                              internships or part-time positions to gain
                              practical experience. These opportunities can help
                              you apply your knowledge in a real-world setting
                              and make valuable industry connections.
                            </li>
                            <li>
                              <b>Entry-Level Positions:</b> Many companies
                              actively seek entry-level data analysts who
                              exhibit potential and a willingness to learn.
                              Applying for junior or trainee roles is a
                              strategic move to get your foot in the door.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading17">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse17"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I become
                            data analyst in 3 months?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse17"
                        className="collapse"
                        aria-labelledby="heading17"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Transitioning into a data analyst role in just three
                            months is an ambitious but feasible goal, depending
                            on your dedication and prior experience. Here's a
                            general path to consider:
                          </p>

                          <ul>
                            <li>
                              <b>Research and Planning:</b> Spend time
                              researching the field of data analytics.
                              Understand the core concepts, tools, and
                              technologies. Develop a clear plan of action for
                              your three-month journey.
                            </li>
                            <li>
                              <b>Relevant Coursework:</b> Enroll in a structured
                              data analytics course that covers key topics like
                              data analysis, statistical methods, and
                              programming languages. Platforms like Logicmojo
                              offer comprehensive training programs.
                            </li>
                            <li>
                              <b>Technical Skills:</b> Focus on building
                              technical skills, particularly in data analysis
                              tools and languages. Python and SQL are essential
                              for a data analyst's toolkit. Practice data
                              manipulation, visualization, and statistical
                              analysis.
                            </li>
                            <li>
                              <b>Programming Languages:</b> Review and
                              strengthen your knowledge of programming
                              languages. Proficiency in Python and SQL is highly
                              valued in the field.
                            </li>
                            <li>
                              <b>Soft Skills:</b> Develop soft skills such as
                              problem-solving, critical thinking, and effective
                              communication. Data analysts often need to convey
                              complex findings to non-technical stakeholders.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading18">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse18"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            time commitment expected for the course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse18"
                        className="collapse"
                        aria-labelledby="heading18"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Successful completion of the Data Analytics program
                            typically requires a time commitment of at least
                            10-12 hours per week. This program is designed to
                            offer a comprehensive curriculum while remaining
                            accessible to working professionals, making it
                            manageable for learners with various schedules.
                          </p>

                          <p>
                            The time commitment can vary based on individual
                            learning speed and prior experience. Here's a
                            breakdown of how this commitment might be
                            distributed:
                          </p>

                          <ul>
                            <li>
                              <b>Lectures and Coursework:</b> Attend online
                              lectures and engage with course materials,
                              including videos, readings, and assignments.
                            </li>
                            <li>
                              <b>Hands-On Projects:</b> Allocate time for
                              hands-on projects, which are crucial for practical
                              skill development.
                            </li>
                            <li>
                              <b>Interactive Sessions:</b> Participate in
                              interactive sessions, workshops, and discussions,
                              which enhance understanding and provide
                              opportunities for peer learning.
                            </li>
                            <li>
                              <b>Assessments and Examinations:</b> Prepare for
                              and complete assessments and examinations that
                              evaluate your comprehension of the course
                              material.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading19">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse19"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How will my
                            doubts/questions be addressed in an online course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse19"
                        className="collapse"
                        aria-labelledby="heading19"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Online data analytics courses provide a structured
                            framework for addressing doubts and questions to
                            ensure an enriching learning experience. To assist
                            students in understanding the material thoroughly,
                            the following methods are typically employed:
                          </p>

                          <ul>
                            <li>
                              <b>Peer-to-Peer Discussion Forum:</b> These
                              courses often include a peer-to-peer discussion
                              forum where students can post their questions.
                              Peers, faculty members, or teaching assistants
                              usually respond to queries within a day, promoting
                              collaborative learning and problem-solving.
                            </li>
                            <li>
                              <b>Regular Q&A Sessions:</b> Online courses
                              frequently organize regular Q&A sessions with
                              faculty members. During these sessions, students
                              can seek clarifications on conceptual doubts or
                              challenging topics, fostering a deeper
                              understanding of the subject matter.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading20">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse20"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            future scope of Data Analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse20"
                        className="collapse"
                        aria-labelledby="heading20"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data analytics has emerged as a dynamic and
                            promising field with significant growth prospects.
                            As of 2023, the industry continues to expand, and
                            the future looks even more promising. Here are some
                            key points to consider:
                          </p>

                          <ul>
                            <li>
                              <b>Steady Growth:</b> The data analytics industry
                              is experiencing steady growth and is expected to
                              keep expanding. Market predictions indicate that
                              it may reach a value of US$11.87 billion by 2026.
                              This sustained growth is indicative of the
                              industry's robust nature.
                            </li>
                            <li>
                              <b>Market Disruption:</b> Data analytics has the
                              potential to disrupt various markets and
                              industries. By harnessing the power of data,
                              organizations can make informed decisions,
                              optimize processes, and gain a competitive edge.
                              This disruption is reshaping traditional business
                              models and strategies.
                            </li>
                            <li>
                              <b>Job Opportunities:</b> The growth of the data
                              analytics industry brings a surge in job
                              opportunities. As more organizations recognize the
                              value of data-driven insights, they seek
                              professionals with data analytics skills. This
                              trend offers a promising career path for
                              individuals looking to enter the field.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading21">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse21"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Does Google
                            hire data analysts?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse21"
                        className="collapse"
                        aria-labelledby="heading21"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Google, one of the tech giants, actively recruits
                            data analysts, offering a wide range of job
                            opportunities across various divisions. As of 2023,
                            Google maintains a dedicated job board specifically
                            for data analytics roles, showcasing its commitment
                            to data-driven decision-making. Here are some key
                            insights into Google's hiring practices for data
                            analysts:
                          </p>

                          <ul>
                            <li>
                              <b>Diverse Roles:</b> Google's data analytics job
                              openings cover a broad spectrum, from entry-level
                              positions suitable for beginners to senior roles
                              like data scientists and engineers. This diversity
                              in roles enables individuals with varying levels
                              of experience to find suitable opportunities.
                            </li>
                            <li>
                              <b>Team Specializations:</b> Google's teams that
                              are actively hiring data analysts encompass a
                              variety of fields. Examples include Google Cloud
                              Analytics, YouTube Analytics, Search Quality
                              Analytics, and more. These specialized teams work
                              on cutting-edge projects, offering a rich and
                              challenging work environment for data
                              professionals.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading22">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse22"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            process of getting into the placement pool ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse22"
                        className="collapse"
                        aria-labelledby="heading22"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Joining the placement pool at Logicmojo's Data
                            Analytics Course involves a structured process
                            designed to ensure that learners are well-prepared
                            and equipped for successful job placements.
                          </p>

                          <p>
                            First and foremost, learners must complete the
                            course satisfactorily. This includes diligently
                            submitting all projects and assignments,
                            demonstrating their proficiency and commitment to
                            the program. Successful project completion showcases
                            a learner's practical skills and understanding of
                            the course material.
                          </p>

                          <p>
                            Furthermore, learners must pass the Placement
                            Readiness Test (PRT). This test is a pivotal step in
                            assessing a learner's preparedness for job
                            placements. It evaluates their knowledge, skills,
                            and aptitude, ensuring they meet the necessary
                            standards for employability.
                          </p>

                          <p>
                            Once a learner has met these criteria by completing
                            the course and passing the PRT, they gain access to
                            the Logicmojo job portal. This portal provides a
                            gateway to numerous job opportunities, connecting
                            learners with potential employers and career
                            prospects.
                          </p>

                          <p>
                            In addition to job listings, learners in the
                            placement pool can participate in career mentoring
                            sessions. These sessions offer valuable insights,
                            guidance, and support to help learners navigate the
                            job market successfully.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading23">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse23"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is data analyst
                            still in demand in 2023?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse23"
                        className="collapse"
                        aria-labelledby="heading23"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In 2023, the role of a data analyst continues to be
                            in high demand, making it a promising and viable
                            career choice. Several factors contribute to the
                            sustained demand for data analysts:
                          </p>

                          <ul>
                            <li>
                              <b>Data-Driven Decision-Making:</b> Organizations
                              across various industries increasingly rely on
                              data to make informed decisions. Data analysts
                              play a pivotal role in gathering, analyzing, and
                              interpreting data to provide valuable insights,
                              influencing crucial business choices.
                            </li>
                            <li>
                              <b>Business Intelligence:</b> As companies expand
                              their operations, there is a growing emphasis on
                              business intelligence and data-driven strategies.
                              Data analysts are essential for translating raw
                              data into actionable business intelligence,
                              helping companies remain competitive in their
                              respective markets.
                            </li>
                            <li>
                              <b>Technological Advancements:</b> Advancements in
                              technology have led to an explosion of data
                              generation. This surge in data volume requires
                              skilled professionals to manage and analyze it
                              efficiently. Data analysts are well-equipped to
                              handle the ever-increasing data streams.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading24">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse24"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Will I receive
                            special different career services in each
                            specialization?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse24"
                        className="collapse"
                        aria-labelledby="heading24"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo's Data Analytics course offers a range of
                            specializations tailored to students' backgrounds,
                            each designed to provide targeted support for a
                            successful career transition. However, when it comes
                            to career services, the approach remains consistent
                            across all specializations.
                          </p>

                          <p>
                            Irrespective of the chosen track, all students
                            benefit from a uniform set of career services,
                            ensuring that they receive the highest level of
                            support. These services include:
                          </p>

                          <ul>
                            <li>
                              <b>Live Sessions:</b> Regular live sessions are
                              available for all students, providing
                              opportunities for learning and interaction.
                            </li>
                            <li>
                              <b>Industry Mentorship:</b> Guidance from industry
                              mentors is accessible to all learners, offering
                              valuable insights and networking opportunities.
                            </li>
                            <li>
                              <b>Preparatory Support:</b> Career preparation and
                              skill development are consistent components of the
                              program to assist students in achieving their
                              professional goals.
                            </li>
                            <li>
                              <b>Access to Opportunities:</b> Regardless of the
                              specialization track, students gain access to
                              relevant job opportunities that align with their
                              chosen path.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading25">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse25"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How do I know
                            if the Course is right for me?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse25"
                        className="collapse"
                        aria-labelledby="heading25"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Determining whether Logicmojo's Data Analytics
                            course is the right choice for your career goals
                            requires a thoughtful evaluation. Consider the
                            following aspects to make an informed decision:
                          </p>

                          <ul>
                            <li>
                              <b>Curriculum:</b> Review the curriculum to ensure
                              it aligns with your career aspirations. Check if
                              it covers the necessary skills and knowledge for
                              your desired role in data analytics.
                            </li>
                            <li>
                              <b>Learning Outcomes:</b> Understand the expected
                              learning outcomes. Are they in line with what you
                              aim to achieve in your data analytics career?
                            </li>
                            <li>
                              <b>Interest in Data Analysis:</b> Data analysis
                              involves uncovering valuable insights from data.
                              If you find joy in this process and are
                              enthusiastic about influencing business decisions
                              through data-driven analysis, this program may be
                              a great fit.
                            </li>
                            <li>
                              <b>Analytical Aptitude:</b> Having an analytical
                              mindset is crucial. If you naturally enjoy
                              problem-solving, critical thinking, and working
                              with data, you are likely a good candidate.
                            </li>
                            <li>
                              <b>Selection Test:</b> Successfully clearing the
                              selection test, or being exempt from it, is an
                              important criterion. If you meet this requirement
                              and are eager to transition into a data analyst
                              role, the program is well-suited for you.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading26">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse26"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Do Data
                            Analysts Require Coding?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse26"
                        className="collapse"
                        aria-labelledby="heading26"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Whether data analysts need to code depends on the
                            specific job and industry. Here's an explanation:
                          </p>

                          <p>
                            Some data analysts indeed perform coding as part of
                            their daily responsibilities, particularly those
                            working in data-intensive fields or industries that
                            demand advanced data manipulation and modeling.
                            Coding allows them to access, clean, and process
                            data efficiently using languages like Python or R.
                          </p>

                          <p>
                            However, it's essential to note that coding skills
                            are not universally mandatory for all data analyst
                            roles. Many data analyst positions may focus on
                            using data visualization tools, spreadsheets, or
                            specialized software that doesn't require extensive
                            coding. The emphasis may be on data interpretation,
                            reporting, and generating actionable insights rather
                            than writing complex code.
                          </p>

                          <p>
                            Therefore, whether coding is required for a data
                            analyst role depends on the specific job description
                            and industry. It's advisable for aspiring data
                            analysts to assess the coding requirements of their
                            desired positions and acquire relevant skills
                            accordingly.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading27">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse27"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            difference between data analysis vs data analytics
                            vs data analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse27"
                        className="collapse"
                        aria-labelledby="heading27"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data Analysis, Data Analytics, and Data Analysts are
                            distinct yet interrelated terms in the field of data
                            science and business intelligence. Here's a
                            breakdown of their differences:
                          </p>

                          <b>Data Analytics:</b>
                          <ul>
                            <li>
                              Data analytics encompasses the comprehensive
                              process of discovering, interpreting, visualizing,
                              and reporting patterns within data. Its primary
                              goal is to drive business strategy, facilitate
                              informed decisions, and improve outcomes.
                            </li>
                          </ul>

                          <b>Data Analysis:</b>
                          <ul>
                            <li>
                              Data analysis is a subset of data analytics. It
                              involves specific actions like data cleaning,
                              transformation, modeling, and querying to extract
                              meaningful insights from a pre-prepared dataset.
                              Data analysis focuses on understanding the
                              information contained within a single dataset.
                            </li>
                          </ul>

                          <b>Data Analysts:</b>
                          <ul>
                            <li>
                              Data analysts are professionals equipped with both
                              technical expertise and effective communication
                              skills. Their role is to extract valuable insights
                              from data. They bridge the gap between raw data
                              and actionable recommendations. Data analysts are
                              adept at deriving and presenting quantitative
                              findings to technical and non-technical
                              stakeholders, helping organizations make
                              data-driven decisions.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading28">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse28"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How do I become
                            a data analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse28"
                        className="collapse"
                        aria-labelledby="heading28"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Becoming a data analyst is an achievable goal, and
                            it typically involves the following steps:
                          </p>

                          <b>1. Educational Qualifications:</b>
                          <ul>
                            <li>
                              Start by earning a Bachelor's or Master's degree
                              in a relevant field such as statistics, computer
                              science, or IT. These degrees provide a strong
                              foundation for data analysis.
                            </li>
                          </ul>

                          <b>2. Skill Development:</b>
                          <ul>
                            <li>
                              Acquire the necessary skills for data analysis.
                              This includes proficiency in data manipulation,
                              statistical analysis, data visualization, and
                              knowledge of tools and programming languages such
                              as Python, R, SQL, and data visualization tools
                              like Tableau or Power BI.
                            </li>
                          </ul>

                          <b>3. Gain Practical Experience:</b>
                          <ul>
                            <li>
                              Seek internships, part-time jobs, or entry-level
                              positions to gain real-world experience in data
                              analysis. Practical experience is invaluable for
                              developing problem-solving skills and building
                              your portfolio.
                            </li>
                          </ul>

                          <b>4. Consider Certification:</b>
                          <ul>
                            <li>
                              Consider obtaining certifications from reputable
                              institutions or platforms. Certifications can
                              validate your skills and make you a more
                              competitive candidate.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading29">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse29"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What Tools Do
                            Data Analysts Use?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse29"
                        className="collapse"
                        aria-labelledby="heading29"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data analysts rely on a variety of tools to perform
                            their tasks efficiently. These tools aid in data
                            collection, analysis, visualization, and reporting.
                            Some essential tools used by data analysts include:
                          </p>

                          <ul>
                            <li>
                              <b>Microsoft Excel:</b> Excel is a fundamental
                              tool for data manipulation, basic analysis, and
                              creating simple visualizations.
                            </li>
                            <li>
                              <b>Python and R:</b> These programming languages
                              are widely used for data cleaning, statistical
                              analysis, and machine learning. Python's
                              libraries, such as Pandas and NumPy, and R's
                              packages, make them indispensable.
                            </li>
                            <li>
                              <b>SQL:</b> Structured Query Language is essential
                              for database management, querying, and data
                              retrieval.
                            </li>
                            <li>
                              <b>Data Visualization Tools:</b> Tools like
                              Tableau, Power BI, and matplotlib enable analysts
                              to create insightful visualizations and
                              dashboards.
                            </li>
                            <li>
                              <b>Jupyter Notebook:</b> Jupyter notebooks provide
                              an interactive environment for coding,
                              documentation, and visualization.
                            </li>
                            <li>
                              <b>Version Control:</b> Git and platforms like
                              GitHub are used for collaborative work and
                              tracking code changes.
                            </li>
                            <li>
                              <b>Machine Learning Frameworks:</b> For predictive
                              modeling and machine learning, libraries like
                              scikit-learn and TensorFlow are employed.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading30">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse30"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors are allotted per batch?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse30"
                        className="collapse"
                        aria-labelledby="heading30"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo's commitment to personalized learning
                            includes offering mentorship to learners. The
                            mentorship program is carefully designed to provide
                            valuable guidance and support throughout your Data
                            Analytics journey.
                          </p>
                          <ul>
                            <li>
                              <b>Mentor Selection:</b> At the beginning of the
                              course, learners are presented with a pool of
                              mentors. The selection process allows you to
                              choose one mentor from this pool. This choice is
                              crucial as it allows you to connect with a mentor
                              whose background aligns with your goals and
                              interests.
                            </li>

                            <li>
                              <b>Personalized Guidance:</b> Your chosen mentor
                              becomes your point of contact for personalized
                              guidance. They offer insights, answer your
                              queries, and provide assistance to help you excel
                              in the course.
                            </li>

                            <li>
                              <b>Background Alignment:</b> Logicmojo strives to
                              match mentors with learners who share similar
                              backgrounds or aspirations. This relatability
                              enhances the effectiveness of the mentorship
                              relationship.
                            </li>

                            <li>
                              <b>Continuous Support:</b> Throughout the course,
                              your mentor remains accessible to address your
                              concerns and provide clarity on course materials.
                              They can also offer career advice and insights
                              into the tech industry.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading32">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse32"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there any
                            minimum educational qualification required to take
                            this Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse32"
                        className="collapse"
                        aria-labelledby="heading32"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To enroll in the Logicmojo Data Analytics Course,
                            you are required to meet certain educational
                            qualifications. The minimum educational requirement
                            is a <b>Bachelor's Degree</b> with a minimum of{" "}
                            <b>50% passing marks</b>. This criterion ensures
                            that learners have a foundational understanding of
                            educational concepts, which can be beneficial in the
                            data analytics field.
                          </p>

                          <p>
                            It's important to note that{" "}
                            <b>no coding experience is required</b> to join the
                            course. This means that individuals from various
                            academic backgrounds can pursue this program, even
                            if they don't have prior coding knowledge.
                            Logicmojo's data analytics course is designed to
                            cater to a diverse range of learners, providing them
                            with the necessary skills and knowledge to excel in
                            the data analytics domain.
                          </p>

                          <p>
                            This inclusive approach opens the doors to
                            individuals with different educational backgrounds,
                            allowing them to explore and thrive in the field of
                            data analytics.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading33">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse33"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Can I request
                            for a support session if I need to better understand
                            the topics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse33"
                        className="collapse"
                        aria-labelledby="heading33"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo's commitment to your learning experience
                            extends to providing support sessions whenever you
                            need better clarity on course topics. We offer a{" "}
                            <b>24/7 query resolution service</b>, allowing you
                            to reach out to our dedicated support team at any
                            time. If you encounter questions or challenges, you
                            can avail yourself of our <b>email support</b> to
                            address your queries.
                          </p>

                          <p>
                            In cases where email support may not be sufficient
                            to resolve your concerns, we go a step further by
                            offering <b>one-on-one sessions</b> with our support
                            team. These personalized sessions can provide you
                            with a deeper understanding of the topics you find
                            challenging. It's important to note that the 1:1
                            session support is available for a{" "}
                            <b>period of 6 months</b> from the commencement of
                            your course, ensuring that you have ample
                            opportunities to seek assistance and enhance your
                            comprehension of the course material.
                          </p>

                          <p>
                            At Logicmojo, we are dedicated to supporting your
                            learning journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading34">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse34"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a non it
                            student become data analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse34"
                        className="collapse"
                        aria-labelledby="heading34"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            It's a common misconception that a career in data
                            analytics is exclusively for individuals with a
                            background in information technology or programming.
                            In reality, the data analytics field welcomes a
                            diverse range of professionals, including those
                            without prior IT experience. While some IT
                            professionals do choose to enhance their skills in
                            data analytics, this field offers opportunities to
                            non-IT students as well.
                          </p>

                          <p>
                            Many successful Data Scientists and Data Analysts
                            embarked on their data careers without prior coding
                            knowledge or IT backgrounds. The evolving landscape
                            of data analytics has led to accessible training
                            programs and courses, such as those provided by
                            Logicmojo, enabling non-IT students to acquire the
                            necessary skills and knowledge. These programs equip
                            individuals with the tools and expertise to become
                            proficient Data Analysts, irrespective of their
                            academic background.
                          </p>

                          <p>
                            The doors to a data analytics career are open to all
                            who are willing to learn and excel in this field.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading35">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse35"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are
                            Logimojo-verified certificates awarded?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse35"
                        className="collapse"
                        aria-labelledby="heading35"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Obtaining a Logicmojo verified certificate is a
                            testament to your successful completion of a data
                            analytics course. The certification process is
                            structured to ensure that learners have acquired the
                            necessary skills and knowledge. The awarding of
                            Logicmojo verified certificates involves specific
                            requirements:
                          </p>

                          <ul>
                            <li>
                              <p>
                                <b>Assignment Submissions:</b> Learners are
                                expected to submit mandatory assignments as part
                                of the course. These assignments assess your
                                understanding of course material and practical
                                application of data analytics concepts.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Project Work:</b> Completing project work is
                                an integral component of the certification
                                process. Projects allow learners to apply their
                                skills to real-world scenarios, demonstrating
                                their proficiency.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Quizzes:</b> Successful completion of quizzes
                                within the course is a key requirement. Quizzes
                                help evaluate your grasp of fundamental concepts
                                and principles.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading36">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse36"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What’s the best
                            way to include digital skills on a data analyst CV?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse36"
                        className="collapse"
                        aria-labelledby="heading36"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Highlighting your digital skills on your data
                            analyst CV is essential to make a strong impression
                            on hiring managers. Data analytics often requires
                            specific proficiencies in digital areas. Here are
                            some tips:
                          </p>

                          <ul>
                            <li>
                              <p>
                                <b>Programming Languages:</b> Mention the
                                programming languages you're proficient in, such
                                as Python, R, or Java. These are critical for
                                data manipulation and analysis.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Big Data Analytics:</b> Showcase your
                                knowledge in big data tools and platforms like
                                Hadoop or Spark if you have experience with
                                them. This demonstrates your ability to handle
                                large datasets.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>SQL:</b> Emphasize your expertise in SQL, as
                                it's fundamental for data retrieval and database
                                management.
                              </p>
                            </li>
                          </ul>

                          <p>
                            Your CV should provide concrete examples of projects
                            or tasks where you've applied these skills.
                            Additionally, consider acquiring certifications
                            related to these skills to further bolster your
                            qualifications. It's essential to align your digital
                            skills with the specific requirements of the data
                            analyst role you're applying for to increase your
                            chances of success.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading37">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse37"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How can I get my
                            first data analyst job?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse37"
                        className="collapse"
                        aria-labelledby="heading37"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Getting your first data analyst job can be an
                            exciting but challenging journey. Here are the steps
                            to guide you in landing your initial position:
                          </p>

                          <ol>
                            <li>
                              <p>
                                <b>Foundational Education:</b> Start with a
                                strong educational foundation. You can pursue a
                                relevant degree in fields like statistics,
                                computer science, or Data Analytics. However, many
                                data analysts have non-technical backgrounds, so
                                a degree is not always necessary.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Technical Skills:</b> Develop your technical
                                skills, including data manipulation, statistical
                                analysis, and proficiency in tools like Python,
                                R, and SQL. Online courses and bootcamps can
                                help you acquire these skills.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Real Data Projects:</b> Work on real-world
                                data projects to gain practical experience. This
                                could involve personal projects, internships, or
                                freelance work.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Portfolio Building:</b> Create a portfolio
                                showcasing your best work. This serves as
                                evidence of your abilities to potential
                                employers.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Presentation Skills:</b> Practice presenting
                                your findings clearly and effectively.
                                Communication is a crucial part of the data
                                analyst role.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Entry-Level Job:</b> Apply for entry-level
                                data analyst positions. These roles often
                                require minimal experience and serve as a
                                starting point in your career.
                              </p>
                            </li>

                            <li>
                              <p>
                                <b>Certifications and Advanced Degrees:</b>{" "}
                                Consider pursuing certifications or advanced
                                degrees to further enhance your qualifications
                                and career prospects.
                              </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading38">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse38"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Do you need
                            strong programming skills to be a data analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse38"
                        className="collapse"
                        aria-labelledby="heading38"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            While programming skills are valuable in the field
                            of data analytics, they are not an absolute
                            necessity. The level of programming expertise
                            required can vary based on the specific job and the
                            tools or languages used by an organization.
                          </p>

                          <p>
                            <b>Here are some key points to consider:</b>
                          </p>

                          <ol>
                            <li>
                              <b>Tool Dependence:</b> Many data analysts work
                              with tools and software that offer graphical user
                              interfaces, reducing the need for extensive
                              programming. However, understanding basic
                              scripting and coding can be advantageous.
                            </li>

                            <li>
                              <b>Programming Languages:</b> Proficiency in
                              programming languages like Python and R is highly
                              beneficial, as these are commonly used for data
                              manipulation and analysis.
                            </li>

                            <li>
                              <b>SQL Skills:</b> Familiarity with Structured
                              Query Language (SQL) is often required for working
                              with databases and extracting data.
                            </li>

                            <li>
                              <b>Specializations:</b> Certain data analyst
                              roles, especially those involving big data or
                              machine learning, may demand advanced programming
                              skills.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading39">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse39"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            salary of a data analyst in India?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse39"
                        className="collapse"
                        aria-labelledby="heading39"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            As of 2023, the salary range for data analysts in
                            India varies significantly, depending on factors
                            like experience, location, and the organization. The
                            annual salaries can range from ₹1.7 Lakhs to ₹11.5
                            Lakhs, with an average annual salary of ₹5.6 Lakhs.
                          </p>

                          <p>
                            <b>Here's a breakdown of the salary range:</b>
                          </p>

                          <ul>
                            <li>
                              <b>Entry-Level:</b> Data analysts with limited
                              experience can expect salaries on the lower end of
                              the scale, around ₹1.7 to ₹3.5 Lakhs annually.
                            </li>

                            <li>
                              <b>Mid-Level:</b> Those with a few years of
                              experience typically earn between ₹4 to ₹8 Lakhs
                              per year.
                            </li>

                            <li>
                              <b>Experienced:</b> Data analysts with several
                              years of expertise and advanced skills may command
                              higher salaries, ranging from ₹8 to ₹11.5 Lakhs
                              annually.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading40">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse40"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Miss A
                            Live Session for Data Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse40"
                        className="collapse"
                        aria-labelledby="heading40"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Missing a live session during your Data Analytics
                            Course is not a problem. All sessions are
                            meticulously recorded and made available through
                            Logicmojo's user-friendly Learning Management System
                            (LMS).
                          </p>

                          <p>
                            With this convenient feature, you can access the
                            recorded sessions at your convenience. Whether it's
                            due to a scheduling conflict or any other reason,
                            you won't miss out on valuable course material. This
                            flexibility ensures that you can keep pace with the
                            curriculum and stay up-to-date with the course
                            content.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading41">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse41"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Will I Receive a
                            Course Completion Certificate?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse41"
                        className="collapse"
                        aria-labelledby="heading41"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes! Upon successfully completing the Data Analytics
                            Course, you will be awarded a course completion
                            certificate from Logicmojo.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading42">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse42"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Forget
                            Data Analytics Concepts After Completion?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse42"
                        className="collapse"
                        aria-labelledby="heading42"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We understand that retaining all the course material
                            can be challenging. That's why we've got you
                            covered. All our sessions are recorded, and you'll
                            have lifelong access to our e-learning resources.
                            So, even if you need a refresher or want to revisit
                            any concept, you can do so at your convenience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading43">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse43"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Which company is
                            best for data analyst fresher in India?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse43"
                        className="collapse"
                        aria-labelledby="heading43"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            As of 2023, the field of data analytics in India
                            offers numerous opportunities for freshers, with
                            several top companies actively hiring data analysts.
                            Here are some of the best companies for data analyst
                            freshers:
                          </p>

                          <ul>
                            <li>
                              <b>TCS (Tata Consultancy Services):</b>
                            </li>

                            <li>
                              <b>Infosys:</b>
                            </li>

                            <li>
                              <b>Accenture:</b>
                            </li>

                            <li>
                              <b>Wipro:</b>
                            </li>

                            <li>
                              <b>Genpact:</b>
                            </li>
                          </ul>

                          <p>
                            These companies have a strong presence in India and
                            are recognized for their commitment to nurturing
                            young talent in the data analytics field. Landing a
                            job with one of these companies can be an excellent
                            starting point for a career in data analysis.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading44">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse44"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are
                            assessments and grades handled?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse44"
                        className="collapse"
                        aria-labelledby="heading44"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In Data Analytics courses, assessments and grading
                            methods may vary depending on the specific program
                            and institution. Typically, these courses involve a
                            mix of assignments, projects, and exams to evaluate
                            your understanding and skills. Assignments are
                            designed to test your knowledge of programming
                            languages, SQL skills, and other related topics.
                            Projects often involve creating data insights to
                            showcase your ability to apply what you've learned.
                          </p>
                          <p>
                            Grading criteria can differ from one course to
                            another, but instructors generally assess your
                            performance based on the quality and functionality
                            of your assignments and projects. Some courses may
                            also have exams to test your theoretical knowledge.
                            To succeed in such courses, it's essential to
                            actively participate, complete assignments on time,
                            and seek help when needed.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading45">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse45"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            placement rate for this Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse45"
                        className="collapse"
                        aria-labelledby="heading45"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The placement rate for the Logicmojo Data Analytics
                            course is quite promising. This course equips you
                            with the essential skills and knowledge needed for
                            various roles in the tech industry. It covers a wide
                            range of topics, including Python & R, SQl
                            databases, and more, making you a well-rounded
                            Analyst.
                          </p>
                          <p>
                            Logicmojo places a strong emphasis on practical
                            training, allowing you to work on real-world
                            projects and build a portfolio that demonstrates
                            your capabilities. This hands-on experience can
                            significantly enhance your prospects in the job
                            market, as employers often seek candidates with
                            practical skills.
                          </p>
                          <p>
                            Furthermore, Logicmojo has established industry
                            partnerships, which can open doors to job fairs,
                            internships, and direct job placements with
                            reputable companies. This network can be invaluable
                            in launching your career as a Data Analyst.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading46">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse46"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> I am a working
                            professional, worried that I won't be able to have
                            time?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse46"
                        className="collapse"
                        aria-labelledby="heading46"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Rest assured, the course is designed to accommodate
                            the needs of working professionals. Here's how you
                            can manage your time:
                          </p>

                          <ul>
                            <li>
                              <b>Weekday Access:</b> The program provides access
                              to the Learning Management System (LMS) on
                              weekdays, allowing you to study and complete
                              assignments at your convenience.
                            </li>

                            <li>
                              <b>1-on-1 Mentorship:</b> You'll have the
                              opportunity for one-on-one mentorship sessions,
                              helping you grasp the course content effectively.
                            </li>

                            <li>
                              <b>Weekend Live Sessions:</b> Live sessions are
                              scheduled on weekends, making it easier for
                              working professionals to participate. Even if you
                              can't attend live, recordings of each session will
                              be available within 24 hours for you to review.
                            </li>

                            <li>
                              <b>Personal Learning Coordinator:</b> A personal
                              learning coordinator will be assigned to you. They
                              will monitor your progress, help you stay on track
                              with your assignments, and address any concerns
                              you may have.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading47">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse47"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How long does it
                            take to learn Data Analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse47"
                        className="collapse"
                        aria-labelledby="heading47"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              The time required to learn data analytics is a
                              flexible concept, influenced by various factors
                              such as the complexity of the tasks and your prior
                              experience. Here's a breakdown:
                            </b>
                          </p>

                          <ul>
                            <li>
                              <b>Basic Operations:</b> If you're starting with
                              fundamental tasks like using Excel for data
                              sorting and filtering, you can grasp these
                              essentials within a few hours of dedicated
                              learning.
                            </li>

                            <li>
                              <b>Complex Analyses:</b> However, diving into
                              advanced areas like statistics, machine learning,
                              or natural language processing demands more time.
                              Learning and mastering these complex disciplines
                              can span from several months to a few years,
                              depending on your commitment and prior knowledge.
                            </li>

                            <li>
                              <b>Practice Matters:</b> Rather than fixating on a
                              specific timeframe, focus on the practice. Define
                              the problem you wish to address with data
                              analysis, choose the relevant tools or subjects,
                              and engage in consistent practice. As your
                              proficiency grows, you can gradually advance to
                              more intricate topics.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading48">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse48"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            networking opportunities with potential employers?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse48"
                        className="collapse"
                        aria-labelledby="heading48"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, the Logicmojo Data Analytics course provides
                            valuable networking opportunities with potential
                            employers, enhancing your chances of landing your
                            dream job in the tech industry.
                          </p>
                          <p>
                            Throughout the course, students often have the
                            chance to participate in networking events and job
                            fairs. These events serve as a bridge between
                            learners and prospective employers. They offer a
                            platform for students to showcase their skills,
                            engage in meaningful conversations with industry
                            professionals, and even secure interviews or
                            internships.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading49">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse49"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is an
                            example of data analytics?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse49"
                        className="collapse"
                        aria-labelledby="heading49"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data analytics in manufacturing helps optimize
                            operations. Manufacturing companies collect data on
                            machine runtime, downtime, and work queues. Using
                            data analytics, they can identify bottlenecks and
                            inefficiencies in production. For example, by
                            analyzing this data, a manufacturer might discover
                            that a particular machine consistently experiences
                            downtime due to maintenance delays.
                          </p>
                          <p>
                            They can then address this issue to improve overall
                            productivity and reduce costly delays. This is just
                            one example of how data analytics can be applied to
                            enhance decision-making, efficiency, and
                            profitability in various industries, including
                            manufacturing.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading50">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse50"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there any
                            assistance provided by Logicmojo for resume building
                            and interview preparation for placement?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse50"
                        className="collapse"
                        aria-labelledby="heading50"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, Logicmojo offers valuable support to
                            prepare you for job placement in the Data Analytics
                            field. After successfully completing the course,
                            which typically spans 9 months, you will be
                            well-prepared for interviews. Logicmojo takes your
                            readiness seriously and offers personalized
                            assistance.
                          </p>
                          <p>
                            First, there is a one-on-one resume preparation
                            session to help you create an impactful resume that
                            highlights your skills and accomplishments.
                            Following this, mock interviews are conducted to
                            sharpen your interview skills and build your
                            confidence.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading51">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse51"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take for students to get placed after completing
                            this Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse51"
                        className="collapse"
                        aria-labelledby="heading51"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Typically, the duration for students to secure
                            placements after completing a Data Analytics course
                            varies. It hinges on factors like individual
                            readiness, job market conditions, and the program's
                            support. Generally, it might take a few weeks to
                            several months. Graduates often receive assistance
                            in job search and preparation, which can expedite
                            the process. Logicmojo's Data Analytics course, for
                            instance, provides placement support to help
                            students connect with job opportunities more
                            efficiently.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading52">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse52"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the Logicmojo in ensuring the placement of
                            its students?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse52"
                        className="collapse"
                        aria-labelledby="heading52"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo plays a crucial role in securing
                            placements for its students by offering a
                            comprehensive education and training program. This
                            course is designed to equip students with the skills
                            and knowledge needed to excel in the industry.
                            Moreover, Logicmojo extends support through job
                            placement assistance initiatives. These include
                            resume building sessions, mock interviews, and
                            opportunities for networking. By preparing students
                            not only academically but also professionally,
                            Logicmojo aims to bridge the gap between education
                            and employment, increasing their chances of
                            successful placements.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading53">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse53"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            pursue internships or part-time jobs during the
                            course to enhance their chances of placement?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse53"
                        className="collapse"
                        aria-labelledby="heading53"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, internships play a vital role in enhancing
                            students' placement opportunities in the Data
                            Analytics field. Logicmojo's Data Analytics course
                            actively supports students in securing internships
                            or pre-placement opportunities. These internships
                            offer several benefits, including improved job
                            prospects in Data Analytics, real-world
                            remuneration, expanded professional networks, and
                            valuable insights into the workings of a
                            professional workplace. By encouraging students to
                            engage in internships or part-time roles, Logicmojo
                            empowers them with practical experience and valuable
                            industry exposure, ultimately boosting their chances
                            of successful placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading54">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse54"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            additional certification programs offered along with
                            the Data Analytics course that can help with
                            placement opportunities?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse54"
                        className="collapse"
                        aria-labelledby="heading54"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Many Data Analytics courses offer supplementary
                            certification programs that can significantly boost
                            your placement prospects. Here's how:
                          </p>

                          <b>1. Specialized Certifications:</b>
                          <ul>
                            <li>
                              <i>Advanced Analytics:</i> Courses often include
                              advanced modules with specific certifications like
                              "Machine Learning" or "Big Data Analytics." These
                              certifications demonstrate expertise in
                              high-demand areas.
                            </li>
                            <li>
                              <i>Data Visualization:</i> Specialization in tools
                              like Tableau, Power BI, or D3.js can be certified
                              separately, making you stand out in the field.
                            </li>
                          </ul>

                          <b>2. Professional Associations:</b>
                          <ul>
                            <li>
                              <i>Membership Certificates:</i> Enrolling in a
                              professional data analytics association often
                              grants membership certificates. This affiliation
                              can open networking opportunities with potential
                              employers.
                            </li>
                            <li>
                              <i>Continuing Education:</i> These associations
                              may offer ongoing certification programs, ensuring
                              you stay current with industry trends.
                            </li>
                          </ul>

                          <b>3. Cloud and Database Certification:</b>
                          <ul>
                            <li>
                              <i>Cloud Platforms:</i> Certifications in cloud
                              platforms like AWS or Azure can be beneficial as
                              many organizations migrate to the cloud for data
                              storage and analysis.
                            </li>
                            <li>
                              <i>Database Management:</i> Proficiency in
                              databases like SQL or NoSQL databases can be
                              validated through certifications, highlighting
                              your data handling skills.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading55">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse55"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How can I build
                            a strong portfolio as a Data Analyst?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse55"
                        className="collapse"
                        aria-labelledby="heading55"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A compelling portfolio is vital for a successful
                            career as a Data Analyst. Here's how to build a
                            strong one:
                          </p>

                          <b>1. Diverse Projects:</b>
                          <ul>
                            <li>
                              <i>Include Varied Projects:</i> Showcase projects
                              covering different aspects of data analysis, such
                              as data cleaning, visualization, predictive
                              modeling, and more. This demonstrates versatility.
                            </li>
                            <li>
                              <i>Real-World Data:</i> Utilize real datasets to
                              highlight your ability to handle authentic,
                              complex data scenarios.
                            </li>
                          </ul>

                          <b>2. Clear Documentation:</b>
                          <ul>
                            <li>
                              <i>Project Descriptions:</i> Provide concise
                              explanations of each project's objectives,
                              methodologies, and results. Make it accessible to
                              non-technical stakeholders.
                            </li>
                            <li>
                              <i>Code and Tools:</i> Share your code on
                              platforms like GitHub, ensuring it's
                              well-documented for others to understand and
                              replicate.
                            </li>
                          </ul>

                          <b>3. Data Visualization:</b>
                          <ul>
                            <li>
                              <i>Effective Visuals:</i> Create compelling data
                              visualizations to convey insights. Employ tools
                              like Tableau, Power BI, or Python libraries like
                              Matplotlib and Seaborn.
                            </li>
                            <li>
                              <i>Narrative:</i> Weave a narrative into your
                              visualizations, explaining the story your data
                              tells and the actionable insights.
                            </li>
                          </ul>

                          <b>4. Problem-Solving:</b>
                          <ul>
                            <li>
                              <i>Emphasize Problem Solving:</i> Highlight how
                              your analyses solved real-world problems or
                              improved decision-making processes.
                            </li>
                            <li>
                              <i>Quantify Impact:</i> Whenever possible,
                              quantify the impact of your work, such as
                              increased revenue or cost savings.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading56">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse56"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            alumni of this Data Analytics course who have
                            successfully been placed in reputed companies?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse56"
                        className="collapse"
                        aria-labelledby="heading56"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            {" "}
                            Many alumni of the Data Analytics course at
                            Logicmojo have gone on to secure positions in
                            renowned companies across the tech industry. Here's
                            how you can explore their success stories:
                          </p>
                          <ul>
                            <li>
                              <b>Connect with Logicmojo:</b> Logicmojo can
                              provide you with information about alumni who have
                              excelled in their careers after completing the
                              course. They can connect you with these
                              accomplished professionals.
                            </li>
                            <li>
                              <b>Alumni Insights:</b> Reach out to alumni
                              directly to gain insights into their experiences.
                              They can share valuable information about their
                              journey, job search, and how the course prepared
                              them for success.
                            </li>
                            <li>
                              <b>Online Research:</b> Utilize online resources
                              and social media platforms to discover alumni
                              achievements. Many former students share their
                              career trajectories on LinkedIn, showcasing the
                              impact of their Data Analytics training.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading57">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse57"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Can I switch
                            careers after completing this course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse57"
                        className="collapse"
                        aria-labelledby="heading57"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, completing a Data Analytics course can serve as
                            a catalyst for a career transition. In today's
                            dynamic job market, data analytics skills are in
                            high demand across various industries. Here's how
                            you can make a successful career switch:
                          </p>

                          <b>1. Skill Diversification:</b>
                          <ul>
                            <li>
                              <i>Explore New Horizons:</i> Data analytics equips
                              you with versatile skills applicable in fields
                              like finance, healthcare, marketing, and more.
                              Consider the industries that align with your
                              interests.
                            </li>
                            <li>
                              <i>Acquire Complementary Skills:</i> Depending on
                              your target industry, consider gaining
                              complementary skills. For example, healthcare
                              analytics may require knowledge of medical data.
                            </li>
                          </ul>

                          <b>2. Networking:</b>
                          <ul>
                            <li>
                              <i>Connect with Peers:</i> Join professional
                              networks, attend industry events, and engage with
                              experts to expand your connections in your desired
                              field.
                            </li>
                            <li>
                              <i>Informational Interviews:</i> Conduct
                              informational interviews with professionals in
                              your target industry. Learn about their career
                              transitions and seek advice.
                            </li>
                          </ul>

                          <b>3. Tailored Applications:</b>
                          <ul>
                            <li>
                              <i>Customize Your Resume:</i> Adapt your resume
                              and cover letter to highlight your data analytics
                              skills and their relevance to the new career path.
                            </li>
                            <li>
                              <i>Showcase Relevant Projects:</i> Emphasize
                              projects from your course that demonstrate your
                              ability to solve problems and make data-driven
                              decisions.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading58">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse58"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            success rate of students getting placed in their
                            preferred companies and domains after completing the
                            Logicmojo Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse58"
                        className="collapse"
                        aria-labelledby="heading58"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Assessing the success rate of students getting
                            placed in their preferred companies and domains
                            after completing this course involves multiple
                            factors. The primary determinants include:
                          </p>
                          <ul>
                            <li>
                              <b>Skills and Proficiency:</b> The extent to which
                              students have mastered all concepts and
                              technologies related to Data Analytics.
                            </li>
                            <li>
                              <b>Portfolio:</b> The quality and diversity of
                              projects in a student's portfolio play a
                              significant role in attracting prospective
                              employers.
                            </li>
                            <li>
                              <b>Networking:</b> Active engagement with peers,
                              mentors, and industry professionals can open doors
                              to job opportunities.
                            </li>
                            <li>
                              <b>Resume Building:</b> Effective resume
                              preparation and interview readiness also influence
                              placement success.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading59">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse59"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            pay after placement-related policies or agreements
                            that students should be aware of before enrolling in
                            the Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse59"
                        className="collapse"
                        aria-labelledby="heading59"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            No, our Data Analytics course does not have schemes
                            such as "Pay After Placement." Upon enrollment with
                            a one-time payment, the Data analytics curriculum
                            begins. After completing the course, the placement
                            process will commence. We do not have any additional
                            placement-related policies or agreements that
                            students need to be aware of before joining our
                            program.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading60">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse60"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Until when will
                            the Logicmojo students get the facility of
                            mentorship?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse60"
                        className="collapse"
                        aria-labelledby="heading60"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Course provides mentorship throughout the
                            program, with mentors specializing in relevant
                            subjects. Upon course completion, students can
                            continue to benefit from mentor support for projects
                            and job placement. This ongoing mentorship ensures
                            that students receive guidance and assistance beyond
                            the classroom, helping them apply their skills
                            effectively in real-world scenarios and facilitating
                            their transition into the job market.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading61">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse61"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a student
                            choose to study from their desired mentor?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse61"
                        className="collapse"
                        aria-labelledby="heading61"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, we understand that a strong
                            mentor-student relationship is essential for
                            effective learning. While each batch is assigned a
                            dedicated mentor, we recognize that students may
                            have unique preferences. If a student finds that
                            their assigned mentor doesn't align with their
                            learning style or needs, they have the option to
                            raise the concern with our management. We are
                            committed to ensuring a positive and productive
                            learning experience, and in such cases, we will work
                            to provide alternative mentorship options that
                            better suit the student's requirements.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading62">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse62"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            experience level of the mentors teaching the Data
                            Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse62"
                        className="collapse"
                        aria-labelledby="heading62"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Data Analytics Course is led by mentors with
                            extensive industry experience, ensuring that
                            students receive top-notch guidance. Our instructors
                            possess in-depth knowledge and hands-on expertise in
                            the field of Data Analytics. With backgrounds as
                            seasoned professionals and consultants, they bring
                            real-world data insights to the classroom. Their
                            wealth of experience equips students with practical
                            skills and industry-relevant knowledge, enabling
                            them to excel in their Data journey. We are
                            committed to providing the best learning experience
                            by offering mentorship from experts who can guide
                            and inspire our students to achieve their goals.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading63">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse63"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors will be assigned to each student during the
                            course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse63"
                        className="collapse"
                        aria-labelledby="heading63"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            During our course, typically one dedicated
                            instructor is assigned to each batch. However, we
                            prioritize adaptability and can schedule multiple
                            trainers based on specific requirements and
                            preferences. Our primary aim is to provide
                            top-quality training through effective teaching
                            methods. Ensuring that students receive the
                            necessary attention and support is our utmost
                            priority. If students have particular needs or
                            preferences, we encourage open communication through
                            Slack, and we are ready to tailor our approach to
                            meet those needs promptly.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading64">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse64"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support can students expect from their mentors
                            during the course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse64"
                        className="collapse"
                        aria-labelledby="heading64"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In this Course, students can anticipate
                            comprehensive support from their mentors throughout
                            the program. Alongside regular live classes, our
                            mentors are available to assist students with any
                            Data Analytics inquiries via a dedicated Slack channel
                            at any time. We acknowledge that questions may arise
                            unexpectedly, and our commitment is to ensure
                            students receive timely guidance. Additionally, we
                            schedule dedicated live doubt sessions during
                            weekdays after office hours, catering to the needs
                            of working professionals. Our primary objective is
                            to empower our students to thrive in their Data
                            Analyst journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading65">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse65"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the mentors
                            available for one-on-one sessions outside of the
                            regular class schedule ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse65"
                        className="collapse"
                        aria-labelledby="heading65"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, in Data Analytics Course, mentors are readily
                            available for one-on-one sessions beyond the
                            standard class schedule. We recognize that students
                            may have specific queries or require additional
                            assistance, and we prioritize meeting their
                            individual needs. Students can easily arrange
                            one-on-one sessions with their assigned mentor at a
                            mutually convenient time. Our mentors are dedicated
                            to supporting students in their journey to success
                            and are committed to addressing any concerns or
                            questions they may have outside of regular class
                            hours.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading66">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse66"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Will students
                            have access to mentors even after completing the
                            Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse66"
                        className="collapse"
                        aria-labelledby="heading66"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our course, which spans over 9 months, students
                            continue to have access to our dedicated mentors
                            even after they have successfully completed the
                            program. Our mentors are readily available to assist
                            students with any queries or challenges they may
                            encounter. Students can easily reach out to mentors
                            through the communication platform Slack, where
                            direct messaging is possible. For urgent matters or
                            those requiring a more in-depth discussion, students
                            also have the option to schedule a one-on-one call
                            with their respective trainers. We understand the
                            value of ongoing support, and our mentors are
                            committed to providing it to our students.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading67">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse67"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            class size for the Data Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse67"
                        className="collapse"
                        aria-labelledby="heading67"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The class size for our Course can vary from batch to
                            batch, depending on the number of enrolled students.
                            However, our primary focus is on catering to the
                            needs of working professionals. We understand that
                            our students have busy schedules, and as a result,
                            we offer flexible learning options to accommodate
                            their requirements. Our commitment is to provide
                            high-quality training that is not only
                            industry-relevant but also empowers our students to
                            advance in their careers. We believe in delivering
                            education that aligns with the dynamic demands of
                            the technology sector.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading68">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse68"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How frequently
                            are Data Analytics Course classes conducted?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse68"
                        className="collapse"
                        aria-labelledby="heading68"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Data Analytics Course is designed to accommodate
                            the diverse schedules of our students. We offer both
                            weekend and weekday classes, catering to your
                            availability. Our weekend sessions are
                            comprehensive, with each class spanning 180 minutes,
                            while our weekday sessions are condensed to 120
                            minutes. This flexibility ensures that you can
                            choose the course timing that best suits your
                            lifestyle and commitments, making it easier for you
                            to pursue your Data Analyst education without
                            compromising on your other responsibilities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading69">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse69"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I switch
                            from self-paced training to instructor-led training
                            in the Data Analytics Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse69"
                        className="collapse"
                        aria-labelledby="heading69"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, transitioning from self-paced training
                            to online instructor-led training is seamless. You
                            can make the switch by simply covering the
                            additional cost. Once you've decided to switch,
                            you'll be able to join the upcoming instructor-led
                            batch, and we'll ensure you receive timely
                            notifications about it. This flexibility allows you
                            to adapt your learning style to your evolving needs
                            and preferences, ensuring that you have the best
                            possible experience in our Course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading70">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse70"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is peer
                            interaction and project collaboration encouraged
                            during the Data Analytics course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse70"
                        className="collapse"
                        aria-labelledby="heading70"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, collaboration and peer interaction are
                            highly encouraged in our Course. We believe that
                            learning is enhanced when students work together and
                            share ideas. Throughout the course, students have
                            opportunities to:
                          </p>
                          <ul>
                            <li>
                              Collaborate on group projects, fostering teamwork
                              and practical experience.
                            </li>
                            <li>
                              Participate in discussion forums and Slack
                              communities for knowledge sharing.
                            </li>
                            <li>
                              Engage in peer code reviews to improve coding
                              skills and gain diverse perspectives.
                            </li>
                            <li>
                              Attend live online classes to interact with
                              instructors and fellow learners.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading71">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse71"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How is the
                            feedback system structured for students to offer
                            input on mentors and the course curriculum?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse71"
                        className="collapse"
                        aria-labelledby="heading71"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Course, we prioritize student feedback as an
                            integral part of continuous improvement. We have
                            established a comprehensive feedback system that
                            encourages students to provide their insights on
                            both mentors and the course curriculum. This system
                            typically includes:
                          </p>
                          <ul>
                            <li>
                              Regular surveys and evaluations to gather opinions
                              on mentors' performance and effectiveness.
                            </li>
                            <li>
                              Channels for students to express thoughts on the
                              course content, structure, and materials.
                            </li>
                            <li>
                              Anonymity options to ensure candid feedback.
                            </li>
                            <li>
                              A responsive approach to addressing concerns and
                              implementing suggested improvements.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading007">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse007"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support we will get in this Course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse007"
                        className="collapse"
                        aria-labelledby="heading007"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our comprehensive Data Analytics Course, you can
                            expect robust support mechanisms designed to enhance
                            your learning experience. These include:
                          </p>
                          <ul>
                            <li>
                              Access to a rich repository of course materials.
                            </li>
                            <li>
                              Participation in live online classes to engage
                              with instructors and peers.
                            </li>
                            <li>
                              Access to discussion forums for collaborative
                              learning and query resolution.
                            </li>
                            <li>
                              Opportunities for peer-to-peer learning, fostering
                              a sense of community and knowledge sharing.
                            </li>
                            <li>
                              Personalized feedback and guidance from
                              experienced trainers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading017">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse017"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How can I
                            access the course materials of Data Analytics
                            Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse017"
                        className="collapse"
                        aria-labelledby="heading017"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To access the course materials for Data Analytics,
                            the course provider utilizes a user-friendly
                            platform, Slack. Within this platform, they share a
                            wealth of valuable resources, including class
                            recordings, assignments, and course materials. These
                            materials are readily available for download by all
                            course participants, fostering a flexible and
                            accessible learning environment. This approach
                            allows students to refer to the course content at
                            their own convenience and pace, ensuring that they
                            can make the most of their learning experience.
                            Additionally, Slack serves as a centralized hub for
                            course-related communication and resource sharing,
                            enhancing the overall educational experience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading027">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse027"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Analytics course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse027"
                        className="collapse"
                        aria-labelledby="heading027"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In the context of the Data Analytics Course, a Flexi
                            Subscription offers valuable flexibility to
                            students. It acknowledges that life can sometimes
                            bring unexpected challenges, such as medical
                            emergencies, work demands, or on-site job
                            opportunities. In such situations, students have the
                            option to switch to another course batch without
                            incurring any penalties. This means they can
                            temporarily pause their current batch and seamlessly
                            resume their learning journey when they are ready.
                            This accommodating feature ensures that students can
                            adapt to changing circumstances while pursuing their
                            education in Data Analyst.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading037">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse037"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there a
                            discussion forum for the course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse037"
                        className="collapse"
                        aria-labelledby="heading037"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Logicmojo employs a dedicated Slack channel for
                            seamless communication and collaboration among
                            course participants. This Slack community serves as
                            an interactive forum where users can readily connect
                            with their peers to seek assistance and address
                            queries related to the Data Analytics Course. It
                            offers a platform for engaging discussions, sharing
                            insights, and fostering a sense of community among
                            learners, enhancing the overall learning experience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="supportbgnew">
        <div className="container">
          <h2>24/7 Learner’s Support</h2>
          <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img">
              <img src="assets/images/supportimg.png" alt="" />
            </div>
            <div className="supportbgnew-inner-content">
              <h4>Got more questions?</h4>
              <h2>Talk to our team directly</h2>
              <p>
                Reach us and a learning consultant will get in touch with you
                shortly
              </p>
              <a href="">
                <i className="fa fa-whatsapp"></i> Enquire now
              </a>
              <a href="" style={{ background: "#1a64c0" }}>
                <i className="fa fa-whatsapp"></i> +91 80889-75867
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footerai">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <p>
                <img src="assets/images/logo.png" alt="" />
              </p>
              <p>
                Enrol Now For Data Analytics Course, System Designing Or Full
                Stack Development Courses. Master The Most Demanding Skills Of
                Job Market And Experience And Ever Growing And Lucrative Career
                Transformation.
              </p>
              <p>
                <a href="mailto:info@logicmojo.com">
                  <i className="fa fa-envelope-o"></i> info@logicmojo.com
                </a>
              </p>
              <p>
                <a href="tel:+91 80889-75867">
                  <i className="fa fa-phone"></i> +91 80889-75867
                </a>
              </p>
            </div>
            {
              <div className="col-md-6 col-lg-4">
                <h3>Courses</h3>
                <p>
                  <Link to="/Introduction-to-Data-Analytics">
                    Advance Data Analytics & AI Program
                  </Link>
                </p>
                <p>
                  <Link to="/Advance-Data-Science-ML-Program">
                    Advance AI & ML Program
                  </Link>
                </p>
                <p>
                  <Link to="/Master-data-Science-ai-program">
                    Master Degree Program For Data Analytics & AI
                  </Link>
                </p>
                <p>
                  <Link to="/AI-Fundamental-for-Non-Data-Scientist">
                    AI Fundamental for Non Data Scientist
                  </Link>
                </p>
                <p>
                  <Link to="/Data-Science-Course-For-Managers">
                    Data Analytics Course For Managers
                  </Link>
                </p>
                <p>
                  <Link to="/Post-Graduate-Program-For-Data-Science">
                    Post Graduate Program For Data Analytics
                  </Link>
                </p>
                <p>
                  <Link to="/Basics-Introduction-to-Data-Science">
                    Basic Introduction to Data Analytics
                  </Link>
                </p>
                <p>
                  <Link to="/Introduction-to-Data-Analytics">
                    Introduction to Data Analytics
                  </Link>
                </p>
                <p>
                  <Link to="/Applied-Data-Science-with-Python">
                    Applied Data Analytics with Python
                  </Link>
                </p>
              </div>
            }
            <div className="col-md-6 col-lg-2">
              <h3>Logicmojo</h3>
              <p>
                <a href="https://logicmojo.com/about_us">About Us</a>
              </p>

              <p>
                <a href="https://logicmojo.com/blog">Blogs</a>
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Terms</h3>
              <p>
                <a href="https://logicmojo.com/terms_condition">
                  Terms and Conditions
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/refund_policy">
                  Refund/Cancellation policy
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/privacy_policy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h3>Project Innovation Lab Address</h3>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Pune</h3>
              <p>
                Sky Loft Group Floor, Creaticity Mall, Opposite Golf Course,
                Airport Rd, Shastrinagar, Yerawada, Pune, Maharashtra 411006
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Mumbai</h3>
              <p>
                Business Centre, 3rd Floor, vinkat House, Dinshaw Vacha Road,
                Churchgate, Mumbai, Maharashtra 400020
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Delhi</h3>
              <p>
                Business Centre Park, Arunachal Building, 8th Floor, Barakhamba
                Road, New Delhi 110001
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Kolkata</h3>
              <p>
                Ambuja Neotia EcoCentre 5th Floor, EM-4,EM-Block, Sector 6
                Kolkata 700091
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Hyderabad</h3>
              <p>
                NSL Centrum, Road No 1, Lane, Opp. Forum Mall Central Hub, KPHB
                4th Phase, Hyderabad, Telangana 500072
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Bangalore</h3>
              <p>
                #23, Above Veena Mobiles, 14th Main Road, Opp-White House,
                Sector 2, Hsr Layout, Bangalore 560102
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Chennai</h3>
              <p>
                Cessanana Business Centre, Phone Booth, 3rd Floor, 39/12 Haddows
                Road, Nungambakkam, Chennai 600 006
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            {/* <div className='col-md-6 col-lg-3'>
                <h3>Bangalore</h3>
                <p><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Machine Learning Course Training In Bangalore</a></p>
                <p><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Business Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Bangalore</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Bangalore</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Hyderabad</h3>
                <p><Link to="/Data-Science-Course-Hydrabad">Data Analytics Course Training In Hyderabad</Link></p>
                <p><a href="#">Machine Learning Course Training In Hyderabad</a></p>
                <p><a href="#">Data Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Business Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Hyderabad</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Hyderabad</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Dubai</h3>
                <p><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p><a href="#">Machine Learning Course Training In Dubai</a></p>
                <p><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p><a href="#">Business Analytics Course Training In Dubai</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Dubai</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Dubai</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Delhi</h3>
                <p><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p><a href="#">Machine Learning Course Training In Delhi</a></p>
                <p><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p><a href="#">Business Analytics Course Training In Delhi</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Delhi</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Delhi</a></p>
            </div> */}
          </div>

          <hr />

          <div className="row">
            <div className="col-lg-12">
              <p className="m-0">© 2023 LOGICMOJO. ALL RIGHTS RESERVED</p>
            </div>
          </div>
        </div>
      </div>
      <div className="modal" id="welcomepopup">
        <div className="modal-header">
          <p>
            <span className="yallowbox">Data Analytics Classes </span>
          </p>
          <button type="button" className="close" data-dismiss="modal">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p>
          Data Analytics &amp; AI Course
            <br />
            <b>
              <p style={{ textDecoration: "underline", color: "#007bff" }}>
                (Duration: 8 months)
              </p>
            </b>
          </p>

          <div className="modal-body">
            <p>Weekend Batch : 9 AM - 12 PM (IST)</p>
          </div>

          <div className="modal-footer">
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
              className="btn btn-primary"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div>
      </div>
      <div class="footerstrip-formob">
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="https://download.cnet.com/a/img/resize/c1337f10fcaf26f6843e014f4f63e6b88c02af83/catalog/2016/05/11/93d7eae4-8cab-4e76-b4e4-dd932d302bf3/imgingest-8323235902858999630.png?auto=webp&amp;fit=crop&amp;width=64"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
        >
          Call Back{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div class="footerstrip">
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-08"
        >
          <span>
            <i class="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i class="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i class="fa fa-question-circle" aria-hidden="true"></i> Any query
            related to live classes
          </span>
        </a>
      </div>
    </div>
  );
}

export default Home;
